import React, { useEffect, useState } from "react";
import FormleftNev from "../../../components/common/FormleftNev"
import FormnavBar from "../../../components/common/wizard_navbar";
import Lang from "../../../lang";
import TlkTable from "../../../components/tlelrik/table/tlkTable";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Switch } from "@progress/kendo-react-inputs";
import { Tooltip } from "antd";
import { Button } from "@progress/kendo-react-buttons";
import { Input } from "@progress/kendo-react-inputs";
import queryString from "query-string";
import services from "../../../services";
import { insertItem, getItems, updateItem, deleteItem , dataGet} from "./Grid1/services";
import { insertItem2, getItems2, updateItem2, deleteItem2 , dataGet2 } from "./Grid2/services2";
import { insertItem3, getItems3, updateItem3, deleteItem3 , dataGet3 } from "./Grid3/services3";
import { insertItem4, getItems4, updateItem4, deleteItem4 , dataGet4} from "./Grid4/services4";
import { insertItem5, getItems5, updateItem5, deleteItem5 , dataGet5} from "./Grid5/services5";
import { insertItem6, getItems6, updateItem6, deleteItem6 , dataGet6} from "./Grid6/services6";

import {dataGet9} from "./Grid9/services9";
import {dataGet10} from "./Grid10/services10";
import {dataGet11} from "./Grid11/services11";
import {dataGet13} from "./Grid13/services13";

import { getItems7 , dataGet7} from "./Grid7/services7";
import { getItems8 , dataGet8} from "./Grid8/services8";
import LocationFunction from '../../../components/common/LocationFunction.jsx';
import { toast } from "react-toastify";
import $ from "jquery";
import jsPDF from "jspdf";
import "@patternfly/react-core/dist/styles/base.css";
import { DualListSelector } from '@patternfly/react-core';
import CurrencyInput from 'react-currency-input-field';
import FiscalizacaoClassCreateGrid from './FiscalizacaoClassCreateGrid'
// import classGrid from './ClassGrid'
import { DropDownList } from '@progress/kendo-react-dropdowns';
import SelosGarantia from './mySelosGarantia'
import DropDownCellTipoVasilha from './myDropDownCellTipoVasilha';
import DropDownCellNVasilha from './myDropDownCellNVasilha';
import DropDownCellCapacidades from './myDropDownCellCapacidades';
import DropDownCellProduto from './myDropDownCellProduto'; 
import SelectCellEtiquetas from './mySelectCellEtiquetas';
import SelectCellSelos from './mySelectCellSelos';
import FiscalizacaoGrid, {changeColumnsFiscalizacaoGrid,changeValueSelect} from './Grid1/ClassGrid';
import FiscalizacaoGrid2, {changeColumnsFiscalizacaoGrid2,changeValueSelect2} from './Grid2/ClassGrid2';
import FiscalizacaoGrid3, {changeColumnsFiscalizacaoGrid3,changeValueSelect3} from './Grid3/ClassGrid3';
import FiscalizacaoGrid4, {changeColumnsFiscalizacaoGrid4,changeValueSelect4} from './Grid4/ClassGrid4';
import FiscalizacaoGrid5, {changeColumnsFiscalizacaoGrid5,changeValueSelect5} from './Grid5/ClassGrid5';
import FiscalizacaoGrid6, {changeColumnsFiscalizacaoGrid6,changeValueSelect6} from './Grid6/ClassGrid6';
import { NumericCell } from './NumericText';
import { Grid, GridColumn as Column, GridToolbar } from "@progress/kendo-react-grid";
import Inserirvasilha from "./Inserirvasilha";
import SelectReact from 'react-select';
import { Select } from 'antd';
import AsyncSelect from 'react-select/async';
// import { ColourOption, colourOptions } from '../data';
import AssinaturaManuscritoDialog from "../../../components/AssinaturaManuscrito/assinatura-manuscrito";
import { createFalse, parseConfigFileTextToJson } from "typescript";
import ClassGrid7 from "./Grid7/ClassGrid7";
import SelectCellSelosGarantia from "./mySelectCellSelosGarantia";
import Detalhes from "../selos/graphicasPopup/Detalhes";
import Swal from "sweetalert2";
import SelectCellEtiquetasSelagem from "./mySelectCellEtiquetasSelagem";
import SelectCellSelosSelagem from "./mySelectCellSelosSelagem";
import ClassGrid from "./Grid1/ClassGrid";
var chosenFiscais = []
var arrayGeral = [];
var arrayGeralDet = [];
const { Option } = Select
var thisAssinatura = null
var FiscaisChosen = []
//import lang from "../../../lang";
//import LabelTabel from "./LabelTable.jsx";
var moment = require("moment");

var thisFiscalizacaohandle = this;
var indexBotaoCalculator = 0
var EntidadeArray = 0;

var optionsEntidade = [];

const editField = "inEdit";
var idAutoOrigemDesselagem = null;
var thisSetStateData = null;
var  dadosDaGrid= {}
var thisStateData = null;

var DropDownDisableValue = true;

var idDropDownSelected = null;

var DropDownDisableArray = [];

var idDropDownDisableArray = 0;

var ThisDropDownDisable = null;

var DualListSelectorNotSelected = [];

var DualListSelectorSelected = [];
var otherThis;
var FamilyOption = [];
var inputbutton = 0
let parsed = queryString.parse(window.location.search);
var idAutoQuery = parsed.idAuto
var DesselagemQuery = parsed.Desselagem
var DetalhesGuardados;
var IdButtonClicked;
const dateFormat = "YYYY-MM-DD";
const dateShowFormat = "dd/MM/yyyy";
var indexAssinatura = 0
let imageObj =
    "data:image/png;base64,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";

export const InputFieldsAll = {
        FiltrosFiscalizacao: [],
        // DadosPart: [],
        DetAuto: [],
        DadosFiscalizacao: [],
        //ParecerFiscalizacao: [],
        FiscaisAuto: [],
        ReconhecimentoFiscalizacao: [],
      };
export const InputFieldsAllParecer = {
    FiltrosFiscalizacao: [],
    // DadosPart: [],
    DetAuto: [],
    DadosFiscalizacao: [],
    ParecerFiscalizacao: [],
    FiscaisAuto: [],
    ReconhecimentoFiscalizacao: [],
};
export var test = InputFieldsAll.ParecerFiscalizacao;

const columnKeyMap = {
    numeroPedido: "Número de Pedido",
    numeroRegistoOrigem: "Número Registo Origem",
    numeroRegistoDestino: "Número Registo Destino",
    correlativas: "Correlativas"
}

var columnsGrid = [];
var setProgressAgente ;
var InstalacoesVinicasEntidade = null;

var SelectEntidadeActive = false;
var SelectVinicaAutoActive = false;

const SelectWrapper = ({ inputRef, onChange, ...otherProps }) => {

    const handleChange = (e) => {

        changeValueSelect(e);
        if(e.value){
            SelectEntidadeActive = true;
        }else{
            SelectEntidadeActive = false;
        }
        
        if(SelectVinicaAutoActive && SelectEntidadeActive){
            $('.botaoAdicionarNovoEnable').removeClass('disabled');
        }else{
            $('.botaoAdicionarNovoEnable').addClass('disabled');
        }

        InstalacoesVinicasEntidade = e.value;

        (async () => { 

            var strHTML = "<option value='0' selected>Selecione...</option>";
            const dataInstalacaoVinica = {"CodEntidade" : InstalacoesVinicasEntidade}
            const InstalacaoVinica = await services.apiCall.requestApi(
            "/InstalacaoVinica/ViewInstalacoesVinicasEntidade",
            dataInstalacaoVinica,
            "get"
            );

            if(InstalacaoVinica.length>0){

                InstalacaoVinica.map((InstalacaoVinica) => (
                    strHTML = strHTML + "<option value='" + InstalacaoVinica.idInstalacaoVinica + "!" + InstalacaoVinica.codEntidade +  "'>" + InstalacaoVinica.instalacaoVinica + "</option>"
                ));

            }
            $("#instal_vinica_auto").html(strHTML);

        })();

    };

    return (

        <SelectReact id="id-select-Entidade" 
        name="form-field-name"
        options={optionsEntidade} 
        isSearchable={true} 
        placeholder="Selecione..."
        onChange={handleChange} {...otherProps}
        />

    );
};

var isComponentVisible =  false;
/* to open vasilha form popup */
const combolistrequest = {
    "Filters": null,
    "SortBy": "",
    "IsSortTypeDESC": true,
    "IsPagination": false,
    "Page": 2,
    "PageSize": 2
};
class InserirFiscalizacao extends React.Component {

    static changeValueButton = (value) => {
       
        SelectEntidadeActive = value;
        SelectVinicaAutoActive = value;

        $('.botaoAdicionarNovoEnable').removeClass('disabled');
    } 
    

    constructor(props) {
        super(props);

        this.state = {
            motivoAuto: 0,
            detailPopUp: "",
            tipoOptionList: {},
            //isComponentVisible: false ,
            availableOptions: [],
            chosenOptions: [],
            certProcIVDest: [],
            finalDataArray: [],
            Family: [],
            show: false,
            isRemarkSet: false,
            mandatoryMissing: false,
            headName: " Gestão de Autos",
            selectedValueDropDownOrigem: '',
            sendData: {
                processomento: {
                    pmentos: [],
                },
                processo: {
                    bib: false,
                    seloIncorporado: false,
                    logo: false,
                    macrapropria: false,
                },
                Dataatual: new Date(),
                Ultimaobservacao: "",
                aprovodo: true,
            },
            // readOnly : false,
            readOnly: true,
            parsed: {},
            telkikTable: "",
            entityGrid: "",
            tituloList: [],
            processoTelkikTable: "",
            resData: {},
            registoData: {},
            filterData: [
                {
                    "Nº Registo": "a",
                    Produto: "a",
                    Cor: "a",
                    Álcool: "a",
                    Tipo: "a",
                    Ano: "a",
                    Doçura: "a",
                    "Acidez (%)": "a",
                    "Saldo Incial (Lts)": "a",
                    Madeira: "a",
                    "Velor energetico": "Velor energetico",
                    Carbohydratos: "Carbohydratos",
                    Proteinas: "Proteinas",
                    "Fibra Elimentor": "Fibra Elimentor",
                    Sodio: "Sodio",
                    "Rotulus aprovados": "xxxxx",
                },
            ],
            nullProcess: true,
            openItem: false,
            Represent: false,
            Agente: false,
            AgenteOutro: false,
            FiscalPrincipal: false,
            validado:false,
            Detalhes: [],
            Detalhes1: []
        };
        this.onListChange = (newAvailableOptions, newChosenOptions) => {
            var firstFiscal = []

            this.setState({
              availableOptions: newAvailableOptions.sort(),
              chosenOptions: newChosenOptions.sort()
            });
            chosenFiscais =newChosenOptions.sort()
            console.log("LENG DO CHOSE", chosenFiscais.length)
            firstFiscal = newChosenOptions
            console.log("FIRST FISCAL" , firstFiscal)
           if(firstFiscal.length > 0){
          
            console.log("LENG DO CHOSE OPcenas", firstFiscal[0].props.value)
            var idFiscais = firstFiscal[0].props.children
            if(chosenFiscais.length != 0){
                var idFiscaisval = chosenFiscais[0].props.value;
            }
            $("#Fisc_Princ_fisc").text(idFiscaisval)
            $("#Fisc_Princ_fisc").val(idFiscais)
            
           }  else{
            $("#Fisc_Princ_fisc").text("")
            $("#Fisc_Princ_fisc").val("")
           }       
        };
        this.filterOption = (newAvailableOptions, input) =>
        newAvailableOptions.props.children.toUpperCase().includes(input.toUpperCase());
    }
    toggleComponent = () => {
        this.setState({ 
            openItem : !this.state.openItem ,
            Represent: false,
            Agente: false,
            AgenteOutro: true,
            FiscalPrincipal: false
        }); 
    } 
    toggleComponentAgente = () => {

        var parsed = queryString.parse(window.location.search);

        var estadoQuery = parsed.codEstado

        if(estadoQuery == null || estadoQuery != '3'){

            this.setState({ 
                openItem : !this.state.openItem ,
                Represent: false,
                Agente: true,
                AgenteOutro: false,
                FiscalPrincipal: false
            }); 

        }

    } 
    toggleComponentRepres = () => {

        var parsed = queryString.parse(window.location.search);

        var estadoQuery = parsed.codEstado

        if(estadoQuery == null || estadoQuery != '3'){

            this.setState({ 
                openItem : !this.state.openItem,
                Represent: true,
                Agente: false,
                AgenteOutro: false,
                FiscalPrincipal: false
            }); 
        }

    }

    toggleComponentFisc = () => {

        var Princfisc = $('#Fisc_Princ_fisc').val();

        var parsed = queryString.parse(window.location.search);

        var estadoQuery = parsed.codEstado

        if(estadoQuery == null || estadoQuery != '3'){

            this.setState({ 
                openItem : Princfisc != '' ? !this.state.openItem : false,
                Represent: false,
                Agente: false,
                AgenteOutro: false,
                FiscalPrincipal: true
            }); 
            
        }
    }

    handleSave = async () => {
        // var codEstadoAprovacao;
        // let parsed = queryString.parse(window.location.search);
        // if(this.state.sendData.aprovodo == true){
        //     codEstadoAprovacao = 2
        // }else{
        //     codEstadoAprovacao = 3
        // }
        // console.log(
        //     "save",
        //     parsed.idPedidoTransferencia ,
        //     this.state.sendData.Ultimaobservacao,
        //     codEstadoAprovacao,
        //     window.localStorage.getItem('username')
        // )
        // let data = {
        //     idPedidoTransferencia: parseInt(parsed.idPedidoTransferencia),
        //     observacoes: this.state.sendData.Ultimaobservacao,
        //     codEstado: codEstadoAprovacao,
        //     LoggedUser: window.localStorage.getItem('username')
        // };
        // console.log(data , "dados no submit")
        // let res = await services.apiCall.requestApi(
        //     "Rotulos/AprovarTransferencias",
        //     data,
        //     "post"
        // );
        // if (res) {
        //     this.redirectScreen();
        // }
    };
    redirectScreen2 = () => {
        const queryParams = queryString.parse(this.props.location.search)
        var idAuto = 0;
            if(queryParams["idAuto"] !== undefined){
                idAuto = queryParams["idAuto"];

        }
        window.location.href = `/revenue_criacao?&idAuto=${idAuto}`
    }
    
    

    handleMelhoria = e => {
       if(e.target.checked == true && e.target.value == "optionParecerCheckNA"){
        $("#MelhoriaReceita").removeClass("d-none");
       }else{
        $("#MelhoriaReceita").addClass("d-none");
       }

       var checkedCheckboxes = $(".ChecksVerificacao:checked");
       var arrayNao = [];
       var arraySim = [];
       var arrayNA = [];
        // Filtrar e verificar os labels associados
        checkedCheckboxes.each(function(index,item) {
            var labelText = item.labels[0].textContent;
            // var labelText = $(this).closest('label').text().trim(); // Obtém o texto do label associado
            if (labelText === "Não") {
                arrayNao.push(item);
            } else if (labelText === "Sim") {
                arraySim.push(item);
            } else if (labelText === "N/A") {
                arrayNA.push(item);
            }
        });

        if(arrayNao.length == 0 && arraySim.length != 0){
            $("#ParecerCheckSim").prop("checked" , true)
        }
        if(arraySim.length == 0 && arrayNao.length != 0){
            $("#ParecerCheckNao").prop("checked" , true) 
        }

        if(arraySim.length != 0 && arrayNao.length != 0){
            $("#ParecerCheckNA").prop("checked" , true)  
        }
    }

    redirectScreen = () => {
        let paramoption = {};
        let url = "/fiscalizacao";
        if (this.state.parsed.from === "rotulos") {
            url = "/fiscalizacao";
            if (this.state.parsed.evaluator == 1) {
                paramoption = {
                    name: "1ª avaliação",
                    url: "/fiscalizacao",
                    tableName: "RotulosOneAvalicao",
                };
            } else if (this.state.parsed.evaluator == 2) {
                paramoption = {
                    name: "2ª avaliação",
                    url: "/fiscalizacao",
                    tableName: "RotulosTwoAvalicao",
                };
            } else {
                paramoption = {
                    name: "Pendentes",
                    url: "/fiscalizacao",
                    tableName: "RotulosPendentes",
                };
            }
        } else if (this.state.parsed.from === "minhas_avaliações") {
            url = "/fiscalizacao";
            paramoption = {
                name: "Minhas avaliações",
                url: "/fiscalizacao",
                tableName: "minhas_avaliações",
            };
        }
        this.props.history.push({
            pathname: url || "/fiscalizacao",
            state: { paramoption },
        });
    };

    handlePopUpsubmit = (data) => {
        let { finalDataArray } = this.state;
        // finalDataArray=[...finalDataArray,data];
        finalDataArray = [
            ...finalDataArray,
            { discritivo: data.discritivo, titulo: data.id },
        ];
        let tableRowData = { ...data };
        let newData = { ...this.state.sendData };
        newData["processomento"] = { ...newData.processomento };
        newData["processomento"]["pmentos"] = [
            ...newData.processomento.pmentos,
            tableRowData,
        ];
        this.setState(
            {
                sendData: newData,
                show: false,
                finalDataArray,
            },
            () =>
                this.createTabel(
                    "processomento",
                    this.state.sendData.processomento.pmentos
                )
        );
    };

    createPDF = (type) => {
        var doc = new jsPDF("p", "pt", "a4");
        if (type === "Outros Formatos") {
            this.state.resData.imagens &&
                this.state.resData.imagens.map((imageData, i) => {
                    doc.addImage(imageObj, "PNG", 150, 100, 350, 150);
                    if (i < this.state.resData.imagens.length - 1) {
                        doc.addPage();
                    }
                });
            doc.save(type);
        } else if (type === "document") {
            let image =
                this.state.resData &&
                this.state.resData.características_do_rotulo &&
                this.state.resData.características_do_rotulo
                    .documentodecedencia; // use this code but it break so commented for now
            // let image = imageObj
            // doc.addImage(image, 'PNG', 150, 100, 350, 150);
            console.log("image", image);
            var a = document.createElement("a"); //Create <a>
            a.href = "data:image/png;base64," + image; //Image Base64 Goes here
            a.download = "Image.png"; //File name Here
            a.click();
        }
    };

    handleConcluir = async () => {
        this.handleSubmit(true);
    }

    validarCampos = () =>{
        //const originalItem = await getItems();
        var fiscais = []
        for (let index = 0; index < chosenFiscais.length; index++) {
            console.log(chosenFiscais , "CHOSEN OPTIONSSSSSSSS")
            var idFiscais = chosenFiscais[index].props.value;
            fiscais.push(idFiscais)
        }

       if(fiscais.length > 1){
            $("#IdentificacaoEntidadeAssinatura0 :selected").val() == "0" || $("#IdentificacaoEntidadeAssinatura0 :selected").val() == "" ?  $("#IdentificacaoEntidadeAssinatura0").addClass("is-invalid") : $("#IdentificacaoEntidadeAssinatura0").removeClass("is-invalid");
            $(".NomeEntidadeAssinatura").val() == "" ? $(".NomeEntidadeAssinatura").addClass("is-invalid") : $(".NomeEntidadeAssinatura").removeClass("is-invalid");
            $(".AssinaturaDiv img").length == 0 ? $(".AssinaturaDiv").addClass("is-invalid") : $(".AssinaturaDiv").removeClass("is-invalid");
        }
         

        $("#tipo_auto :selected").val() == "0" || $("#tipo_auto :selected").val() == "" ? $("#tipo_auto").addClass("is-invalid") : $("#tipo_auto").removeClass("is-invalid");
        $("#instal_vinica_auto :selected").val() == "0" || $("#instal_vinica_auto :selected").val() == "" ? $("#instal_vinica_auto").addClass("is-invalid") :  $("#instal_vinica_auto").removeClass("is-invalid");
        $("#Motivo_fisc :selected").val() == "0" || $("#Motivo_fisc :selected").val() == "" ? $("#Motivo_fisc").addClass("is-invalid") : $("#Motivo_fisc").removeClass("is-invalid");
        $(".ant-select-selection-item").length == 0 ? $(".DropEntidade").addClass("is-invalid") : $(".DropEntidade").removeClass("is-invalid");
        //$(".Edocklink_det_auto").val() == "" ?  $(".Edocklink_det_auto").addClass("is-invalid") : $(".Edocklink_det_auto").removeClass("is-invalid");
        //$(".Nr_Pedido_Agendamento_det_auto").val() == "" ?  $(".Nr_Pedido_Agendamento_det_auto").addClass("is-invalid") : $(".Nr_Pedido_Agendamento_det_auto").removeClass("is-invalid");
        //$(".Dep_fisc").val() == "" && $("#tipo_auto :selected").val() == '6' ? $(".Dep_fisc").addClass("is-invalid") : $(".Dep_fisc").removeClass("is-invalid");
        $(".email-inst").val() == "" ? $(".email-inst").addClass("is-invalid") : $(".email-inst").removeClass("is-invalid");
        
        
        $(".repres_fisc").val() == "" ? $(".repres_fisc").addClass("is-invalid") : $(".repres_fisc").removeClass("is-invalid"); 
        // $(".email-repr_fisc").val() == "" ? $(".email-repr_fisc").addClass("is-invalid") :  $(".email-repr_fisc").removeClass("is-invalid");
        $(".Fisc_Princ_fisc").val() == "" ? $(".Fisc_Princ_fisc").addClass("is-invalid") : $(".Fisc_Princ_fisc").removeClass("is-invalid");
       
        $(".AssinaturaDivFiscPrincipal img").length == 0 ? $(".AssinaturaDivFiscPrincipal").addClass("is-invalid") : $(".AssinaturaDivFiscPrincipal").removeClass("is-invalid");
        $(".AssinaturaDivRepresentante img").length == 0 ? $(".AssinaturaDivRepresentante").addClass("is-invalid") : $(".AssinaturaDivRepresentante").removeClass("is-invalid");
        $(".Distrito :selected").val() == "0" || $("#Distrito :selected").val() == "" ? $("#Distrito").addClass("is-invalid") : $("#Distrito").removeClass("is-invalid");
        $(".Concelho :selected").val() == "0" || $("#Concelho :selected").val() == "" ? $("#Concelho").addClass("is-invalid") : $("#Concelho").removeClass("is-invalid");
        $(".Freguesia :selected").val() == "0" || $("#Freguesia :selected").val() == "" ? $("#Freguesia").addClass("is-invalid") : $("#Freguesia").removeClass("is-invalid");
        //originalItem.length == 0 ? $(".k-grid-container").addClass("is-invalid") : $(".k-grid-container").removeClass("is-invalid");
        

        if(($("#inlineCheckbox7").prop('checked') == true && $("#inlineCheckbox6").prop('checked') == false) || 
        ($("#inlineCheckbox7").prop('checked') == false && $("#inlineCheckbox6").prop('checked') == true) || 
        ($("#inlineCheckbox7").prop('checked') == true && $("#inlineCheckbox6").prop('checked') == true)){
             
            $("#inlineCheckbox7").removeClass("is-invalid")
            $("#inlineCheckbox6").removeClass("is-invalid")
        }else{
            
            $("#inlineCheckbox7").addClass("is-invalid")
            $("#inlineCheckbox6").addClass("is-invalid")
        }
        if(($("#inlineCheckbox1").prop('checked') == true && $("#inlineCheckbox2").prop('checked') == false && $("#inlineCheckbox3").prop('checked') == false && $("#inlineCheckbox4").prop('checked') == false && $("#inlineCheckbox5").prop('checked') == false) || 
        ($("#inlineCheckbox1").prop('checked') == true && $("#inlineCheckbox2").prop('checked') == true && $("#inlineCheckbox3").prop('checked') == false && $("#inlineCheckbox4").prop('checked') == false && $("#inlineCheckbox5").prop('checked') == false) || 
        ($("#inlineCheckbox1").prop('checked') == true && $("#inlineCheckbox2").prop('checked') == true && $("#inlineCheckbox3").prop('checked') == false && $("#inlineCheckbox4").prop('checked') == true && $("#inlineCheckbox5").prop('checked') == false) || 
        ($("#inlineCheckbox1").prop('checked') == true && $("#inlineCheckbox2").prop('checked') == true && $("#inlineCheckbox3").prop('checked') == false && $("#inlineCheckbox4").prop('checked') == true && $("#inlineCheckbox5").prop('checked') == true) || 
        ($("#inlineCheckbox1").prop('checked') == false && $("#inlineCheckbox2").prop('checked') == true && $("#inlineCheckbox3").prop('checked') == false && $("#inlineCheckbox4").prop('checked') == false && $("#inlineCheckbox5").prop('checked') == false) ||
        ($("#inlineCheckbox1").prop('checked') == false && $("#inlineCheckbox2").prop('checked') == false && $("#inlineCheckbox3").prop('checked') == true && $("#inlineCheckbox4").prop('checked') == false && $("#inlineCheckbox5").prop('checked') == false) ||
        ($("#inlineCheckbox1").prop('checked') == false && $("#inlineCheckbox2").prop('checked') == false && $("#inlineCheckbox3").prop('checked') == true && $("#inlineCheckbox4").prop('checked') == true && $("#inlineCheckbox5").prop('checked') == false) ||
        ($("#inlineCheckbox1").prop('checked') == false && $("#inlineCheckbox2").prop('checked') == false && $("#inlineCheckbox3").prop('checked') == false && $("#inlineCheckbox4").prop('checked') == true && $("#inlineCheckbox5").prop('checked') == true) ||
        ($("#inlineCheckbox1").prop('checked') == false && $("#inlineCheckbox2").prop('checked') == true && $("#inlineCheckbox3").prop('checked') == false && $("#inlineCheckbox4").prop('checked') == true && $("#inlineCheckbox5").prop('checked') == true) ||
        ($("#inlineCheckbox1").prop('checked') == false && $("#inlineCheckbox2").prop('checked') == false && $("#inlineCheckbox3").prop('checked') == false && $("#inlineCheckbox4").prop('checked') == true && $("#inlineCheckbox5").prop('checked') == false) ||
        ($("#inlineCheckbox1").prop('checked') == false && $("#inlineCheckbox2").prop('checked') == false && $("#inlineCheckbox3").prop('checked') == false && $("#inlineCheckbox4").prop('checked') == false && $("#inlineCheckbox5").prop('checked') == true) ||
        ($("#inlineCheckbox1").prop('checked') == true && $("#inlineCheckbox2").prop('checked') == false && $("#inlineCheckbox3").prop('checked') == false && $("#inlineCheckbox4").prop('checked') == true && $("#inlineCheckbox5").prop('checked') == false) ||
        ($("#inlineCheckbox1").prop('checked') == true && $("#inlineCheckbox2").prop('checked') == false && $("#inlineCheckbox3").prop('checked') == false && $("#inlineCheckbox4").prop('checked') == false && $("#inlineCheckbox5").prop('checked') == true) ||
        ($("#inlineCheckbox1").prop('checked') == true && $("#inlineCheckbox2").prop('checked') == false && $("#inlineCheckbox3").prop('checked') == false && $("#inlineCheckbox4").prop('checked') == true && $("#inlineCheckbox5").prop('checked') == true) ||
        ($("#inlineCheckbox1").prop('checked') == true && $("#inlineCheckbox2").prop('checked') == true && $("#inlineCheckbox3").prop('checked') == false && $("#inlineCheckbox4").prop('checked') == false && $("#inlineCheckbox5").prop('checked') == true) ||
        ($("#inlineCheckbox1").prop('checked') == false && $("#inlineCheckbox2").prop('checked') == false && $("#inlineCheckbox3").prop('checked') == true && $("#inlineCheckbox4").prop('checked') == false && $("#inlineCheckbox5").prop('checked') == true) ||
        ($("#inlineCheckbox1").prop('checked') == false && $("#inlineCheckbox2").prop('checked') == true && $("#inlineCheckbox3").prop('checked') == false && $("#inlineCheckbox4").prop('checked') == false && $("#inlineCheckbox5").prop('checked') == true) ||
        ($("#inlineCheckbox1").prop('checked') == false && $("#inlineCheckbox2").prop('checked') == true && $("#inlineCheckbox3").prop('checked') == false && $("#inlineCheckbox4").prop('checked') == true && $("#inlineCheckbox5").prop('checked') == false) ||
        ($("#inlineCheckbox1").prop('checked') == false && $("#inlineCheckbox2").prop('checked') == false && $("#inlineCheckbox3").prop('checked') == true && $("#inlineCheckbox4").prop('checked') == true && $("#inlineCheckbox5").prop('checked') == true)){
             
            $("#inlineCheckbox1").removeClass("is-invalid")
            $("#inlineCheckbox2").removeClass("is-invalid")
            $("#inlineCheckbox3").removeClass("is-invalid")
            $("#inlineCheckbox4").removeClass("is-invalid")
            $("#inlineCheckbox5").removeClass("is-invalid")
        }else{
            $("#inlineCheckbox1").addClass("is-invalid")
            $("#inlineCheckbox2").addClass("is-invalid")
            $("#inlineCheckbox3").addClass("is-invalid")
            $("#inlineCheckbox4").addClass("is-invalid")
            $("#inlineCheckbox5").addClass("is-invalid")
        }

        if($(".is-invalid").length == 0){
            return true
        }else{
            Swal.fire({
                icon: 'error',
                title: 'Campos obrigatórios por preencher',
                text: 'Preencha os campos em falta e volte a Submeter',
            })
            return false
        }
    }
    validarGrid = (preenchimentoDaGrid) =>{
        if(preenchimentoDaGrid == 0){
            return false
        }else{
            return true 
        }
        
    }
    
    hasDuplicates = (arr) => {
        let set = new Set()
        return arr.some(el => {
          if (set.has(el)) return true
          set.add(el)
        })
    }

    handleSubmit = async (isConcluir) => {
        try {
        var concluido = isConcluir
        var validado = this.validarCampos()
        if(validado == true) {
            const originalItem = await dataGet();
            const originalItem2 = await dataGet2();
            const originalItem3 = await dataGet3();
            const originalItem4 = await dataGet4();
            const originalItem5 = await dataGet5();
            const originalItem6 = await dataGet6();
            const originalItem7 = await dataGet7();
            const originalItem8 = await dataGet8();

            const originalItem9 = await dataGet9();
            const originalItem10 = await dataGet10();
            const originalItem11 = await dataGet11();
            const originalItem13 = await dataGet13();
           

            console.log("CENASSSSS" , originalItem)
            console.log("CENASSSSS" , originalItem2)
            const queryParams = queryString.parse(this.props.location.search)
            var idAuto = "0";
            if(queryParams["idAuto"] !== undefined){
                idAuto = queryParams["idAuto"].toString();

            }

            //////// dados gerais do submeter //////// igual para todos ///////
            var idTipoAuto = parseInt($("#tipo_auto :selected").val())
            var idInstalacaoVinica = parseInt($("#instal_vinica_auto :selected").val().split("!")[0])
            var idEntidadeProprietario = parseInt($("#instal_vinica_auto :selected").val().split("!")[1])
            var idMotivo = parseInt($("#Motivo_fisc :selected").val())
            var observacao = $(".Obrs_fisc").val()
            var representante = $(".repres_fisc").val()


            if($('#email-repr_fisc').hasClass('focusInputCharEmail')){
                Swal.fire({
                    icon: 'error',
                    title: 'E-mail inválido',
                    text: "O campo e-mail tem de seguir a seguinte formula 'email@email.pt'"
                })
                return;
            }

            var representanteEmail = $(".email-repr_fisc").val()

            var depositario =  $(".Dep_fisc").val()
            var edocklink = $(".Edocklink_det_auto").val()
            var numeroPedidoAgendamento = $(".Nr_Pedido_Agendamento_det_auto").val()
            var assinado = $(".Ass_fisc").val()
            if(assinado != ''){
                assinado =true
            }else{
                assinado= false
            }
            var fiscais = []
            for (let index = 0; index < chosenFiscais.length; index++) {
                console.log(chosenFiscais , "CHOSEN OPTIONSSSSSSSS")
                var idFiscais = chosenFiscais[index].props.value;
                fiscais.push(idFiscais)
            }
            console.log(fiscais ,"ARRAYfISCAISSSSSSSSSSSSSSSS")
            var idFiscalPrincipal = parseInt($(".Fisc_Princ_fisc").text())
            var AutoGrid = [];
            var AutoAssinaturas = [];
            if(fiscais.length > 1){
                for (let i = 0; i < $(".NomeEntidadeAssinatura").length; i++) {

                    if($(".getSigAgentes .imageSignature").length == $(".NomeEntidadeAssinatura").length && chosenFiscais.length - 1 <= $(".getSigAgentes .imageSignature").length){
    
                        var CaixaTextoAssinatura = $(".NomeEntidadeAssinatura")[i].value;
                        var CaixaAssinatura =  $(".getSigAgentes .imageSignature")[i].src;
                        var AssinaturaImagem = CaixaAssinatura.split("base64,")[1]
                        var CaixaIdentificacao = $(".IdentificacaoEntidadeAssinatura :selected")[i].text;
                        if(CaixaIdentificacao != "Representante da Entidade" || CaixaIdentificacao != "Fiscal Principal"){
                            AutoAssinaturas.push({
                                "Nome" : CaixaTextoAssinatura,
                                "imagem" : AssinaturaImagem,
                                "identificacao" : CaixaIdentificacao
                            })
                        }    
    
                    }
                    else{
    
                        Swal.fire({
                            icon: 'error',
                            title: 'Assinatura em falta',
                        })
                        return;
                        
                    }
                }
            }
            
            
            var CaixaTextoAssinaturaRepres =  $("#repres_fisc").val();
            var CaixaAssinaturaResp =  $(".represAssinatura")[0].src.split("base64,")[1]
                AutoAssinaturas.push({
                    "Nome" : CaixaTextoAssinaturaRepres,
                    "imagem" : CaixaAssinaturaResp,
                    "identificacao" : "Representante da Entidade"
                })
            var CaixaTextoAssinaturaFiscP =  $("#Fisc_Princ_fisc").val();
            var CaixaAssinaturaFiscP =  $(".FiscPrincAssinatura")[0].src.split("base64,")[1];
                AutoAssinaturas.push({
                    "Nome" : CaixaTextoAssinaturaFiscP,
                    "imagem" : CaixaAssinaturaFiscP,
                    "identificacao" : "Fiscal Principal"
                })

            var DataEmissao = $("#deadlineclender").val()
            var DataRequisitante = $("#dataPedido").val()
          
                ////////    Auto 6 - Colheita de amostra      ///////
            if($("#tipo_auto :selected").val() == "1"){
                var validacaoGrid = this.validarGrid(originalItem.length)
                
                if(validacaoGrid == true){
                    ///// verificar etiquetas ////
                    var etiquetasSeguranca1 = []
                    var concatenation;
                    originalItem.map((Etiqueta, index) => (
                        Etiqueta.Etiquetas_segurança_IDVP != undefined && Etiqueta.Etiquetas_segurança_AE != undefined ? 
                        concatenation =  Etiqueta.Etiquetas_segurança_IDVP.concat(Etiqueta.Etiquetas_segurança_AE)
                        :
                        Etiqueta.Etiquetas_segurança_IDVP == undefined && Etiqueta.Etiquetas_segurança_AE != undefined ? 
                        concatenation =  Etiqueta.Etiquetas_segurança_AE
                        :
                        Etiqueta.Etiquetas_segurança_IDVP != undefined && Etiqueta.Etiquetas_segurança_AE == undefined ?
                        concatenation =  Etiqueta.Etiquetas_segurança_IDVP
                        :
                        concatenation = null,
                        etiquetasSeguranca1.push(concatenation)
                    ));

                    

                    //const concatenation2 = etiquetasSeguranca1.flatMap(num => num);  
                     const concatenation2 = (etiquetasSeguranca1 || [])
                            .flat()
                            .filter(num => num != null);

                      
                    if(this.hasDuplicates(concatenation2) == false){
                        for (let index = 0; index < originalItem.length; index++) {
                            var idVasilha = originalItem[index].N_Vasilha != "" && originalItem[index].N_Vasilha != undefined ? parseInt(originalItem[index].N_Vasilha.value) : 0
                            var idTipoVasilha = originalItem[index].Tipo_Vasilha != "" && originalItem[index].Tipo_Vasilha != undefined ? parseInt(originalItem[index].Tipo_Vasilha.value) : 0
                            //var idContaCorrente = originalItem[index].Produto_NC_GA_IG != "" && originalItem[index].Produto_NC_GA_IG != undefined ? parseInt(originalItem[index].Produto_NC_GA_IG.value) : 0
                            var numeroRegisto = originalItem[index].Produto_NC_GA_IG != "" && originalItem[index].Produto_NC_GA_IG != undefined ? parseInt(originalItem[index].Produto_NC_GA_IG.text.split("-")[2]) : 0
                            var idCapacidadeIVDP = originalItem[index].Capacidade_IVDP != "" && originalItem[index].Capacidade_IVDP != undefined ?  parseInt(originalItem[index].Capacidade_IVDP.value) : 0
                            var numeroGarrafasIVDP = originalItem[index].N_Garrafas_IVDP != "" && originalItem[index].N_Garrafas_IVDP != undefined ? parseInt(originalItem[index].N_Garrafas_IVDP) : 0
                            var etiquetasSegurancaIVDP = originalItem[index].Etiquetas_segurança_IDVP
                            var idCapacidadeAE = originalItem[index].Capacidade_AE != undefined && originalItem[index].Capacidade_AE != "" ? parseInt(originalItem[index].Capacidade_AE.value) : 0
                            var numeroGarrafasAE = originalItem[index].N_Garrafas_AE != "" && originalItem[index].N_Garrafas_AE != undefined ? parseInt(originalItem[index].N_Garrafas_AE) : 0
                            var etiquetasSegurancaAE = originalItem[index].Etiquetas_segurança_AE
                            var quantidadeAferida = originalItem[index].Quantidade_aferida != "" && originalItem[index].Quantidade_aferida != undefined ?  parseFloat(originalItem[index].Quantidade_aferida) : 0
                            var falta = originalItem[index].Falta != "" && originalItem[index].Falta != undefined ? parseFloat(originalItem[index].Falta) : 0
                            var QuantidadeApurada = originalItem[index].QuantidadeApurada != "" && originalItem[index].QuantidadeApurada != undefined  ? parseFloat(originalItem[index].QuantidadeApurada) : 0
                            
                            var idContaCorrente = originalItem[index].TipoProduto != undefined &&  originalItem[index].TipoProduto != ""  ? originalItem[index].TipoProduto.value != "ProdutosSemConta" && originalItem[index].TipoProduto.value != "Outros" ? parseInt(originalItem[index].TipoProduto.value) : originalItem[index].TipoProduto.value == "ProdutosSemConta" ? -1 : originalItem[index].TipoProduto.value == "Outros" ? -2 : 0 : originalItem[index].idContaCorrenteEng != null  ? originalItem[index].idContaCorrenteEng != "ProdutosSemConta" && originalItem[index].idContaCorrenteEng != "Outros" ? parseInt(originalItem[index].idContaCorrenteEng) : originalItem[index].idContaCorrenteEng == "ProdutosSemConta" ? -1 :originalItem[index].idContaCorrenteEng == "Outros" ? -2 : 0 : 0 
                            var ProdutosSemConta =  originalItem[index].ProdutosSemConta != undefined &&  originalItem[index].ProdutosSemConta != ""  ? parseInt(originalItem[index].ProdutosSemConta.value) : originalItem[index].idProdutosSemConta != null ? parseInt(originalItem[index].idProdutosSemConta) : 0;
                            var Cor =  originalItem[index].Cor != undefined &&  originalItem[index].Cor != ""  ? parseInt(originalItem[index].Cor.value) : originalItem[index].Cor != null ? parseInt(originalItem[index].Cor) : 0;
		                    var Ano = originalItem[index].Ano != ""  && originalItem[index].Ano != undefined ? parseInt(originalItem[index].Ano) : 0 ;
                            
                            AutoGrid.push({
                                //"idTipoVasilha" : idTipoVasilha,
                                "idVasilha" : idVasilha,
                                "quantidadeFinal": QuantidadeApurada,
                                "idContaCorrente" : idContaCorrente,
                                "numeroRegisto" : numeroRegisto,
                                "idCapacidadeIVDP" : idCapacidadeIVDP,
                                "numeroGarrafasIVDP" : numeroGarrafasIVDP,
                                "etiquetasSegurancaIVDP": etiquetasSegurancaIVDP,
                                "idCapacidadeAE" : idCapacidadeAE,
                                "numeroGarrafasAE" : numeroGarrafasAE,
                                "etiquetasSegurancaAE" : etiquetasSegurancaAE,
                                "quantidadeAferida" : quantidadeAferida,
                                "falta" : falta,
                                "idAutoDetalhe": originalItem[index].IDAutoDetalhe,
                                "ProdutosSemConta" : ProdutosSemConta,
                                "IDCorEngarrafado":Cor,
                                "AnoEngarrafado":Ano
                            })
                        }
                        var data = {
                            idAuto : idAuto ,
                            isConcluir: isConcluir,
                            idTipoAuto: idTipoAuto,
                            idInstalacaoVinica: idInstalacaoVinica,
                            idMotivo: idMotivo,
                            observacao: observacao,
                            representante: representante,
                            representanteEmail: representanteEmail,
                            depositario: depositario,
                            assinado: assinado,
                            fiscais: fiscais,
                            autoGrid: AutoGrid,
                            idFiscalPrincipal: idFiscalPrincipal,
                            edocklink : edocklink ,
                            numeroPedidoAgendamento : numeroPedidoAgendamento,
                            idEntidadeProprietario: idEntidadeProprietario,
                            AutoAssinaturas: AutoAssinaturas,
                            LoggedUser: window.localStorage.getItem('username'),
                            dataPedido : DataEmissao,
                            dataPedidoAE : DataRequisitante,
                            idEntidade : idEntidadeProprietario,
                        };
    
                        let res = await services.apiCall.requestApi(
                            "/Fiscalizacao/SubmeterAuto",
                            data,
                            "post"
                        );
                        if (res) {
                            if(concluido == true){
                                Swal.fire({
                                    title: 'Deseja emitir receita?',
                                    showDenyButton: true,
                                    showCancelButton: false,
                                    confirmButtonText: 'Sim',
                                    denyButtonText: 'Não',
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        this.redirectScreen2();
                                    } else if (result.isDenied) {
                                        this.redirectScreen();
                                    }
                                })
                            }else{
                                this.redirectScreen();
                            } 
                        }
                    }else{
                        Swal.fire({
                            icon: 'error',
                            title: 'Validar Etiquetas de segurança',
                            text: 'Não pode selecionar a mesma etiqueta de segurança em vasilhas diferentes',
                        })
                    }
                  
                }else{
                    Swal.fire({
                        icon: 'error',
                        title: 'Preencher dados na grid',
                        text: 'Preencha os campos em falta e volte a Submeter',
                    })
                }
                
                ////////        Auto 6 - Colheita de amostra  FIM    ///////
                ////////        Auto 6 - Colheita de amostra Trânsito a granel      ///////
            } else if ($("#tipo_auto :selected").val() == "2"){
                var validacaoGrid = this.validarGrid(originalItem.length)
                if(validacaoGrid == true){
                    ///// verificar etiquetas ////
                    var etiquetasSeguranca1 = []
                    var selos1 = []
                    var concatenation;
                    originalItem.map((Etiqueta, index) => (
                        Etiqueta.EtiquetasSegurancaIVDP != undefined && Etiqueta.EtiquetasSegurancaAE != undefined ?
                        concatenation =  Etiqueta.EtiquetasSegurancaIVDP.concat(Etiqueta.EtiquetasSegurancaAE)
                        :
                        Etiqueta.EtiquetasSegurancaIVDP == undefined && Etiqueta.EtiquetasSegurancaAE != undefined ?
                        concatenation =  Etiqueta.EtiquetasSegurancaAE
                        :
                        Etiqueta.EtiquetasSegurancaIVDP != undefined && Etiqueta.EtiquetasSegurancaAE == undefined ?
                        concatenation =  Etiqueta.EtiquetasSegurancaIVDP
                        :
                        concatenation = null,
                        
                        etiquetasSeguranca1.push(concatenation),
                        selos1.push(Etiqueta.SelosSeguranca)
                    ));
                    
                    //const concatenation2 = etiquetasSeguranca1.flatMap(num => num);
                    //const concatenation3 = selos1.flatMap(num => num); 
                    
                     const concatenation2 = (etiquetasSeguranca1 || [])
                            .flat()
                            .filter(num => num != null);

                        const concatenation3 = (selos1 || [])
                            .flat()
                            .filter(num => num != null);
                    if(this.hasDuplicates(concatenation2) == false){
                        if(this.hasDuplicates(concatenation3) == false){
                            var certificadoProcedencia = $(".certificado_procedencia").val()
                            var proveniencia = $(".Proveniencia").val()
                            var destinatario = $(".Destinatario").val()
                            var transportador = $(".Transportador").val()
                            var matricula = $(".Matrícula").val()
                            var numeroContentores = parseInt($(".NContentores").val())
                            var volume = parseFloat($(".VolumeL").val())
                            var documentoTransporte = $(".DocTransporte").val()
                            var validacaoGrid = this.validarGrid(originalItem.length)
                            for (let index = 0; index < originalItem.length; index++) {
                                var idContaCorrente = originalItem[index].RegistoProduto != "" && originalItem[index].RegistoProduto != undefined ? parseInt(originalItem[index].RegistoProduto.value) : 0
                                var idCapacidadeIVDP = originalItem[index].Capacidade_IVDP != "" && originalItem[index].Capacidade_IVDP != undefined ? parseInt(originalItem[index].Capacidade_IVDP.value) : null
                                var numeroGarrafasIVDP = originalItem[index].NGarrafasIVDP != "" && originalItem[index].NGarrafasIVDP != undefined ? parseInt(originalItem[index].NGarrafasIVDP) : 0
                                var etiquetasSegurancaIVDP = originalItem[index].EtiquetasSegurancaIVDP
                                var idCapacidadeAE = originalItem[index].Capacidade_AE != "" && originalItem[index].Capacidade_AE != undefined ? parseInt(originalItem[index].Capacidade_AE.value) : null
                                var numeroGarrafasAE = originalItem[index].NGarrafasAE != "" && originalItem[index].NGarrafasAE != undefined ? parseInt(originalItem[index].NGarrafasAE) : 0
                                var etiquetasSegurancaAE = originalItem[index].EtiquetasSegurancaAE
                                var quantidadeAferida = originalItem[index].VolumeAferido != "" && originalItem[index].VolumeAferido != undefined ?   parseFloat(originalItem[index].VolumeAferido) : 0
                                var selosSeguranca = originalItem[index].SelosSeguranca
                                AutoGrid.push({
                                    "idContaCorrente" : idContaCorrente,
                                    "idCapacidadeIVDP" : idCapacidadeIVDP,
                                    "numeroGarrafasIVDP" : numeroGarrafasIVDP,
                                    "etiquetasSegurancaIVDP": etiquetasSegurancaIVDP,
                                    "idCapacidadeAE" : idCapacidadeAE,
                                    "numeroGarrafasAE" : numeroGarrafasAE,
                                    "etiquetasSegurancaAE" : etiquetasSegurancaAE,
                                    "quantidadeAferida" : quantidadeAferida,
                                    "selosSeguranca" : selosSeguranca,
                                    "idAutoDetalhe": originalItem[index].IDAutoDetalhe
                                })
                            }
                                
                            var data = {
                                idAuto : idAuto,
                                isConcluir: isConcluir,
                                idTipoAuto: idTipoAuto,
                                idInstalacaoVinica: idInstalacaoVinica,
                                idMotivo: idMotivo,
                                observacao: observacao,
                                representante: representante,
                                representanteEmail: representanteEmail,
                                depositario: depositario,
                                assinado: assinado,
                                fiscais: fiscais,
                                autoGrid: AutoGrid,
                                idFiscalPrincipal: idFiscalPrincipal,
                                edocklink : edocklink ,
                                numeroPedidoAgendamento : numeroPedidoAgendamento,
                                idEntidadeProprietario: idEntidadeProprietario,
                                AutoAssinaturas: AutoAssinaturas,
                                LoggedUser: window.localStorage.getItem('username'),
                                certificadoProcedencia : certificadoProcedencia,
                                proveniencia : proveniencia,
                                destinatario : destinatario,
                                transportador : transportador,
                                matricula : matricula,
                                numeroContentores : numeroContentores,
                                volume : volume,
                                documentoTransporte : documentoTransporte,
                                dataPedido : DataEmissao,
                                dataPedidoAE : DataRequisitante,
                                idEntidade : idEntidadeProprietario,
                                
                            };
        
                            let res = await services.apiCall.requestApi(
                                "/Fiscalizacao/SubmeterAuto",
                                data,
                                "post"
                            );
                            if (res) {
                                if(concluido == true){
                                    Swal.fire({
                                        title: 'Deseja emitir receita?',
                                        showDenyButton: true,
                                        showCancelButton: false,
                                        confirmButtonText: 'Sim',
                                        denyButtonText: 'Não',
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            this.redirectScreen2();
                                        } else if (result.isDenied) {
                                            this.redirectScreen();
                                        }
                                    })
                                }else{
                                    this.redirectScreen();
                                } 
                            }
                        }else{
                            Swal.fire({
                                icon: 'error',
                                title: 'Validar selos de segurança',
                                text: 'Não pode selecionar o mesmo selo de segurança em vasilhas diferentes',
                            })
                        }
                    }else{
                        Swal.fire({
                            icon: 'error',
                            title: 'Validar etiquetas de segurança',
                            text: 'Não pode selecionar a mesma etiqueta de segurança em vasilhas diferentes',
                        })
                    }
                }else{
                    Swal.fire({
                        icon: 'error',
                        title: 'Preencher dados na grid',
                        text: 'Preencha os campos em falta e volte a Submeter',
                    })
                }
                
                    ////////        Auto 6 - Colheita de amostra Trânsito a granel   FIM   ///////
                    ////////        Auto 14 - Devoluções   ///////
                }else if ($("#tipo_auto :selected").val() == "3"){
                    var validacaoGrid = this.validarGrid(originalItem.length)
                    var etiquetasSeguranca1 = []
                    var concatenation;
                    originalItem.map((Etiqueta, index) => (
                        concatenation =  Etiqueta.Etiquetas_segurança_IDVP,
                    
                        etiquetasSeguranca1.push(concatenation)
                    ));

                   // const concatenation2 = etiquetasSeguranca1.flatMap(num => num);  

                     const concatenation2 = (etiquetasSeguranca1 || [])
                            .flat()
                            .filter(num => num != null);

                    
                    if(this.hasDuplicates(concatenation2) == false){
                        if(validacaoGrid == true){
                            //var origemDevolucao = $(".OrigemDevolucao").val() 
                            for (let index = 0; index < originalItem.length; index++) {
                                var etiquetasSegurancaIVDP = originalItem[index].Etiquetas_segurança_IDVP
                                var documentoSaida = originalItem[index].DocSaida
                                var documentoEntrada = originalItem[index].DocEntrada
                                var idRegistoProduto = originalItem[index].Registo != "" && originalItem[index].Registo != undefined ? parseInt(originalItem[index].Registo.value) : 0
                                var idRotulo = originalItem[index].Correlativa != "" && originalItem[index].Correlativa != undefined  ? parseInt(originalItem[index].Correlativa.idRotulo) : 0
                                var numeroLote = originalItem[index].NLote
                                var numeroGarrafasDevolvidas = originalItem[index].NGarrafasDevolvidas != "" && originalItem[index].NGarrafasDevolvidas != undefined ? parseInt(originalItem[index].NGarrafasDevolvidas) : 0
                                var quantidadeFinal = originalItem[index].QtdFinal != "" ?   parseFloat(originalItem[index].QtdFinal) : 0
                                var numeroGarrafasAmostra = originalItem[index].NGarrafasAmostra != "" && originalItem[index].NGarrafasAmostra != undefined ? parseInt(originalItem[index].NGarrafasAmostra) : 0
                                var motivoDispensa = originalItem[index].MotivoDispensa != undefined ? originalItem[index].MotivoDispensa.text : ""
                                AutoGrid.push({
                                    "idRegistoProduto" : idRegistoProduto,
                                    "idRotulo" : idRotulo,
                                    "numeroLote" : numeroLote,
                                    "numeroGarrafasDevolvidas": numeroGarrafasDevolvidas,
                                    "quantidadeFinal" : quantidadeFinal,
                                    "numeroGarrafasAmostra" : numeroGarrafasAmostra,
                                    "motivoDispensa" : motivoDispensa,
                                    "documentoSaida" : documentoSaida,
                                    "documentoEntrada" : documentoEntrada,
                                    "idAutoDetalhe": originalItem[index].IDAutoDetalhe,
                                    "etiquetasSegurancaIVDP": etiquetasSegurancaIVDP,
                                })
                            }
                            
                            var data = {
                                idAuto : idAuto,
                                isConcluir: isConcluir,
                                idTipoAuto: idTipoAuto,
                                idInstalacaoVinica: idInstalacaoVinica,
                                idMotivo: idMotivo,
                                observacao: observacao,
                                representante: representante,
                                representanteEmail: representanteEmail,
                                depositario: depositario,
                                assinado: assinado,
                                fiscais: fiscais,
                                autoGrid: AutoGrid,
                                idFiscalPrincipal: idFiscalPrincipal,
                                edocklink : edocklink ,
                                numeroPedidoAgendamento : numeroPedidoAgendamento,
                                idEntidadeProprietario: idEntidadeProprietario,
                                AutoAssinaturas: AutoAssinaturas,
                                LoggedUser: window.localStorage.getItem('username'),
                                dataPedido : DataEmissao,
                                idEntidade : idEntidadeProprietario,
                                dataPedidoAE : DataRequisitante,
                                /// extras devolucoes //
                                //origemDevolucao : origemDevolucao,

                                /// fim extras devolucoes //
                            };
                            let res = await services.apiCall.requestApi(
                                "/Fiscalizacao/SubmeterAuto",
                                data,
                                "post"
                            );
                            if (res) {
                                if(concluido == true){
                                    Swal.fire({
                                        title: 'Deseja emitir receita?',
                                        showDenyButton: true,
                                        showCancelButton: false,
                                        confirmButtonText: 'Sim',
                                        denyButtonText: 'Não',
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            this.redirectScreen2();
                                        } else if (result.isDenied) {
                                            this.redirectScreen();
                                        }
                                    })
                                }else{
                                    this.redirectScreen();
                                } 
                            }
                        }
                    }else{
                        Swal.fire({
                            icon: 'error',
                            title: 'Preencher dados na grid',
                            text: 'Preencha os campos em falta e volte a Submeter',
                        })
                    }
                    
                    ////////        Auto 14 - Devoluções   FIM   ///////
                    ////////        Auto 14 - FDO          Inicio //////
                }else if($("#tipo_auto :selected").val() == "4"){
                    var validacaoGrid = this.validarGrid(originalItem.length)
                    if(validacaoGrid == true){
                        var validacaoGrid = this.validarGrid(originalItem2.length)
                        if(originalItem.length > originalItem2.length){
                            Swal.fire({
                                icon: 'error',
                                title: 'Preencher dados na grid',
                                text: 'Os valores da aferição têm de corresponder com os valores das amostras',
                            })
                        }else{
                            if(validacaoGrid == true){
                                ///// verificar etiquetas ////
                                var etiquetasSeguranca1 = []
                                var selos1 = []
                                var concatenation;
                                var concatenationselos;
                                var nrGarrafasSemEtiqueta = true;

                                originalItem.map((Etiqueta, index) => (
                                    Etiqueta.NGarrafasAE != undefined && Etiqueta.NGarrafasAE != "" && Etiqueta.EtiquetasSegurancaAE == undefined ?    
                                    nrGarrafasSemEtiqueta = false                      
                                    :
                                    Etiqueta.EtiquetasSegurancaIVDP != undefined ? 
                                    concatenation =  Etiqueta.EtiquetasSegurancaIVDP.concat(Etiqueta.EtiquetasSegurancaAE)
                                    :
                                    concatenation =  Etiqueta.EtiquetasSegurancaAE,
                                    Etiqueta.SelosGarantiaIVDP != undefined && Etiqueta.SelosGarantiaIVDP.length > 0?
                                    concatenationselos =  Etiqueta.SelosGarantiaIVDP.concat(Etiqueta.SelosGarantiaIVDP[0].idIntervalo.value)
                                    :
                                    concatenationselos =  [],
                                    etiquetasSeguranca1.push(concatenation),
                                    selos1.push(concatenationselos)
                                ));
                                
                                
                                const concatenation2 = etiquetasSeguranca1.flatMap(num => num).filter(value => value !== undefined);
                                
                                const concatenation3 = selos1.flatMap(num => num);  
                                if(nrGarrafasSemEtiqueta == true){
                                    if(this.hasDuplicates(concatenation2) == false){
                                        if(this.hasDuplicates(concatenation3) == false){
                                            for (let index = 0; index < originalItem.length; index++) {
                                                var idRegistoProduto = originalItem[index].Registo != "" && originalItem[index].Registo != undefined ? parseInt(originalItem[index].Registo.value) : 0;
                                                var correlativa = originalItem[index].Correlativa != null ||  originalItem[index].Correlativa != undefined ? originalItem[index].Correlativa.text : "";
                                                var idCapacidadeIVDP = originalItem[index].CapacidadeFDO != undefined && originalItem[index].CapacidadeFDO != "" ? parseInt(originalItem[index].CapacidadeFDO.value) : 0
                                                var numeroLote = originalItem[index].NLote;
                                                var numeroGarrafasIVDP = originalItem[index].NGarrafasIVDP != "" && originalItem[index].NGarrafasIVDP != undefined ? parseInt(originalItem[index].NGarrafasIVDP) : null;
                                                var idRotulo =  originalItem[index].Correlativa != null ||  originalItem[index].Correlativa != undefined ? parseInt(originalItem[index].Correlativa.idRotulo) : 0;
                                                var SelosGarantiaIVDP = originalItem[index].SelosGarantiaIVDP;
                                                var etiquetasSegurancaIVDP = originalItem[index].EtiquetasSegurancaIVDP ? originalItem[index].EtiquetasSegurancaIVDP : [];
                                                var numeroGarrafasAE = originalItem[index].NGarrafasAE != "" && originalItem[index].NGarrafasAE != undefined ?  parseInt(originalItem[index].NGarrafasAE) : null;
                                                var SelosGarantiaAE = originalItem[index].SelosGarantiaAE;
                                                var etiquetasSegurancaAE = originalItem[index].EtiquetasSegurancaAE
                                                var QuantidadeAferidaIG =  originalItem2[index].IndispGranelQA != "" && originalItem2[index].IndispGranelQA != undefined ?  parseFloat(originalItem2[index].IndispGranelQA) : 0;
                                                var QuantidadeAferidaIE = originalItem2[index].IndispEngaQA != "" && originalItem2[index].IndispEngaQA != undefined ?  parseFloat(originalItem2[index].IndispEngaQA) : 0;
                                                var QuantidadeAferidaPA = originalItem2[index].ProdutoAcabadoQA != "" && originalItem2[index].ProdutoAcabadoQA != undefined ?  parseFloat(originalItem2[index].ProdutoAcabadoQA) : 0;
                                                var QuantidadeAferidaTotal = originalItem2[index].TotalQA != "" && originalItem2[index].TotalQA != undefined ?  parseFloat(originalItem2[index].TotalQA) : 0;
                                                var QuantidadeAferidaVendas = originalItem2[index].VendasQA != "" && originalItem2[index].VendasQA != undefined ?  parseFloat(originalItem2[index].VendasQA) : 0;
                                                var QuantidadeAferida = originalItem2[index].TotalQA != "" && originalItem2[index].TotalQA != undefined ?  parseFloat(originalItem2[index].TotalQA) : 0;
                                                var QuantidadeTotalIG = originalItem2[index].IndispGranelQT != "" && originalItem2[index].IndispGranelQT != undefined ?  parseFloat(originalItem2[index].IndispGranelQT) : 0;
                                                var QuantidadeTotalIE = originalItem2[index].IndispEngaQT != "" && originalItem2[index].IndispEngaQT != undefined ?  parseFloat(originalItem2[index].IndispEngaQT) : 0;
                                                var QuantidadeTotalPA = originalItem2[index].ProdutoAcabadoQT != "" && originalItem2[index].ProdutoAcabadoQT != undefined ?  parseFloat(originalItem2[index].ProdutoAcabadoQT) : 0;
                                                var QuantidadeTotal = originalItem2[index].TotalQT != "" && originalItem2[index].TotalQT != undefined ?  parseFloat(originalItem2[index].TotalQT) : 0;
                                                
                                                AutoGrid.push({
                                                    "idRegistoProduto" : idRegistoProduto,
                                                    "correlativa" : correlativa,
                                                    "idCapacidadeIVDP" : idCapacidadeIVDP,
                                                    "numeroLote" : numeroLote,
                                                    "numeroGarrafasIVDP": numeroGarrafasIVDP,
                                                    "etiquetasSegurancaIVDP" :etiquetasSegurancaIVDP,
                                                    "numeroGarrafasAE" : numeroGarrafasAE,
                                                    "etiquetasSegurancaAE" : etiquetasSegurancaAE,
                                                    "SelosGarantiaIVDP": SelosGarantiaIVDP,
                                                    "SelosGarantiaAE": SelosGarantiaAE,
                                                    "idAutoDetalhe": originalItem[index].IDAutoDetalhe,
                                                    "QuantidadeAferidaIG" : QuantidadeAferidaIG,
                                                    "QuantidadeAferidaIE" : QuantidadeAferidaIE,
                                                    "QuantidadeAferidaPA" : QuantidadeAferidaPA,
                                                    "QuantidadeAferidaVendas": QuantidadeAferidaVendas,
                                                    "QuantidadeAferida" : QuantidadeAferida,
                                                    "QuantidadeTotalIG" : QuantidadeTotalIG,
                                                    "QuantidadeTotalIE" : QuantidadeTotalIE,
                                                    "QuantidadeTotalPA" : QuantidadeTotalPA,
                                                    "QuantidadeAferidaTotal" : QuantidadeAferidaTotal,
                                                    "QuantidadeTotal": QuantidadeTotal,
                                                    "idRotulo": idRotulo
                                                })      
                                            }
                                            var data = {
                                                idAuto : idAuto,
                                                isConcluir: isConcluir,
                                                idTipoAuto: idTipoAuto,
                                                idInstalacaoVinica: idInstalacaoVinica,
                                                idMotivo: idMotivo,
                                                observacao: observacao,
                                                representante: representante,
                                                representanteEmail: representanteEmail,
                                                depositario: depositario,
                                                assinado: assinado,
                                                fiscais: fiscais,
                                                autoGrid: AutoGrid,
                                                idFiscalPrincipal: idFiscalPrincipal,
                                                edocklink : edocklink ,
                                                rotulosEmConformidade : $('#id-label-verified-accordance').is(":checked"),
                                                rotulosNaoEstaoEmConformidade : $('#id-label-verified-not-accordance').is(":checked"), 
                                                naoForamVerificados: $('#id-label-verified-not-accordance2').is(":checked"), 
                                                numeroPedidoAgendamento : numeroPedidoAgendamento,
                                                idEntidadeProprietario: idEntidadeProprietario,
                                                AutoAssinaturas: AutoAssinaturas,
                                                LoggedUser: window.localStorage.getItem('username'),
                                                dataPedido : DataEmissao,
                                                dataPedidoAE : DataRequisitante,
                                                idEntidade : idEntidadeProprietario,
                                            };
                
                                                let res = await services.apiCall.requestApi(
                                                    "/Fiscalizacao/SubmeterAuto",
                                                    data,
                                                    "post"
                                                );
                                                if (res) {
                                                    if(concluido == true){
                                                        Swal.fire({
                                                            title: 'Deseja emitir receita?',
                                                            showDenyButton: true,
                                                            showCancelButton: false,
                                                            confirmButtonText: 'Sim',
                                                            denyButtonText: 'Não',
                                                        }).then((result) => {
                                                            if (result.isConfirmed) {
                                                                this.redirectScreen2();
                                                            } else if (result.isDenied) {
                                                                this.redirectScreen();
                                                            }
                                                        })
                                                    }else{
                                                        this.redirectScreen();
                                                    } 
                                                }
                                        }else{
                                            Swal.fire({
                                                icon: 'error',
                                                title: 'Validar selos de segurança',
                                                text: 'Não pode selecionar o mesmo selo de segurança em vasilhas diferentes',
                                            })
                                        }
                                    }else{
                                        Swal.fire({
                                            icon: 'error',
                                            title: 'Validar etiquetas de segurança',
                                            text: 'Não pode selecionar a mesma etiqueta de segurança em vasilhas diferentes',
                                        })
                                    }
                                }else{
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Preencher dados na grid',
                                        text: 'Tem de adicionar etiquetas de segurança quando tem Nº de garrafas',
                                    })
                                }
                               
                                
                            }else{
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Preencher dados na grid',
                                    text: 'Preencha os campos em falta e volte a Submeter',
                                })
                            }
                        }
                        
                    }else{
                        Swal.fire({
                            icon: 'error',
                            title: 'Preencher dados na grid',
                            text: 'Preencha os campos em falta e volte a Submeter',
                        })
                    }
                        
                   
                    
                        ////////        Auto 14 - FDO          FIM          //////
                        ////////        Auto 14 - Notícias e despejo Inicio /////
                } else if( $("#tipo_auto :selected").val() == "5"){
                    //var originalItemDet = ClassGrid7.ClassGrid7.getGridDetails()
                    //var idAutoOrigem = ClassGrid7.ClassGrid7.getIdAutoPassagem()
                    console.log(originalItem7 , "submit noticias e despejo")
                    if($('#id-label-verified-solicited').is(":checked") == false){
                        var validacaoGrid = this.validarGrid(originalItem7.length)
                    }
                    
                    if(validacaoGrid == true || $('#id-label-verified-solicited').is(":checked") == true){
                        if($('#id-label-verified-solicited').is(":checked") == false){
                            for (let index = 0; index < originalItem7.length; index++) {
                                var correlativa = originalItem7[index].Correlativa;
                                var numeroGarrafasAE = originalItem7[index].NGarrafas != undefined && originalItem7[index].NGarrafas != "" && originalItem7[index].NGarrafas != null ? parseInt(originalItem7[index].NGarrafas) : null;
                                var numeroLote = originalItem7[index].NLote;
                                var idContaCorrente = originalItem7[index].idContaCorrente != undefined && originalItem7[index].idContaCorrente != "" ? parseInt(originalItem7[index].idContaCorrente) : 0
                                var idRegistoProduto = originalItem7[index].idRegistoProduto != "" && originalItem7[index].idRegistoProduto != undefined ?  parseInt(originalItem7[index].idRegistoProduto) : 0
                                var TotalQBD = originalItem7[index].TotalQBD == "" || originalItem7[index].TotalQBD == undefined || originalItem7[index].TotalQBD == null ? TotalQBD = null : parseFloat(originalItem7[index].TotalQBD);
                                var idRotulo = originalItem7[index].idRotulo == ""  || originalItem7[index].idRotulo == undefined || originalItem7[index].idRotulo == null ? null : parseInt(originalItem7[index].idRotulo);
                                var RegistoProduto = originalItem7[index].RegistoProduto;
                                if(TotalQBD == ""){
                                    TotalQBD = null
                                }
                                var idCapacidadeAE = originalItem7[index].CapacidadeND !=undefined ? originalItem7[index].CapacidadeND.value : originalItem7[index].idCapacidadeAE !=undefined && originalItem7[index].idCapacidadeAE !="" ? parseInt(originalItem7[index].idCapacidadeAE) : 0;
                                AutoGrid.push({
                                    "idContaCorrente" : idContaCorrente,
                                    "idRegistoProduto" : idRegistoProduto,
                                    "correlativa" : correlativa,
                                    "numeroLote" : numeroLote,
                                    "numeroGarrafasAE" : numeroGarrafasAE,
                                    "quantidadeTotal" : TotalQBD,
                                    "idCapacidadeAE" : idCapacidadeAE,
                                    "idAutoDetalhe": originalItem7[index].idAutoDetalhe,
                                    "idRotulo" : idRotulo,
                                    "registo": RegistoProduto
                                })
                            }
                        }else{
                            for (let index2 = 0; index2 < originalItem8.length; index2++) {
                                var correlativa = originalItem8[index2].CorrelativaND != undefined ? originalItem8[index2].CorrelativaND.text : "";
                                var numeroGarrafasAE = originalItem8[index2].NGarrafas != undefined && originalItem8[index2].NGarrafas != "" && originalItem8[index2].NGarrafas != null ? parseInt(originalItem8[index2].NGarrafas) : null;
                                var numeroLote = originalItem8[index2].NLote;
                                var idContaCorrente = originalItem8[index2].idContaCorrente != undefined && originalItem8[index2].idContaCorrente != "" ? parseInt(originalItem8[index2].idContaCorrente) : 0
                                var idRegistoProduto = originalItem8[index2].RegistoProduto != "" && originalItem8[index2].RegistoProduto != undefined ?  parseInt(originalItem8[index2].RegistoProduto.value) : 0
                                var TotalQBD = originalItem8[index2].TotalQBD == "" || originalItem8[index2].TotalQBD == undefined || originalItem8[index2].TotalQBD == null ? TotalQBD = null : parseFloat(originalItem8[index2].TotalQBD);
                                var idRotulo = originalItem8[index2].idRotulo == ""  || originalItem8[index2].idRotulo == undefined || originalItem8[index2].idRotulo == null ? null : parseInt(originalItem8[index2].idRotulo);
                                var RegistoProduto = originalItem8[index2].RegistoProduto.text;
                                if(TotalQBD == ""){
                                    TotalQBD = null
                                }
                                var idCapacidadeAE = originalItem8[index2].CapacidadeND !=undefined ? originalItem8[index2].CapacidadeND.value : originalItem8[index2].idCapacidadeAE !=undefined && originalItem8[index2].idCapacidadeAE !="" ? parseInt(originalItem8[index2].idCapacidadeAE) : 0;
                                AutoGrid.push({
                                    "idContaCorrente" : idContaCorrente,
                                    "idRegistoProduto" : idRegistoProduto,
                                    "correlativa" : correlativa,
                                    "numeroLote" : numeroLote,
                                    "numeroGarrafasAE" : numeroGarrafasAE,
                                    "quantidadeTotal" : TotalQBD,
                                    "idCapacidadeAE" : idCapacidadeAE,
                                    //"idAutoDetalhe": originalItem7[index].idAutoDetalhe,
                                    "idRotulo" : idRotulo,
                                    "registo": RegistoProduto
                                })
                            }
                        }
                        
                        var data = {
                            idAuto : idAuto,
                            isConcluir: isConcluir,
                            idTipoAuto: idTipoAuto,
                            idInstalacaoVinica: idInstalacaoVinica,
                            idMotivo: idMotivo,
                            observacao: observacao,
                            representante: representante,
                            representanteEmail: representanteEmail,
                            depositario: depositario,
                            assinado: assinado,
                            fiscais: fiscais,
                            autoGrid: AutoGrid,
                            idFiscalPrincipal: idFiscalPrincipal,
                            edocklink : edocklink ,
                            numeroPedidoAgendamento : numeroPedidoAgendamento,
                            idEntidadeProprietario: idEntidadeProprietario,
                            AutoAssinaturas: AutoAssinaturas,
                            idAutoOrigem: parseInt($("#id-DropDownAutoOrigem")[0].className.split("!")[1]),
                            dataInicioDespejo : $(".DataInicioDespejo input").val() != "dia/mês/ano" ? $(".DataInicioDespejo input").val() : "",
                            dataFimDespejo : $(".DataFimDespejo input").val() != "dia/mês/ano" ? $(".DataFimDespejo input").val()  : "",
                            despejoEntidade :$('#id-label-verified-solicited').is(":checked"),
                            LoggedUser: window.localStorage.getItem('username'),
                            dataPedido : DataEmissao,
                            dataPedidoAE : DataRequisitante,
                            idEntidade : idEntidadeProprietario,
                        };
                        let res = await services.apiCall.requestApi(
                            "/Fiscalizacao/SubmeterAuto",
                            data,
                            "post"
                        );
                        if (res) {
                            if(concluido == true){
                                Swal.fire({
                                    title: 'Deseja emitir receita?',
                                    showDenyButton: true,
                                    showCancelButton: false,
                                    confirmButtonText: 'Sim',
                                    denyButtonText: 'Não',
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        this.redirectScreen2();
                                    } else if (result.isDenied) {
                                        this.redirectScreen();
                                    }
                                })
                            }else{
                                this.redirectScreen();
                            } 
                        }
                    }else{
                        Swal.fire({
                            icon: 'error',
                            title: 'Preencher dados na grid',
                            text: 'Preencha os campos em falta e volte a Submeter',
                        })
                    }
                    
                    ////////  Auto 14 - Notícias e despejo  FIM //////
                    ////////  Auto 26 - Apuramento Rótulo/Selo Inicio //////
                }else if( $("#tipo_auto :selected").val() == "9"){
                    var SelagemRotulos = $('#inlineCheckbox6').is(":checked")
                    var SelagemSelosGarantia = $('#inlineCheckbox7').is(":checked")
                    var tudoCerto = false; 
                    var tudoCerto2 = false;
                    if(SelagemRotulos == true){
                        var validacaoGrid = this.validarGrid(originalItem.length)
                        if(validacaoGrid == true){
                           var tudoCerto = true 
                        }else{
                            tudoCerto = false
                        }
                    }else{
                        tudoCerto = true
                    }

                    if(SelagemSelosGarantia == true){
                        var validacaoGrid = this.validarGrid(originalItem4.length)
                        if(validacaoGrid == true){
                           tudoCerto2 = true 
                        }else{
                            tudoCerto2 = false
                        }
                    }else{
                        tudoCerto2 = true
                    }

                    if(tudoCerto == true && tudoCerto2 == true){
                        arrayGeral = [];
                        arrayGeral.push({selosGarantia:originalItem4 , rotulos: originalItem})
                        var AutoGridSelosGarantia = [];
                        var AutoGridRotulos = [];
                        arrayGeral.map((x) => {
                            x.rotulos.map((y) => {
                                var TipoRotulo = y.tipo_rotulos.text;
                                var numeroRegisto = y.Registo_rotulos != undefined && y.Registo_rotulos != "" ?  parseInt(y.Registo_rotulos.text) : 0
                                var correlativa = y.Correlativa_rotulos != undefined ? y.Correlativa_rotulos.text : "";
                                var DescricaoRotulo =  y.Descricao_rotulos != undefined ? y.Descricao_rotulos : "" ;
                                var QuantidadeRotulo = y.Quantidade_rotulos != undefined && y.Quantidade_rotulos != "" ?  parseInt(y.Quantidade_rotulos) : 0
                                var idRegistoProduto = y.Registo_rotulos != undefined && y.Registo_rotulos != "" ?  parseInt(y.Registo_rotulos.value) : 0
                                var idRotulo = y.Correlativa_rotulos != undefined && y.Correlativa_rotulos != "" ?  parseInt(y.Correlativa_rotulos.idRotulo) : 0
                                var idAutoDetalhe = y.IDAutoDetalhe != undefined && y.IDAutoDetalhe != "" ? parseInt(y.IDAutoDetalhe) : 0
                            AutoGridRotulos.push({
                                "TipoRotulo" : TipoRotulo,
                                "numeroRegisto" : numeroRegisto,
                                "correlativa" : correlativa,
                                "DescricaoRotulo" : DescricaoRotulo,
                                "QuantidadeRotulo" : QuantidadeRotulo,
                                "idRegistoProduto" : idRegistoProduto,
                                "idRotulo" : idRotulo,
                                "idAutoDetalhe": idAutoDetalhe
                            })
                            })
                            x.selosGarantia.map ((t) => {
                                var idTipoSelo = t.TipoSelo != undefined && t.TipoSelo != "" ? parseInt(t.TipoSelo.value) : 0
                                var SerieSelo = t.Serie_selosGarantia != undefined ? t.Serie_selosGarantia.text : "";
                                var IDRegistoSelo = t.Serie_selosGarantia != "" && t.Serie_selosGarantia != undefined ? parseInt(t.Serie_selosGarantia.value) : 0
                                var IntervaloSelo =  t.intervalosDisponiveis_selosGarantia != undefined ? t.intervalosDisponiveis_selosGarantia.text : "";
                                var NumeroSeloInicial = t.Nr_Selo_inicial_selosGarantia != undefined ? t.Nr_Selo_inicial_selosGarantia : "";
                                var NumeroSeloFinal = t.Nr_Selo_final_selosGarantia != undefined ? t.Nr_Selo_final_selosGarantia : "";
                                var Quantidade_selosGarantia = t.Quantidade_selosGarantia != undefined && t.Quantidade_selosGarantia != "" ? parseFloat(t.Quantidade_selosGarantia) : 0
                                var produto = t.Produto_Selos != undefined ? t.Produto_Selos : "";
                                var idRotuloEng = t.Correlativa_selos != undefined && t.Correlativa_selos != "" ? parseInt(t.Correlativa_selos.idRotulo) : 0
                                var idContaCorrenteEng =  0
                                var correlativaEng = t.Correlativa_selos != undefined && t.Correlativa_selos != "" ? t.Correlativa_selos.text : "";
                                var capacidade_selos = t.Correlativa_selos != undefined && t.Correlativa_selos!= "" ? parseFloat(t.Correlativa_selos.value) : 0
                                var idAutoDetalhe = t.IDAutoDetalhe != undefined && t.IDAutoDetalhe != "" ? parseInt(t.IDAutoDetalhe)  : 0
    
                                AutoGridSelosGarantia.push({
                                    "idTipoSelo" : idTipoSelo,
                                    "SerieSelo" : SerieSelo, 
                                    "IDRegistoSelo": IDRegistoSelo,
                                    "IntervaloSelo" : IntervaloSelo,
                                    "NumeroSeloInicial": NumeroSeloInicial,
                                    "NumeroSeloFinal": NumeroSeloFinal, 
                                    "QuantidadeSelos": Quantidade_selosGarantia,
                                    "Produto": produto,
                                    "idRotuloEng" : idRotuloEng,
                                    "idContaCorrenteEng" : idContaCorrenteEng,
                                    "correlativaEng" : correlativaEng,
                                    "capacidadeEngarrafado": capacidade_selos,
                                    "idAutoDetalhe": idAutoDetalhe
                                     
                                })
                            })
                        });
                        var data = {
                            idAuto : idAuto,
                            isConcluir: isConcluir,
                            idTipoAuto: idTipoAuto,
                            idInstalacaoVinica: idInstalacaoVinica,
                            idMotivo: idMotivo,
                            observacao: observacao,
                            representante: representante,
                            representanteEmail: representanteEmail,
                            depositario: depositario,
                            assinado: assinado,
                            fiscais: fiscais,
                            autoGridSelosGarantia : AutoGridSelosGarantia,
                            autoGridRotulos : AutoGridRotulos,
                            idFiscalPrincipal: idFiscalPrincipal,
                            edocklink : edocklink ,
                            numeroPedidoAgendamento : numeroPedidoAgendamento,
                            idEntidadeProprietario: idEntidadeProprietario,
                            AutoAssinaturas: AutoAssinaturas,
                            SelagemSelosGarantia: SelagemSelosGarantia,
                            SelagemRotulos: SelagemRotulos,
                            LoggedUser: window.localStorage.getItem('username'),
                            dataPedido : DataEmissao,
                            dataPedidoAE : DataRequisitante,
                            idEntidade : idEntidadeProprietario,
                        };
                        let res = await services.apiCall.requestApi(
                            "/Fiscalizacao/SubmeterAuto",
                            data,
                            "post"
                        );
                        if (res) {
                            if(concluido == true){
                                Swal.fire({
                                    title: 'Deseja emitir receita?',
                                    showDenyButton: true,
                                    showCancelButton: false,
                                    confirmButtonText: 'Sim',
                                    denyButtonText: 'Não',
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        this.redirectScreen2();
                                    } else if (result.isDenied) {
                                        this.redirectScreen();
                                    }
                                })
                            }else{
                                this.redirectScreen();
                            } 
                        }
                    }else{
                        Swal.fire({
                            icon: 'error',
                            title: 'Preencher dados na grid',
                            text: 'Preencha os campos em falta e volte a Submeter',
                        })
                    }
                    
                    ////////  Auto 26 - Apuramento Rótulo/Selo FIM //////
                    ////////  Auto 38 - Auto em branco Inicio //////
                }else if($("#tipo_auto :selected").val() == "21"){

                    var DescricaoAutoBranco = $("#id-div-whiteAuto-textarea").val();
                    DescricaoAutoBranco == "" ? $("#id-div-whiteAuto-textarea").css("border","1px solid red") : $("#id-div-whiteAuto-textarea").css("border","1px solid grey")
                    var OBSAutoBranco = $("#auto_de").val()
                    OBSAutoBranco == "" ? $("#auto_de").css("border","1px solid red") : $("#auto_de").css("border","1px solid grey")
                    if(DescricaoAutoBranco != '' && OBSAutoBranco != '' ){
                        var data = {
                            idAuto : idAuto,
                            isConcluir: isConcluir,
                            idTipoAuto: idTipoAuto,
                            idInstalacaoVinica: idInstalacaoVinica,
                            idMotivo: idMotivo,
                            observacao: observacao,
                            representante: representante,
                            representanteEmail: representanteEmail,
                            depositario: depositario,
                            assinado: assinado,
                            fiscais: fiscais,
                            autoGrid: AutoGrid,
                            DescricaoAutoBranco: DescricaoAutoBranco,
                            idFiscalPrincipal: idFiscalPrincipal,
                            edocklink : edocklink ,
                            numeroPedidoAgendamento : numeroPedidoAgendamento,
                            idEntidadeProprietario: idEntidadeProprietario,
                            AutoAssinaturas: AutoAssinaturas,
                            TituloAutoBranco:$("#auto_de").val(),
                            LoggedUser: window.localStorage.getItem('username'),
                            dataPedido : DataEmissao,
                            dataPedidoAE : DataRequisitante,
                            idEntidade : idEntidadeProprietario,
                        };
                        let res = await services.apiCall.requestApi(
                            "/Fiscalizacao/SubmeterAuto",
                            data,
                            "post"
                        );
                        if (res) {
                            if(concluido == true){
                                Swal.fire({
                                    title: 'Deseja emitir receita?',
                                    showDenyButton: true,
                                    showCancelButton: false,
                                    confirmButtonText: 'Sim',
                                    denyButtonText: 'Não',
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        this.redirectScreen2();
                                    } else if (result.isDenied) {
                                        this.redirectScreen();
                                    }
                                })
                            }else{
                                this.redirectScreen();
                            } 
                        }
                    
                    }else{
                        Swal.fire({
                            icon: 'error',
                            title: 'Preencher campos em falta',
                            text: 'Preencha os campos em falta e volte a Submeter',
                        })
                    }
                    
                    ////////  Auto 38 - Auto em branco FIM //////
                    ////////  Auto 27 - Auto em varejo FIM //////
                }else if($("#tipo_auto :selected").val() == "24" ){
                   
                    // var tudoCerto = false
                    // var tudoCerto2 = false
                    // var tudoCerto3 = false
                    // var tudoCerto4 = false
                    // var tudoCerto5 = false

                    // var validacaoGrid = this.validarGrid(originalItem9.length)
                    // if(validacaoGrid == true){
                    //     tudoCerto = true
                    // }else{
                    //     tudoCerto = false
                    // }
                    
                    // var validacaoGrid = this.validarGrid(originalItem10.length)
                    // if(validacaoGrid == true){
                    //     tudoCerto2 = true
                    // }else{
                    //     tudoCerto2 = false
                    // }
                    
                    // var validacaoGrid = this.validarGrid(originalItem11.length)
                    // if(validacaoGrid == true){
                    //     tudoCerto3 = true
                    // }else{
                    //     tudoCerto3 = false
                    // }

                    
                    // var validacaoGrid = this.validarGrid(originalItem13.length)
                    // if(validacaoGrid == true){
                    //     tudoCerto4 = true
                    // }else{
                    //     tudoCerto4 = false
                    // }
                    
                    // if(tudoCerto == true && tudoCerto2 == true && tudoCerto3 == true && tudoCerto4 == true && tudoCerto5 == true){
                    arrayGeral = [];
                    arrayGeral.push({engarrafado: originalItem9 , granel: originalItem10 , selosGarantia:originalItem11 , vendas: originalItem13 })
                    console.log(arrayGeral, "testearraygeral")
                   
                    var AutoGridEngarrafado = [];
                    var AutoGridGranel = [];
                    var AutoGridSelosGarantia = [];
                    var AutoGridViatura = [];

                    arrayGeral.map((x) => {
                        x.granel.map((y) => {
                           // var idContaCorrente = y.TipoProduto != undefined &&  y.TipoProduto != ""  ? y.TipoProduto.value != "ProdutosSemConta" && y.TipoProduto.value != "Outros" ? parseInt(y.TipoProduto.value) : y.TipoProduto.value == "ProdutosSemConta" ? 1 : y.TipoProduto.value == "Outros" ? 2 : 0 : 0 ;
                            var idContaCorrente = y.TipoProduto != undefined &&  y.TipoProduto != ""  ? y.TipoProduto.value != "ProdutosSemConta" && y.TipoProduto.value != "Outros" ? parseInt(y.TipoProduto.value) : y.TipoProduto.value == "ProdutosSemConta" ? -1 : y.TipoProduto.value == "Outros" ? -2 : 0 : y.idContaCorrenteEng != null  ? y.idContaCorrenteEng != "ProdutosSemConta" && y.idContaCorrenteEng != "Outros" ? parseInt(y.idContaCorrenteEng) : y.idContaCorrenteEng == "ProdutosSemConta" ? -1 : y.idContaCorrenteEng == "Outros" ? -2 : 0 : 0 ;
                            var idVasilha = y.N_Vasilha != undefined && y.N_Vasilha != "" ? parseInt(y.N_Vasilha.value) : 0
                            var capacidadeAferida = y.Quantidade_aferida != undefined &&  y.Quantidade_aferida != "" ? parseFloat(y.Quantidade_aferida) : 0
                            var quantidadeApurada = y.QuantidadeApurada != undefined &&  y.QuantidadeApurada != ""  ? parseFloat(y.QuantidadeApurada) : 0
                            var falta = y.Falta != ""  && y.Falta != undefined ? parseFloat(y.Falta) : 0 
                            // var idContaCorrente = y.TipoProduto != undefined &&  y.TipoProduto != ""  ? y.TipoProduto.value != "ProdutosSemConta" && y.TipoProduto.value != "Outros" ? parseInt(y.TipoProduto.value) : 0 : 0 ;
                            var idAgenteEconomico = y.EntidadesInst != undefined && y.EntidadesInst != "" && y.EntidadesInst.value != undefined ? parseInt(y.EntidadesInst.value) : parseInt(y.EntidadesInst)
                            var altura = y.Altura != ""  && y.Altura != undefined ? parseFloat(y.Altura) : 0  ;
                            var Observacoes = y.Observacoes;
                            var ProdutosSemConta =  y.ProdutosSemConta != undefined &&  y.ProdutosSemConta != ""  ? parseInt(y.ProdutosSemConta.value) : y.idProdutosSemConta != null ? parseInt(y.idProdutosSemConta) : 0;
                            var Ano = y.Ano != ""  && y.Ano != undefined ? parseInt(y.Ano) : 0 ;
                            var Cor =  y.Cor != undefined &&  y.Cor != ""  ? parseInt(y.Cor.value) : y.Cor != null ? parseInt(y.Cor) : 0;
                            var idAutoDetalhe = y.idAutoDetalhe != undefined &&  y.idAutoDetalhe != ""  ? parseInt(y.idAutoDetalhe) : 0
                            AutoGridGranel.push({
                                "IDVasilha" : idVasilha,
                                "QuantidadeAferida" : capacidadeAferida,
                                "QuantidadeFinal": quantidadeApurada,
                                "Falta" : falta,
                                "idContaCorrente" : idContaCorrente,
                                /// adicionar backend
                                "idAgenteEconomico" : idAgenteEconomico,
                                "altura" : altura,
                                "Observacoes" : Observacoes,
                                "ProdutosSemConta": ProdutosSemConta,
                                /////
                                "idAutoDetalhe": idAutoDetalhe,
                                "IDCorGranel": Cor,
                                "AnoGranel":Ano
                            })
                        })
                        x.engarrafado.map ((w ,index) => {
                            //var idContaCorrenteEng =  w.TipoProduto != undefined &&  w.TipoProduto != ""  ? w.TipoProduto.value != "ProdutosSemConta" && w.TipoProduto.value != "Outros" ? parseInt(w.TipoProduto.value) : 0 : 0 ;
                            var idContaCorrenteEng = w.TipoProduto != undefined &&  w.TipoProduto != ""  ? w.TipoProduto.value != "ProdutosSemConta" && w.TipoProduto.value != "Outros" ? parseInt(w.TipoProduto.value) : w.TipoProduto.value == "ProdutosSemConta" ? -1 : w.TipoProduto.value == "Outros" ? -2 : 0 : w.idContaCorrenteEng != null  ? w.idContaCorrenteEng != "ProdutosSemConta" && w.idContaCorrenteEng != "Outros" ? parseInt(w.idContaCorrenteEng) : w.idContaCorrenteEng == "ProdutosSemConta" ? -1 : w.idContaCorrenteEng == "Outros" ? -2 : 0 : 0 ;
                            var capacidade_engarrafado = w.Capacidade != undefined && w.Capacidade != "" ? parseFloat(w.Capacidade.value) : w.idCapacidadeEng != null ? parseFloat(w.idCapacidadeEng) : 0;
                            var idAutoDetalhe = w.idAutoDetalhe != undefined && w.idAutoDetalhe != "" ? parseInt(w.idAutoDetalhe) : 0
                            var ProdutosSemConta =  w.ProdutosSemConta != undefined &&  w.ProdutosSemConta != ""  ? parseInt(w.ProdutosSemConta.value) : w.idProdutosSemConta != null ? parseInt(w.idProdutosSemConta) : 0;
                            var idAgenteEconomico = w.EntidadesInst != undefined && w.EntidadesInst != ""  && w.EntidadesInst.value != undefined ? parseInt(w.EntidadesInst.value) : parseInt(w.EntidadesInst)
                            var NGarrafas = w.NGarrafasVist != undefined && w.NGarrafasVist != "" ? parseFloat(w.NGarrafasVist) : 0;
                            var Observacoes = w.Observacoes;
                            var ProdutoAcabado = w.ProdutoAcabado != undefined && w.ProdutoAcabado != "" ? parseFloat(w.ProdutoAcabado) : 0;
                            var IndisponivelEngarrafado = w.QuantidadeApuradaEngarrafado != undefined && w.QuantidadeApuradaEngarrafado != "" ? parseFloat(w.QuantidadeApuradaEngarrafado) : 0;
                            var Cor =  w.Cor != undefined &&  w.Cor != ""  ? parseInt(w.Cor.value) : w.Cor != null ? parseInt(w.Cor) : 0;
                            var Ano = w.Ano != ""  && w.Ano != undefined ? parseInt(w.Ano) : 0 ;

                            AutoGridEngarrafado.push({
                                "idContaCorrenteEng" : idContaCorrenteEng,
                                "CapacidadeEngarrafado": capacidade_engarrafado,
                                "idAutoDetalhe": idAutoDetalhe,
                                "NumeroGarrafasIVDP" : NGarrafas,
                                ////
                                "ObservacoesEng" : Observacoes,
                                "ProdutoAcabado" : ProdutoAcabado,
                                "IndisponivelEngarrafado" : IndisponivelEngarrafado,
                                "ProdutosSemContaEng": ProdutosSemConta,
                                "idAgenteEconomicoEng" : idAgenteEconomico,
                                "IDCorEngarrafado": Cor,
                                "AnoEngarrafado":Ano
                            }) 
                        })
                        x.vendas.map ((p) => {
                            var idContaCorrenteVendas = p.TipoProduto != undefined &&  p.TipoProduto != ""  ? p.TipoProduto.value != "ProdutosSemConta" && p.TipoProduto.value != "Outros" ? parseInt(p.TipoProduto.value) : p.TipoProduto.value == "ProdutosSemConta" ? -1 : p.TipoProduto.value == "Outros" ? -2 : 0 : p.idContaCorrenteEng != null  ? p.idContaCorrenteEng != "ProdutosSemConta" && p.idContaCorrenteEng != "Outros" ? parseInt(p.idContaCorrenteEng) : p.idContaCorrenteEng == "ProdutosSemConta" ? -1 : p.idContaCorrenteEng == "Outros" ? -2 : 0 : 0 ;
                            //var idContaCorrenteVendas = p.TipoProduto != undefined &&  p.TipoProduto != ""  ? p.TipoProduto.value != "ProdutosSemConta" && p.TipoProduto.value != "Outros" ? parseInt(p.TipoProduto.value) : p.TipoProduto.value == "ProdutosSemConta" ? 1 : p.TipoProduto.value == "Outros" ? 2 : 0 : 0 ;
                            var CapacidadeVendas = p.CapacidadeVendas != undefined && p.CapacidadeVendas != "" ? parseFloat(p.CapacidadeVendas.value) : p.idCapacidadeEng != null ? parseFloat(p.idCapacidadeEng) : 0;
                            var DataVendas = p.DataVendas;
                            var Destinatario = p.Destinatario;
                            var Documento = p.Documento != undefined && p.Documento != "" ? parseFloat(p.Documento.value) : p.idDocumento != null ? parseFloat(p.idDocumento): 0 ;
                            var idAgenteEconomico = p.EntidadesInst != undefined && p.EntidadesInst != "" && p.EntidadesInst.value != undefined ? parseInt(p.EntidadesInst.value) : parseInt(p.EntidadesInst)
                            var Morada = p.Morada;
                            var NumeroGarrafasVendas = p.NumeroGarrafasVendas != undefined && p.NumeroGarrafasVendas != "" ? parseFloat(p.NumeroGarrafasVendas) : 0 ;
                            var NumeroVendas = p.NumeroVendas != undefined && p.NumeroVendas != "" ? parseFloat(p.NumeroVendas) : 0 ;
                            var Observacoes = p.Observacoes;
                            var VolumeVendas = p.VolumeVendas != undefined && p.VolumeVendas != "" ? parseFloat(p.VolumeVendas) : 0 ;
                            //var idContaCorrenteVendas = p.TipoProduto != undefined &&  p.TipoProduto != ""  ? p.TipoProduto.value != "ProdutosSemConta" && p.TipoProduto.value != "Outros" ? parseInt(p.TipoProduto.value) : 0 : 0 ;
                            var ProdutosSemConta =  p.ProdutosSemConta != undefined &&  p.ProdutosSemConta != ""  ? parseInt(p.ProdutosSemConta.value) : p.idProdutosSemConta != null ? parseInt(p.idProdutosSemConta) : 0;
                            var idAutoDetalhe = p.idAutoDetalhe != undefined && p.idAutoDetalhe != "" ? parseInt(p.idAutoDetalhe) : 0
                            var Cor =  p.Cor != undefined &&  p.Cor != ""  ? parseInt(p.Cor.value) : p.Cor != null ? parseInt(p.Cor) : 0;
                            var Ano = p.Ano != ""  && p.Ano != undefined ? parseInt(p.Ano) : 0 ;

                            AutoGridViatura.push({
                                "CapacidadeVendas" : CapacidadeVendas,
                                "DataVendas" : DataVendas, 
                                "Destinatario": Destinatario,
                                "IDDocumento" : Documento,
                                "idAgenteEconomicoVendas": idAgenteEconomico,
                                "Morada": Morada, 
                                "NumeroGarrafasAE": NumeroGarrafasVendas,
                                "NumeroVendas": NumeroVendas,  
                                "ObservacoesVendas" : Observacoes,
                                "VolumeVendas" : VolumeVendas,
                                "idContaCorrenteVendas" : idContaCorrenteVendas,
                                "ProdutosSemContaVendas" : ProdutosSemConta,
                                "idAutoDetalhe": idAutoDetalhe,
                                "IDCorVendas": Cor,
                                "AnoVendas":Ano
                            })
                        })
                        x.selosGarantia.map ((t) => {
                            var idTipoSelo = t.TipoSelo != undefined && t.TipoSelo != "" ? parseInt(t.TipoSelo.value) : 0;
                            var SerieSelo = t.Serie_selosGarantia != undefined ? t.Serie_selosGarantia.text : "";
                            var IDRegistoSelo = t.Serie_selosGarantia != undefined && t.Serie_selosGarantia != "" ? parseInt(t.Serie_selosGarantia.value) : 0
                            var IntervaloSelo = t.intervalosDisponiveis_selosGarantia != undefined ? t.intervalosDisponiveis_selosGarantia.text : "";
                            var NumeroSeloInicial = t.Nr_Selo_inicial_selosGarantia;
                            var NumeroSeloFinal = t.Nr_Selo_final_selosGarantia;
                            var QTSelosCarteira = t.QTSelosCarteira != undefined && t.QTSelosCarteira != "" ? parseFloat(t.QTSelosCarteira) : 0
                            var idAutoDetalhe = t.idAutoDetalhe != undefined && t.idAutoDetalhe != "" ? parseInt(t.idAutoDetalhe) : 0;
                            var idAgenteEconomico = t.EntidadesInst != undefined && t.EntidadesInst != "" && t.EntidadesInst.value != undefined ? parseInt(t.EntidadesInst.value) : parseInt(t.EntidadesInst)
                            AutoGridSelosGarantia.push({
                                "idTipoSelo" : idTipoSelo,
                                "SerieSelo" : SerieSelo, 
                                "IDRegistoSelo": IDRegistoSelo,
                                "IntervaloSelo" : IntervaloSelo,
                                "NumeroSeloInicial": NumeroSeloInicial,
                                "NumeroSeloFinal": NumeroSeloFinal, 

                                ///
                                "QTSelosCarteira": QTSelosCarteira,
                                "idAgenteEconomicoSelos" : idAgenteEconomico,
                                ///
                                "idAutoDetalhe" : idAutoDetalhe
                            })
                        })
                        
                    });
                    var data = {
                        IDRSPrevia: $("#NrRequisicao :selected").val() != null && $("#NrRequisicao :selected").val() != undefined && $("#NrRequisicao :selected").val() != "0" ? parseInt($("#NrRequisicao :selected").val()) : null,
                        //VerificarRS : verificarRS,
                        idAuto : idAuto,
                        isConcluir: isConcluir,
                        idTipoAuto: idTipoAuto,
                        idInstalacaoVinica: idInstalacaoVinica,
                        idMotivo: idMotivo,
                        observacao: observacao,
                        representante: representante,
                        representanteEmail: representanteEmail,
                        depositario: depositario,
                        assinado: assinado,
                        fiscais: fiscais,
                        LeituraEscalaGraduada: $("#inlineCheckboxVarejo1").is(":checked"),
                        CalculoCubagemRecipiente: $("#inlineCheckboxVarejo2").is(":checked"),
                        Estimativa: $("#inlineCheckboxVarejo3").is(":checked"),
                        autoGridGranel : AutoGridGranel,
                        autoGridEngarrafado : AutoGridEngarrafado,
                        autoGridViatura : AutoGridViatura,
                        autoGridSelosGarantia : AutoGridSelosGarantia,

                        idFiscalPrincipal: idFiscalPrincipal,
                        edocklink : edocklink ,
                        numeroPedidoAgendamento : numeroPedidoAgendamento,
                        idEntidadeProprietario: idEntidadeProprietario,
                        AutoAssinaturas: AutoAssinaturas,
                        LoggedUser: window.localStorage.getItem('username'),
                        
                        
                        
                        dataPedido : DataEmissao,
                        dataPedidoAE : DataRequisitante,
                        idEntidade : idEntidadeProprietario,
                    };
                    let res = await services.apiCall.requestApi(
                        "/Fiscalizacao/SubmeterAuto",
                        data,
                        "post"
                    );
                    if (res) {
                        if(concluido == true){
                            Swal.fire({
                                title: 'Deseja emitir receita?',
                                showDenyButton: true,
                                showCancelButton: false,
                                confirmButtonText: 'Sim',
                                denyButtonText: 'Não',
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.redirectScreen2();
                                } else if (result.isDenied) {
                                    this.redirectScreen();
                                }
                            })
                        }else{
                            this.redirectScreen();
                        } 
                    } 
                               
                }else if($("#tipo_auto :selected").val() == "6" ){
                    var SelagemGranel = $('#inlineCheckbox1').is(":checked")
                    var SelagemEngarrafado = $('#inlineCheckbox2').is(":checked")
                    var SelagemViatura = $('#inlineCheckbox3').is(":checked")
                    var SelagemSelosGarantia = $('#inlineCheckbox4').is(":checked")
                    var SelagemRotulos = $('#inlineCheckbox5').is(":checked")
                    // outras checks
                    //var RepEntidadeDepositario = $('#flexCheckDefault1').is(":checked")
                    var EntregaEmMao = $('#flexCheckDefault2').is(":checked")
                    var DespejoImediato = $('#flexCheckDefault3').is(":checked")
                    var Recurso = $('#flexCheckDefault4').is(":checked")
                    var DespejoControlado = $('#flexCheckDefault5').is(":checked")
                    ///
                    //var verificarRS = $("#NrRequisicao :selected").val() == "0" || $("#NrRequisicao :selected").val() == null || $("#NrRequisicao :selected").val() == undefined ? null : $("#NrRequisicao :selected").val();
                    // campos da grid 1
                    
                    var tudoCerto = false
                    var tudoCerto2 = false
                    var tudoCerto3 = false
                    var tudoCerto4 = false
                    var tudoCerto5 = false

                        if(SelagemGranel == true){
                            var validacaoGrid = this.validarGrid(originalItem.length)
                            if(validacaoGrid == true){
                                tudoCerto = true
                            }else{
                                tudoCerto = false
                            }
                        }else{
                            tudoCerto = true
                        }

                        if(SelagemEngarrafado == true){
                            var validacaoGrid = this.validarGrid(originalItem6.length)
                            if(validacaoGrid == true){
                                tudoCerto2 = true
                            }else{
                                tudoCerto2 = false
                            }
                        }else{
                            tudoCerto2 = true
                        }
                        if(SelagemViatura == true){
                            var validacaoGrid = this.validarGrid(originalItem3.length)
                            if(validacaoGrid == true){
                                tudoCerto3 = true
                            }else{
                                tudoCerto3 = false
                            }
                        }else{
                            tudoCerto3 = true
                        }

                        if(SelagemSelosGarantia == true){
                            var validacaoGrid = this.validarGrid(originalItem4.length)
                            if(validacaoGrid == true){
                                tudoCerto4 = true
                            }else{
                                tudoCerto4 = false
                            }
                        }else{
                            tudoCerto4 = true
                        }
                        if(SelagemRotulos == true){
                            var validacaoGrid = this.validarGrid(originalItem5.length)
                            if(validacaoGrid == true){
                                tudoCerto5 = true
                            }else{
                                tudoCerto5 = false
                            }
                        }else{
                            tudoCerto5 = true
                        }
                    if(tudoCerto == true && tudoCerto2 == true && tudoCerto3 == true && tudoCerto4 == true && tudoCerto5 == true){
                        arrayGeral = [];
                        arrayGeral.push({granel: originalItem , engarrafado: originalItem6 , viatura: originalItem3 , selosGarantia:originalItem4 , rotulos: originalItem5})
                        console.log(arrayGeral, "testearraygeral")
                        var AutoGridGranel = [];
                        var AutoGridEngarrafado = [];
                        var AutoGridViatura = [];
                        var AutoGridSelosGarantia = [];
                        var AutoGridRotulos = [];
    

                            ///// verificar etiquetas ////
                            var etiquetasSeguranca1 = []
                            var selos1 = []
                            var concatenation;
                            if(originalItem.length > 0){
                               
                                originalItem.map((Etiqueta, index) => {
                                    const valuesSelos = Etiqueta.SelosSeguranca_granel ? Etiqueta.SelosSeguranca_granel.map(selo => selo.value)[0] ? Etiqueta.SelosSeguranca_granel.map(selo => selo.value) : Etiqueta.SelosSeguranca_granel : [];
                                    
                                    let concatenation = [];
                                
                                    if (Etiqueta.Etiquetas_RecolhaAmostra_granel && Etiqueta.Etiquetas_selagem_granel) {
                                        concatenation = Etiqueta.Etiquetas_RecolhaAmostra_granel.concat(Etiqueta.Etiquetas_selagem_granel);
                                    } else if (Etiqueta.Etiquetas_selagem_granel) {
                                        concatenation = Etiqueta.Etiquetas_selagem_granel;
                                    } else if (Etiqueta.Etiquetas_RecolhaAmostra_granel) {
                                        concatenation = Etiqueta.Etiquetas_RecolhaAmostra_granel;
                                    }
                                
                                    if (concatenation.length > 0) {
                                        etiquetasSeguranca1.push(concatenation);
                                    }
                                    
                                    selos1.push(valuesSelos);
                                });
                            }
                            if(originalItem6.length > 0){
                                originalItem6.map((Etiqueta, index) => (
                                    // Etiqueta.Etiquetas_RecolhaAmostra_engarrafado != undefined ? 
                                    // concatenation =  Etiqueta.Etiquetas_selagem_engarrafado.concat(Etiqueta.Etiquetas_RecolhaAmostra_engarrafado)
                                    // : 
                                    // concatenation =  Etiqueta.Etiquetas_selagem_engarrafado,
                                    // etiquetasSeguranca1.push(concatenation),
                                    // selos1.push(Etiqueta.SelosSeguranca_engarrafado)

                                    Etiqueta.Etiquetas_RecolhaAmostra_engarrafado != undefined && Etiqueta.Etiquetas_selagem_engarrafado != undefined ? 
                                    concatenation =  Etiqueta.Etiquetas_selagem_engarrafado.concat(Etiqueta.Etiquetas_RecolhaAmostra_engarrafado)
                                    :
                                    Etiqueta.Etiquetas_RecolhaAmostra_engarrafado == undefined && Etiqueta.Etiquetas_selagem_engarrafado != undefined ? 
                                    concatenation =  Etiqueta.Etiquetas_selagem_engarrafado
                                    :
                                    Etiqueta.Etiquetas_RecolhaAmostra_engarrafado != undefined && Etiqueta.Etiquetas_selagem_engarrafado == undefined ?
                                    concatenation =  Etiqueta.Etiquetas_RecolhaAmostra_engarrafado
                                    :
                                    concatenation = null,
                                    etiquetasSeguranca1.push(concatenation),
                                    selos1.push(Etiqueta.SelosSeguranca_engarrafado)
                                ));
                            }
                            if(originalItem3.length > 0){
                                originalItem3.map((Etiqueta, index) => (
                                    concatenation =  Etiqueta.Etiquetas_selagem_viatura,
                                    etiquetasSeguranca1.push(concatenation),
                                    selos1.push(Etiqueta.SelosSeguranca_viatura)
                                ));
                            }
                            if(originalItem4.length > 0){
                                originalItem4.map((Etiqueta, index) => (
                                    concatenation =  Etiqueta.Etiquetas_selagem_selosGarantia,
                                    etiquetasSeguranca1.push(concatenation),
                                    selos1.push(Etiqueta.SelosSeguranca)
                                ));
                            }
                            if(originalItem5.length > 0){
                                originalItem5.map((Etiqueta, index) => (
                                    concatenation =  Etiqueta.Etiquetas_selagem_rotulos,
                                    etiquetasSeguranca1.push(concatenation),
                                    selos1.push(Etiqueta.SelosSegurancas_rotulos)
                                ));
                            }
                            console.log(etiquetasSeguranca1)

                           const concatenation2 = (etiquetasSeguranca1 || [])
                            .flat()
                            .filter(num => num != null);

                        const concatenation3 = (selos1 || [])
                            .flat()
                            .filter(num => num != null);

                            console.log(concatenation2);
                            console.log(concatenation3);
                            if(this.hasDuplicates(concatenation2) == false){
                                if(this.hasDuplicates(concatenation3) == false){
                                    arrayGeral.map((x) => {
                                        x.granel.map((y) => {
                                            var idVasilha = y.N_Vasilha_granel != undefined && y.N_Vasilha_granel != "" ? parseInt(y.N_Vasilha_granel.value) : 0
                                            var capacidadeAferida = y.Capacidade_aferida != undefined &&  y.Capacidade_aferida != "" ? parseInt(y.Capacidade_aferida) : 0
                                            var quantidadeApurada = y.Quantidade_apurada != undefined &&  y.Quantidade_apurada != ""  ? parseInt(y.Quantidade_apurada) : 0
                                            var falta = y.Falta_granel != ""  && y.Falta_granel != undefined ? parseFloat(y.Falta_granel) : 0 
                                            //var idContaCorrente = y.Produto_NC_GA_IG_granel != undefined &&  y.Produto_NC_GA_IG_granel != ""  ? parseInt(y.Produto_NC_GA_IG_granel.value) : 0
                                            var etiquetasSegurancaSelagem = y.Etiquetas_selagem_granel;
                                            var Sinetes = y.Sinetes_granel;
                                            var numeroGarrafasRecolhaAmostra = y.NGarrafasAmostra_granel != undefined &&  y.NGarrafasAmostra_granel != "" ? parseInt(y.NGarrafasAmostra_granel) : 0
                                            var idCapacidadeRecolhaAmostra = y.Capacidade_Amostra_granel != undefined &&  y.Capacidade_Amostra_granel != "" ? parseInt(y.Capacidade_Amostra_granel.value) : 0
                                            var EtiquetasSegurancaRecolhaAmostras = y.Etiquetas_RecolhaAmostra_granel ? y.Etiquetas_RecolhaAmostra_granel : [];
                                            
                                            var SelosSeguranca = y.SelosSeguranca_granel ? y.SelosSeguranca_granel.map(selo => selo.value)[0] ? y.SelosSeguranca_granel.map(selo => selo.value) : y.SelosSeguranca_granel : []; 
                                            var idAutoDetalhe = y.IDAutoDetalhe != undefined &&  y.IDAutoDetalhe != ""  ? parseInt(y.IDAutoDetalhe) : 0

                                            var idContaCorrente = y.TipoProduto != undefined &&  y.TipoProduto != ""  ? y.TipoProduto.value != "ProdutosSemConta" && y.TipoProduto.value != "Outros" ? parseInt(y.TipoProduto.value) : y.TipoProduto.value == "ProdutosSemConta" ? -1 : y.TipoProduto.value == "Outros" ? -2 : 0 : y.idContaCorrenteEng != null  ? y.idContaCorrenteEng != "ProdutosSemConta" && y.idContaCorrenteEng != "Outros" ? parseInt(y.idContaCorrenteEng) : y.idContaCorrenteEng == "ProdutosSemConta" ? -1 : y.idContaCorrenteEng == "Outros" ? -2 : 0 : 0 
                                            var ProdutosSemConta =  y.ProdutosSemConta != undefined &&  y.ProdutosSemConta != ""  ? parseInt(y.ProdutosSemConta.value) : y.idProdutosSemConta != null ? parseInt(y.idProdutosSemConta) : 0;
                                            var Cor =  y.Cor != undefined &&  y.Cor != ""  ? parseInt(y.Cor.value) : y.Cor != null ? parseInt(y.Cor) : 0;
		                                    var Ano = y.Ano != ""  && y.Ano != undefined ? parseInt(y.Ano) : 0 ;
                                            
                                            var IDProdutoAdicionar = y.ProdutoAdicionar != undefined && y.ProdutoAdicionar != null ? y.ProdutoAdicionar.value : null;
                                            var QuantidadeAdicionada = y.QuantidadeAdicionada != undefined && y.QuantidadeAdicionada != null ? y.QuantidadeAdicionada : null;
                                            var IDProdutoObter = y.ProdutoObter != undefined && y.ProdutoObter != null ? y.ProdutoObter.value : null;
                                            var QuantidadeFinal = y.QuantidadeFinal != undefined && y.QuantidadeFinal != null ? y.QuantidadeFinal : null;


                                            AutoGridGranel.push({
                                                "IDVasilha" : idVasilha,
                                                "QuantidadeAferida" : capacidadeAferida,
                                                "QuantidadeFinal": quantidadeApurada,
                                                "Falta" : falta,
                                                "idContaCorrente" : idContaCorrente,
                                                "EtiquetasSegurancaSelagem" : etiquetasSegurancaSelagem,
                                                "Sinetes" : Sinetes,
                                                "NumeroGarrafasRecolhaAmostra" : numeroGarrafasRecolhaAmostra,
                                                "IDCapacidadeRecolhaAmostra" : idCapacidadeRecolhaAmostra,
                                                "EtiquetasSegurancaRecolhaAmostras": EtiquetasSegurancaRecolhaAmostras,
                                                "SelosSeguranca" : SelosSeguranca,
                                                "idAutoDetalhe": idAutoDetalhe,
                                                "ProdutosSemConta" : ProdutosSemConta,
                                                "IDCorEngarrafado":Cor,
                                                "AnoEngarrafado":Ano,

                                                "IDProdutoAdicional": IDProdutoAdicionar,
                                                "QuantidadeAferidaIE": QuantidadeAdicionada,
                                                "IDProdutoSB":IDProdutoObter,
                                                "QuantidadeTotal": QuantidadeFinal
                                            })
                                        })
                                        x.engarrafado.map ((w ,index) => {
                                            //var idContaCorrenteEng =  w.Produto_NC_GA_IG_engarrafado != undefined && w.Produto_NC_GA_IG_engarrafado != "" ? parseInt(w.Produto_NC_GA_IG_engarrafado.value.split("-")[0]) : 0
                                            
                                            var idContaCorrenteEng = w.Produto_NC_GA_IG_engarrafado != undefined &&  w.Produto_NC_GA_IG_engarrafado != ""  ? w.Produto_NC_GA_IG_engarrafado.value != "ProdutosSemConta" && w.Produto_NC_GA_IG_engarrafado.value != "Outros" ? parseInt(w.Produto_NC_GA_IG_engarrafado.value) : w.Produto_NC_GA_IG_engarrafado.value == "ProdutosSemConta" ? -1 : w.Produto_NC_GA_IG_engarrafado.value == "Outros" ? -2 : 0 : w.idContaCorrenteEng != null  ? w.idContaCorrenteEng != "ProdutosSemConta" && w.idContaCorrenteEng != "Outros" ? parseInt(w.idContaCorrenteEng) : w.idContaCorrenteEng == "ProdutosSemConta" ? -1 : w.idContaCorrenteEng == "Outros" ? -2 : 0 : 0 
                                            var ProdutosSemConta =  w.ProdutosSemConta != undefined &&  w.ProdutosSemConta != ""  ? parseInt(w.ProdutosSemConta.value) : w.idProdutosSemConta != null ? parseInt(w.idProdutosSemConta) : 0;
                                            var Cor =  w.Cor != undefined &&  w.Cor != ""  ? parseInt(w.Cor.value) : w.Cor != null ? parseInt(w.Cor) : 0;
		                                    var Ano = w.Ano != ""  && w.Ano != undefined ? parseInt(w.Ano) : 0 ;
                                            
                                            var idRegistoProduto =  w.Produto_NC_GA_IG_engarrafado != undefined && w.Produto_NC_GA_IG_engarrafado != "" ? parseInt(w.Produto_NC_GA_IG_engarrafado.value.split("-")[1]) : 0
                                            var correlativaEng = w.Correlativa_engarrafado != undefined ? w.Correlativa_engarrafado.text : "";
                                            var numeroLote_engarrafado = w.NLote_engarrafado;
                                            var numeroGarrafasDevolvidas = w.NGarrafasDevolvidas_engarrafado != undefined && w.NGarrafasDevolvidas_engarrafado != "" ? parseInt(w.NGarrafasDevolvidas_engarrafado) : 0
                                            // var capacidade_engarrafado = w.Correlativa_engarrafado != undefined && w.Correlativa_engarrafado != "" ? parseFloat(w.Correlativa_engarrafado.value) : 0 
                                            var capacidade_engarrafado = w.Correlativa_engarrafado == null ? w.Capacidade__engarrafado.text.includes("cl") ? (parseFloat(w.Capacidade__engarrafado.text.replace(" cl", ""))/100) : w.Capacidade__engarrafado.value : w.Correlativa_engarrafado.value;
                                            var Volume_engarrafado = w.Volume_engarrafado != undefined && w.Volume_engarrafado != "" ? parseInt(w.Volume_engarrafado) : 0
                                            var SelosSeguranca_engarrafado = w.SelosSeguranca_engarrafado;
                                            var Etiquetas_selagem_engarrafado = w.Etiquetas_selagem_engarrafado;
                                            var Sinetes_engarrafado = w.Sinetes_engarrafado;
                                            var NGarrafas_engarrafado = w.NGarrafas_engarrafado != undefined && w.NGarrafas_engarrafado != "" ? parseInt(w.NGarrafas_engarrafado) : 0
                                            var idCapacidade__engarrafado = w.Capacidade__engarrafado != undefined && w.Capacidade__engarrafado != "" ? parseInt(w.Capacidade__engarrafado.value)  : 0
                                            var Etiquetas_RecolhaAmostra_engarrafado = w.Etiquetas_RecolhaAmostra_engarrafado ? w.Etiquetas_RecolhaAmostra_engarrafado : [];
                                            var idRotuloEng = w.Correlativa_engarrafado != undefined && w.Correlativa_engarrafado != "" ? parseInt(w.Correlativa_engarrafado.idRotulo) : 0
                                            var idAutoDetalhe = w.IDAutoDetalhe != undefined && w.IDAutoDetalhe != "" ? parseInt(w.IDAutoDetalhe) : 0
                                            AutoGridEngarrafado.push({
                                                "idContaCorrenteEng" : idContaCorrenteEng,
                                                "correlativaEng" : correlativaEng, 
                                                "numeroLote": numeroLote_engarrafado,
                                                "numeroGarrafasDevolvidas" : numeroGarrafasDevolvidas,
                                                "IdRotuloEng": idRotuloEng,
                                                "CapacidadeEngarrafado": capacidade_engarrafado,
                                                "VolumeEngarrafado": Volume_engarrafado,
                                                "SelosSegurancaSelagemEngarrafado": SelosSeguranca_engarrafado,
                                                "EtiquetasSegurancaSelagemEngarrafado": Etiquetas_selagem_engarrafado, 
                                                "SinetesEngarrafado" : Sinetes_engarrafado,
                                                "NumeroGarrafasIVDP" : NGarrafas_engarrafado ,
                                                "IDCapacidadeIVDP" : idCapacidade__engarrafado,
                                                "EtiquetasSegurancaRecolhaAmostrasEngarrafado" : Etiquetas_RecolhaAmostra_engarrafado,
                                                "idAutoDetalhe": idAutoDetalhe,
                                                "idRegistoProduto": idRegistoProduto,
                                                "ProdutosSemConta" : ProdutosSemConta,
                                                "IDCorEngarrafado":Cor,
                                                "AnoEngarrafado":Ano
                                            }) 
                                        })
                                        x.viatura.map ((p) => {
                                            var Matricula_viatura = p.Matricula_viatura;
                                            var Doc_Transporte_viatura = p.Doc_Transporte_viatura;
                                            var Cert_precedencia_viatura = p.Cert_precedencia_viatura;
                                            var RCDO_viatura = p.RCDO_viatura;
                                            var Volume_viatura = p.Volume_viatura != "" && p.Volume_viatura != undefined ?  parseInt(p.Volume_viatura) : 0
                                            var SelosSeguranca_viatura = p.SelosSeguranca_viatura; 
                                            var Etiquetas_selagem_viatura = p.Etiquetas_selagem_viatura; 
                                            var Sinetes_viatura = p.Sinetes_viatura;
                                            var idAutoDetalhe = p.IDAutoDetalhe != "" && p.IDAutoDetalhe != undefined ?  parseInt(p.IDAutoDetalhe) : 0
                                            AutoGridViatura.push({
                                                "Matricula" : Matricula_viatura,
                                                "DocumentoTransporte" : Doc_Transporte_viatura, 
                                                "CertificadoProcedencia": Cert_precedencia_viatura,
                                                "RCDO" : RCDO_viatura,
                                                "VolumeViatura": Volume_viatura,
                                                "SelosSegurancaSelagemViatura": SelosSeguranca_viatura, 
                                                "EtiquetasSegurancaViatura": Etiquetas_selagem_viatura,
                                                "SinetesViatura": Sinetes_viatura,  
                                                "idAutoDetalhe" : idAutoDetalhe
                                            })
                                        })
                                        x.selosGarantia.map ((t) => {
                                            var idTipoSelo = t.TipoSelo != undefined && t.TipoSelo != "" ? parseInt(t.TipoSelo.value) : 0
                                            var SerieSelo = t.Serie_selosGarantia != undefined ? t.Serie_selosGarantia.text : "";
                                            var IDRegistoSelo = t.Serie_selosGarantia != undefined && t.Serie_selosGarantia != "" ? parseInt(t.Serie_selosGarantia.value) : 0
                                            var IntervaloSelo = t.intervalosDisponiveis_selosGarantia != undefined ? t.intervalosDisponiveis_selosGarantia.text : "";
                                            var NumeroSeloInicial = t.Nr_Selo_inicial_selosGarantia;
                                            var NumeroSeloFinal = t.Nr_Selo_final_selosGarantia;
                                            var Quantidade_selosGarantia = t.Quantidade_selosGarantia != undefined && t.Quantidade_selosGarantia != "" ? parseFloat(t.Quantidade_selosGarantia) : 0
                                            var SelosSeguranca = t.SelosSeguranca;
                                            var Etiquetas_selagem_selosGarantia = t.Etiquetas_selagem_selosGarantia;
                                            var Sinetes_selosGarantia = t.Sinetes_selosGarantia;
                                            var idAutoDetalhe = t.IDAutoDetalhe != undefined && t.IDAutoDetalhe != "" ? parseInt(t.IDAutoDetalhe) : 0
                                            AutoGridSelosGarantia.push({
                                                "idTipoSelo" : idTipoSelo,
                                                "SerieSelo" : SerieSelo, 
                                                "IDRegistoSelo": IDRegistoSelo,
                                                "IntervaloSelo" : IntervaloSelo,
                                                "NumeroSeloInicial": NumeroSeloInicial,
                                                "NumeroSeloFinal": NumeroSeloFinal, 
                                                "QuantidadeSelos": Quantidade_selosGarantia,
                                                "SelosSegurancaSelagemSelosGarantia": SelosSeguranca, 
                                                "EtiquetasSegurancaSelosGarantia": Etiquetas_selagem_selosGarantia,
                                                "SinetesSelosGarantia": Sinetes_selosGarantia,    
                                                "idAutoDetalhe" : idAutoDetalhe
                                            })
                                        })
                                        x.rotulos.map ((m) => {
                                            var tipo_rotulos = m.tipo_rotulos != undefined ? m.tipo_rotulos.text : "";
                                            var numeroRegisto_rotulos = m.Registo_rotulos != undefined && m.Registo_rotulos != "" ? parseInt(m.Registo_rotulos.text) : 0
                                            var correlativa_rotulos = m.Correlativa_rotulos != undefined ? m.Correlativa_rotulos.text : "";
                                            var Descricao_rotulos =  m.Descricao_rotulos != undefined ? m.Descricao_rotulos : "";
                                            var QuantidadeRotulo = m.Quantidade_rotulos != undefined && m.Quantidade_rotulos != "" ? parseInt(m.Quantidade_rotulos) : 0
                                            var SelosSegurancas_rotulos = m.SelosSegurancas_rotulos;
                                            var Etiquetas_selagem_rotulos = m.Etiquetas_selagem_rotulos;
                                            var Sinetes_rotulos = m.Sinetes_rotulos != undefined ? m.Sinetes_rotulos : "";
                                            var idRotulo = m.Correlativa_rotulos != undefined && m.Correlativa_rotulos != "" ? parseInt(m.Correlativa_rotulos.idRotulo) : 0
                                            var idAutoDetalhe = m.IDAutoDetalhe != undefined && m.IDAutoDetalhe != "" ? parseInt(m.IDAutoDetalhe) : 0
                                            var idRegistoProduto = m.Registo_rotulos != undefined && m.Registo_rotulos != "" ? parseInt(m.Registo_rotulos.value) : 0
                                            AutoGridRotulos.push({
                                                "TipoRotulo" : tipo_rotulos,
                                                "numeroRegisto" : numeroRegisto_rotulos, 
                                                "correlativa": correlativa_rotulos,
                                                "idRotulo": idRotulo,
                                                "DescricaoRotulo" : Descricao_rotulos,
                                                "QuantidadeRotulo": QuantidadeRotulo,
                                                "SelosSegurancaSelagemRotulos": SelosSegurancas_rotulos,
                                                "EtiquetasSegurancaRotulos": Etiquetas_selagem_rotulos,
                                                "SinetesRotulos": Sinetes_rotulos, 
                                                "idAutoDetalhe" : idAutoDetalhe,
                                                "idRegistoProduto" : idRegistoProduto
                                            })
                                        })  
                                    });
                                    var data = {
                                        IDRSPrevia: $("#NrRequisicao :selected").val() != null && $("#NrRequisicao :selected").val() != undefined && $("#NrRequisicao :selected").val() != "0" ? parseInt($("#NrRequisicao :selected").val()) : null,
                                        //VerificarRS : verificarRS,
                                        idAuto : idAuto,
                                        isConcluir: isConcluir,
                                        idTipoAuto: idTipoAuto,
                                        idInstalacaoVinica: idInstalacaoVinica,
                                        idMotivo: idMotivo,
                                        observacao: observacao,
                                        representante: representante,
                                        representanteEmail: representanteEmail,
                                        depositario: depositario,
                                        assinado: assinado,
                                        fiscais: fiscais,
                                        autoGridGranel : AutoGridGranel,
                                        autoGridEngarrafado : AutoGridEngarrafado,
                                        autoGridViatura : AutoGridViatura,
                                        autoGridSelosGarantia : AutoGridSelosGarantia,
                                        autoGridRotulos : AutoGridRotulos,
                                        idFiscalPrincipal: idFiscalPrincipal,
                                        edocklink : edocklink ,
                                        numeroPedidoAgendamento : numeroPedidoAgendamento,
                                        idEntidadeProprietario: idEntidadeProprietario,
                                        AutoAssinaturas: AutoAssinaturas,
                                        LoggedUser: window.localStorage.getItem('username'),
                                        
                                        SelagemGranel: SelagemGranel,
                                        SelagemEngarrafado: SelagemEngarrafado,
                                        SelagemViatura: SelagemViatura,
                                        SelagemSelosGarantia: SelagemSelosGarantia,
                                        SelagemRotulos: SelagemRotulos,
                                        
                                        //RepEntidadeDepositario: RepEntidadeDepositario,
                                        EntregaEmMao: EntregaEmMao,
                                        DespejoImediato: DespejoImediato,
                                        Recurso: Recurso,
                                        DespejoControlado: DespejoControlado,
                                        dataPedido : DataEmissao,
                                        dataPedidoAE : DataRequisitante,
                                        idEntidade : idEntidadeProprietario,
                                    };
                                    let res = await services.apiCall.requestApi(
                                        "/Fiscalizacao/SubmeterAuto",
                                        data,
                                        "post"
                                    );
                                    if (res) {
                                        if(concluido == true){
                                            Swal.fire({
                                                title: 'Deseja emitir receita?',
                                                showDenyButton: true,
                                                showCancelButton: false,
                                                confirmButtonText: 'Sim',
                                                denyButtonText: 'Não',
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    this.redirectScreen2();
                                                } else if (result.isDenied) {
                                                    this.redirectScreen();
                                                }
                                            })
                                        }else{
                                            this.redirectScreen();
                                        } 
                                    } 
                                }else{
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Validar selos de segurança',
                                        text: 'Não pode selecionar o mesmo selo de segurança em vasilhas diferentes',
                                    })
                                }
                            }else{
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Validar etiquetas de segurança',
                                    text: 'Não pode selecionar a mesma etiqueta de segurança em vasilhas diferentes',
                                })
                            }
                    }else{
                        Swal.fire({
                            icon: 'error',
                            title: 'Preencher dados na grid',
                            text: 'Preencha os campos em falta e volte a Submeter',
                        }) 
                    }
                   
                } else if ($("#tipo_auto :selected").val() == "15"){
                    var AutoGridGranel = [];
                    var AutoGridEngarrafado = [];
                    var AutoGridViatura = [];
                    var AutoGridSelosGarantia = [];
                    var AutoGridRotulos = [];
                    var originalItemDet1 = originalItem
                    var originalItemDet3 = FiscalizacaoGrid3.ClassGrid3.getGridDetails() == undefined ? originalItem3 : FiscalizacaoGrid3.ClassGrid3.getGridDetails()
                    var originalItemDet4 = FiscalizacaoGrid4.ClassGrid4.getGridDetails() == undefined ? originalItem4 : FiscalizacaoGrid4.ClassGrid4.getGridDetails()
                    var originalItemDet5 = FiscalizacaoGrid5.ClassGrid5.getGridDetails() == undefined ? originalItem5 : FiscalizacaoGrid5.ClassGrid5.getGridDetails()
                    var originalItemDet6 = FiscalizacaoGrid6.ClassGrid6.getGridDetails() == undefined ? originalItem6 : FiscalizacaoGrid6.ClassGrid6.getGridDetails()
                    var SelagemGranel = $('#inlineCheckbox1').is(":checked")
                    var SelagemEngarrafado = $('#inlineCheckbox2').is(":checked")
                    var SelagemViatura = $('#inlineCheckbox3').is(":checked")
                    var SelagemSelosGarantia = $('#inlineCheckbox4').is(":checked")
                    var SelagemRotulos = $('#inlineCheckbox5').is(":checked")
                    // outras checks

                    //var RepEntidadeDepositario = $('#flexCheckDefault1').is(":checked")
                    var EntregaEmMao = $('#flexCheckDefault2').is(":checked")
                    var DespejoImediato = $('#flexCheckDefault3').is(":checked")
                    var Recurso = $('#flexCheckDefault4').is(":checked")
                    var DespejoControlado = $('#flexCheckDefault5').is(":checked")
                    var idAutoOrigem = parseInt(idAutoQuery)
                    var tudoCerto = false
                    var tudoCerto2 = false
                    var tudoCerto3 = false
                    var tudoCerto4 = false
                    var tudoCerto5 = false

                        if(SelagemGranel == true){
                            var validacaoGrid = this.validarGrid(originalItemDet1.length)
                            if(validacaoGrid == true){
                                tudoCerto = true
                            }else{
                                tudoCerto = false
                            }
                        }else{
                            tudoCerto = true
                        }

                        if(SelagemEngarrafado == true){
                            var validacaoGrid = this.validarGrid(originalItemDet6.length)
                            if(validacaoGrid == true){
                                tudoCerto2 = true
                            }else{
                                tudoCerto2 = false
                            }
                        }else{
                            tudoCerto2 = true
                        }
                        if(SelagemViatura == true){
                            var validacaoGrid = this.validarGrid(originalItemDet3.length)
                            if(validacaoGrid == true){
                                tudoCerto3 = true
                            }else{
                                tudoCerto3 = false
                            }
                        }else{
                            tudoCerto3 = true
                        }

                        if(SelagemSelosGarantia == true){
                            var validacaoGrid = this.validarGrid(originalItemDet4.length)
                            if(validacaoGrid == true){
                                tudoCerto4 = true
                            }else{
                                tudoCerto4 = false
                            }
                        }else{
                            tudoCerto4 = true
                        }
                        if(SelagemRotulos == true){
                            var validacaoGrid = this.validarGrid(originalItemDet5.length)
                            if(validacaoGrid == true){
                                tudoCerto5 = true
                            }else{
                                tudoCerto5 = false
                            }
                        }else{
                            tudoCerto5 = true
                        }
                    if(tudoCerto == true && tudoCerto2 == true && tudoCerto3 == true && tudoCerto4 == true && tudoCerto5 == true){
                        arrayGeralDet = [];
                        arrayGeralDet.push({granel: originalItemDet1 , engarrafado: originalItemDet6 , viatura: originalItemDet3 , selosGarantia: originalItemDet4 , rotulos: originalItemDet5})
                        console.log(arrayGeralDet)

                        //// validar etiquetas e selos
                        var etiquetasSeguranca1 = []
                        var selos1 = []
                        var concatenation;
                        if(originalItemDet1 != undefined && originalItem.length > 0){
                            // originalItem.map((Etiqueta, index) => (
                            //     concatenation =  Etiqueta.Etiquetas_selagem_granel.concat(Etiqueta.Etiquetas_RecolhaAmostra_granel),
                            //     etiquetasSeguranca1.push(concatenation),
                            //     selos1.push(Etiqueta.SelosSeguranca_granel)

                                
                            // ));

                            originalItem.map((Etiqueta, index) => {
                                const valuesSelos = Etiqueta.SelosSeguranca_granel ? Etiqueta.SelosSeguranca_granel.map(selo => selo.value)[0] ? Etiqueta.SelosSeguranca_granel.map(selo => selo.value) : Etiqueta.SelosSeguranca_granel : [];
                                
                                let concatenation = [];
                            
                                if (Etiqueta.Etiquetas_RecolhaAmostra_granel && Etiqueta.Etiquetas_selagem_granel) {
                                    concatenation = Etiqueta.Etiquetas_RecolhaAmostra_granel.concat(Etiqueta.Etiquetas_selagem_granel);
                                } else if (Etiqueta.Etiquetas_selagem_granel) {
                                    concatenation = Etiqueta.Etiquetas_selagem_granel;
                                } else if (Etiqueta.Etiquetas_RecolhaAmostra_granel) {
                                    concatenation = Etiqueta.Etiquetas_RecolhaAmostra_granel;
                                }
                            
                                if (concatenation.length > 0) {
                                    etiquetasSeguranca1.push(concatenation);
                                }
                                
                                selos1.push(valuesSelos);
                            });
                        }
                        // if(originalItemDet6 != undefined){
                        //     originalItemDet6.map((Etiqueta, index) => (
                        //         Etiqueta.etiquetasSegurancaSelagemEngarrafado == undefined ? 
                        //         concatenation =  Etiqueta.Etiquetas_selagem_engarrafado.concat(Etiqueta.Etiquetas_RecolhaAmostra_engarrafado) :  concatenation =  Etiqueta.etiquetasSegurancaSelagemEngarrafado.concat(Etiqueta.etiquetasSegurancaRecolhaAmostrasEngarrafado),
                        //         etiquetasSeguranca1.push(concatenation),
                        //         selos1.push(Etiqueta.selosSegurancaSelagemEngarrafado == undefined ? Etiqueta.SelosSeguranca_engarrafado : Etiqueta.selosSegurancaSelagemEngarrafado)
                        //     ));
                        // }

                        if(originalItemDet6 != undefined){
                            originalItemDet6.map((Etiqueta, index) => (
                                Etiqueta.Etiquetas_selagem_engarrafado != undefined  && Etiqueta.Etiquetas_RecolhaAmostra_engarrafado != undefined? 
                                concatenation =  Etiqueta.Etiquetas_selagem_engarrafado.concat(Etiqueta.Etiquetas_RecolhaAmostra_engarrafado) 
                                :
                                Etiqueta.Etiquetas_selagem_engarrafado != undefined  && Etiqueta.Etiquetas_RecolhaAmostra_engarrafado == undefined? 
                                concatenation =  Etiqueta.Etiquetas_selagem_engarrafado
                                :
                                Etiqueta.Etiquetas_selagem_engarrafado == undefined  && Etiqueta.Etiquetas_RecolhaAmostra_engarrafado != undefined? 
                                concatenation =  Etiqueta.Etiquetas_RecolhaAmostra_engarrafado
                                :
                                concatenation =  [],

                                //concatenation =  Etiqueta.etiquetasSegurancaSelagemEngarrafado.concat(Etiqueta.etiquetasSegurancaRecolhaAmostrasEngarrafado),
                                etiquetasSeguranca1.push(concatenation),
                                selos1.push(Etiqueta.selosSegurancaSelagemEngarrafado == undefined ? Etiqueta.SelosSeguranca_engarrafado : Etiqueta.selosSegurancaSelagemEngarrafado)
                            ));
                        }

                        if(originalItemDet3 != undefined){
                            originalItemDet3.map((Etiqueta, index) => (
                                Etiqueta.etiquetasSegurancaViatura == undefined ? concatenation =  Etiqueta.Etiquetas_selagem_viatura : concatenation =  Etiqueta.etiquetasSegurancaViatura,
                                etiquetasSeguranca1.push(concatenation),
                                selos1.push(Etiqueta.selosSegurancaSelagemViatura == undefined ? Etiqueta.SelosSeguranca_viatura : Etiqueta.selosSegurancaSelagemViatura)
                            ));
                        }
                        if(originalItemDet4 != undefined){
                            originalItemDet4.map((Etiqueta, index) => (
                                Etiqueta.etiquetasSegurancaSelosGarantia == undefined ?  concatenation = Etiqueta.Etiquetas_selagem_selosGarantia : concatenation =  Etiqueta.etiquetasSegurancaSelosGarantia,
                                etiquetasSeguranca1.push(concatenation),
                                selos1.push(Etiqueta.selosSegurancaSelagemSelosGarantia == undefined ? Etiqueta.SelosSeguranca : Etiqueta.selosSegurancaSelagemSelosGarantia)
                            ));
                        }
                        if(originalItemDet5 != undefined){
                            originalItemDet5.map((Etiqueta, index) => (
                                Etiqueta.etiquetasSegurancaRotulos == undefined ? concatenation =  Etiqueta.Etiquetas_selagem_rotulos : concatenation =  Etiqueta.etiquetasSegurancaRotulos,
                                etiquetasSeguranca1.push(concatenation),
                                selos1.push(Etiqueta.selosSegurancaSelagemRotulos == undefined ? Etiqueta.SelosSegurancas_rotulos : Etiqueta.selosSegurancaSelagemRotulos)
                            ));
                        }
                        console.log(etiquetasSeguranca1)

                        var concatenation2 = etiquetasSeguranca1.flatMap(num => num);
                        var concatenation3 = selos1.flatMap(num => num);  
                        console.log(concatenation2)
                        console.log(concatenation3)
                        if(this.hasDuplicates(concatenation2) == false){
                            if(this.hasDuplicates(concatenation3) == false){
                                arrayGeralDet.map((x) => {
                                    if(x.granel != undefined){ x.granel.map((y) => {
                                        var idVasilha = y.N_Vasilha_granel.value != undefined && y.N_Vasilha_granel.value != "" ? parseInt(y.N_Vasilha_granel.value) : 0
                                        var capacidadeAferida = y.Capacidade_aferida != undefined && y.Capacidade_aferida != "" ? parseInt(y.Capacidade_aferida) : 0
                                        var quantidadeApurada = y.Quantidade_apurada != undefined && y.Quantidade_apurada != "" ? parseInt(y.Quantidade_apurada) : 0
                                        var falta = y.Falta_granel != "" &&  y.Falta_granel != undefined ? parseFloat(y.Falta_granel) : 0
                                        var idContaCorrente = y.Produto_NC_GA_IG_granel.value != undefined && y.Produto_NC_GA_IG_granel.value != "" ? parseInt(y.Produto_NC_GA_IG_granel.value)  : 0
                                        var etiquetasSegurancaSelagem = y.Etiquetas_selagem_granel;
                                        var Sinetes = y.Sinetes_granel;
                                        var numeroGarrafasRecolhaAmostra = y.NGarrafasAmostra_granel != undefined && y.NGarrafasAmostra_granel != "" ? parseInt(y.NGarrafasAmostra_granel)  : 0
                                        var idCapacidadeRecolhaAmostra = y.Capacidade_Amostra_granel.value != undefined && y.Capacidade_Amostra_granel.value != "" ? parseInt(y.Capacidade_Amostra_granel.value)  : 0
                                        var EtiquetasSegurancaRecolhaAmostras = y.Etiquetas_RecolhaAmostra_granel;
                                        var SelosSeguranca = y.SelosSeguranca_granel ? y.SelosSeguranca_granel.map(selo => selo.value)[0] ? y.SelosSeguranca_granel.map(selo => selo.value) : y.SelosSeguranca_granel : []; 
                                        var idAutoDetalhe = y.IDAutoDetalhe != undefined && y.IDAutoDetalhe != "" ? parseInt(y.IDAutoDetalhe)  : 0
                                        var Etiquetas = []
                                        var EtiquetasRecAmostra = []
                                        var selosSeg = []
                                        if(etiquetasSegurancaSelagem != undefined && etiquetasSegurancaSelagem != null){
                                            etiquetasSegurancaSelagem.map((etiquetasSegurancaSelagem) => (
                                                Etiquetas.push(etiquetasSegurancaSelagem)
                                            ));
                                        }
                                        if(EtiquetasSegurancaRecolhaAmostras != undefined && EtiquetasSegurancaRecolhaAmostras != null){
                                            EtiquetasSegurancaRecolhaAmostras.map((EtiquetasSegurancaRecolhaAmostras) => (
                                                EtiquetasRecAmostra.push(EtiquetasSegurancaRecolhaAmostras)
                                            ));
                                        }
                                        if(SelosSeguranca != undefined && SelosSeguranca != null){
                                            SelosSeguranca.map((SelosSeguranca) => (
                                                selosSeg.push(SelosSeguranca)
                                            ));
                                        }
                                        
            
                                        AutoGridGranel.push({
                                            "IDVasilha" : idVasilha,
                                            "QuantidadeAferida" : capacidadeAferida,
                                            "QuantidadeFinal": quantidadeApurada,
                                            "Falta" : falta,
                                            "idContaCorrente" : idContaCorrente,
                                            "EtiquetasSegurancaSelagem" : Etiquetas,
                                            "Sinetes" : Sinetes,
                                            "NumeroGarrafasRecolhaAmostra" : numeroGarrafasRecolhaAmostra,
                                            "IDCapacidadeRecolhaAmostra" : idCapacidadeRecolhaAmostra,
                                            "EtiquetasSegurancaRecolhaAmostras": EtiquetasRecAmostra,
                                            "SelosSeguranca" : selosSeg,
                                            "idAutoDetalhe": idAutoDetalhe
                                        })
                                    }) }
                                    if(x.engarrafado != undefined){ x.engarrafado.map ((w ,index) => {
                                        var idContaCorrenteEng = w.idContaCorrenteEng != undefined ? parseInt(w.idContaCorrenteEng) : parseInt(w.Produto_NC_GA_IG_engarrafado.value.split("-")[0])
                                        var correlativaEng = w.correlativaEng != undefined ? w.correlativaEng : w.Correlativa_engarrafado.text ;
                                        var numeroLote_engarrafado = w.numeroLote != undefined ? w.numeroLote : w.NLote_engarrafado;
                                        var numeroGarrafasDevolvidas = w.numeroGarrafasDevolvidas != undefined ? parseInt(w.numeroGarrafasDevolvidas) : parseInt(w.NGarrafasDevolvidas_engarrafado)
                                        var capacidade_engarrafado = w.capacidadeEngarrafado != undefined ? parseInt(w.capacidadeEngarrafado) : parseFloat(w.Correlativa_engarrafado.value)
                                        var Volume_engarrafado = w.volumeEngarrafado != undefined ? parseInt(w.volumeEngarrafado) : parseInt(w.Volume_engarrafado)
                                        var SelosSeguranca_engarrafado = w.selosSegurancaSelagemEngarrafado == undefined ? w.SelosSeguranca_engarrafado : w.selosSegurancaSelagemEngarrafado;
                                        var Etiquetas_selagem_engarrafado = w.etiquetasSegurancaSelagemEngarrafado == undefined ? w.Etiquetas_selagem_engarrafado : w.etiquetasSegurancaSelagemEngarrafado
                                        var Sinetes_engarrafado = w.sinetesEngarrafado != undefined ? w.sinetesEngarrafado : w.Sinetes_engarrafado;
                                        var NGarrafas_engarrafado = w.numeroGarrafasIVDP != undefined ? parseInt(w.numeroGarrafasIVDP) : parseInt(w.NGarrafas_engarrafado)
                                        var idCapacidade__engarrafado = w.idCapacidadeIVDP != undefined ? parseInt(w.idCapacidadeIVDP) : parseInt(w.Capacidade__engarrafado.value)
                                        var Etiquetas_RecolhaAmostra_engarrafado = w.etiquetasSegurancaRecolhaAmostrasEngarrafado == undefined ? w.Etiquetas_RecolhaAmostra_engarrafado : w.etiquetasSegurancaRecolhaAmostrasEngarrafado ;
                                        var idRotuloEng = w.idRotuloEng != undefined  ? parseInt(w.idRotuloEng) : parseInt(w.Correlativa_engarrafado.idRotulo)
                                        var idAutoDetalhe = w.IDAutoDetalhe != undefined ? parseInt(w.IDAutoDetalhe) : parseInt(w.IDAutoDetalhe)
                                        var EtiquetasRecAmostraEng = []
                                        var selosSegEng = []
                                        var EtiquetasSegEng = []
                                        if(Etiquetas_selagem_engarrafado != undefined && Etiquetas_selagem_engarrafado != null){
                                            Etiquetas_selagem_engarrafado.map((Etiquetas_selagem_engarrafado) => (
                                                EtiquetasSegEng.push(Etiquetas_selagem_engarrafado.idEtiqueta == undefined ?Etiquetas_selagem_engarrafado : Etiquetas_selagem_engarrafado.idEtiqueta)
                                            ));
                                        }
                                        if(Etiquetas_RecolhaAmostra_engarrafado != undefined && Etiquetas_RecolhaAmostra_engarrafado != null){
                                            Etiquetas_RecolhaAmostra_engarrafado.map((Etiquetas_RecolhaAmostra_engarrafado) => (
                                                EtiquetasRecAmostraEng.push(Etiquetas_RecolhaAmostra_engarrafado.idEtiqueta == undefined ? Etiquetas_RecolhaAmostra_engarrafado : Etiquetas_RecolhaAmostra_engarrafado.idEtiqueta)
                                            ));
                                        }
                                        if(SelosSeguranca_engarrafado != undefined && SelosSeguranca_engarrafado != null){
                                            SelosSeguranca_engarrafado.map((SelosSeguranca_engarrafado) => (
                                                selosSegEng.push(SelosSeguranca_engarrafado.idSelo == undefined ? SelosSeguranca_engarrafado : SelosSeguranca_engarrafado.idSelo)
                                            ));
                                        }
                                        
                                        AutoGridEngarrafado.push({
                                            "idContaCorrenteEng" : idContaCorrenteEng,
                                            "correlativaEng" : correlativaEng, 
                                            "numeroLote": numeroLote_engarrafado,
                                            "numeroGarrafasDevolvidas" : numeroGarrafasDevolvidas,
                                            "IdRotuloEng": idRotuloEng,
                                            "CapacidadeEngarrafado": capacidade_engarrafado,
                                            "VolumeEngarrafado": Volume_engarrafado,
                                            "SelosSegurancaSelagemEngarrafado": selosSegEng,
                                            "EtiquetasSegurancaSelagemEngarrafado": EtiquetasSegEng, 
                                            "SinetesEngarrafado" : Sinetes_engarrafado,
                                            "NumeroGarrafasIVDP" : NGarrafas_engarrafado ,
                                            "IDCapacidadeIVDP" : idCapacidade__engarrafado,
                                            "EtiquetasSegurancaRecolhaAmostrasEngarrafado" : EtiquetasRecAmostraEng ,
                                            "idAutoDetalhe": idAutoDetalhe
                                        }) 
                                    })}
                                    if(x.viatura != undefined ){ x.viatura.map ((p) => {
                                        var Matricula_viatura = p.matricula != undefined ? p.matricula : p.Matricula_viatura;
                                        var Doc_Transporte_viatura = p.documentoTransporte != undefined ? p.documentoTransporte : p.Doc_Transporte_viatura;
                                        var Cert_precedencia_viatura = p.certificadoProcedencia != undefined ? p.certificadoProcedencia : p.Cert_precedencia_viatura;
                                        var RCDO_viatura = p.rcdo != undefined ? p.rcdo : p.RCDO_viatura;
                                        var Volume_viatura = p.volumeViatura != undefined ? parseInt(p.volumeViatura) : parseInt(p.Volume_viatura)
                                        var SelosSeguranca_viatura = p.selosSegurancaSelagemViatura == undefined ? p.SelosSeguranca_viatura : p.selosSegurancaSelagemViatura; 
                                        var Etiquetas_selagem_viatura = p.etiquetasSegurancaViatura == undefined ? p.Etiquetas_selagem_viatura : p.etiquetasSegurancaViatura; 
                                        var Sinetes_viatura = p.sinetesViatura  != undefined ? p.sinetesViatura : p.Sinetes_viatura;
                                        var idAutoDetalhe = p.IDAutoDetalhe != undefined ? parseInt(p.IDAutoDetalhe) : parseInt(p.IDAutoDetalhe)
                                
                                        var selosSegViatura = []
                                        var EtiquetasSegViatura = []
                                       
                                        Etiquetas_selagem_viatura.map((Etiquetas_selagem_viatura) => (
                                            EtiquetasSegViatura.push(Etiquetas_selagem_viatura.idEtiqueta != undefined ? Etiquetas_selagem_viatura.idEtiqueta : Etiquetas_selagem_viatura)
                                        ));
                                        SelosSeguranca_viatura.map((SelosSeguranca_viatura) => (
                                            selosSegViatura.push(SelosSeguranca_viatura.idSelo != undefined ? SelosSeguranca_viatura.idSelo : SelosSeguranca_viatura)
                                        ));
                                        AutoGridViatura.push({
                                            "Matricula" : Matricula_viatura,
                                            "DocumentoTransporte" : Doc_Transporte_viatura, 
                                            "CertificadoProcedencia": Cert_precedencia_viatura,
                                            "RCDO" : RCDO_viatura,
                                            "VolumeViatura": Volume_viatura,
                                            "SelosSegurancaSelagemViatura": selosSegViatura, 
                                            "EtiquetasSegurancaViatura": EtiquetasSegViatura,
                                            "SinetesViatura": Sinetes_viatura,   
                                            "idAutoDetalhe": idAutoDetalhe 
                                        })
                                    })}
                                    if(x.selosGarantia != undefined){ x.selosGarantia.map ((t) => {
                                        var idTipoSelo = t.idTipoSelo != undefined ? parseInt(t.idTipoSelo) : parseInt(t.TipoSelo.value)
                                        var SerieSelo = t.serieSelo != undefined ? t.serieSelo : t.Serie_selosGarantia.text;
                                        var IDRegistoSelo = t.idRegistoSelo != undefined ? parseInt(t.idRegistoSelo) : parseInt(t.Serie_selosGarantia.value)
                                        var IntervaloSelo = t.intervaloSelo != undefined ? t.intervaloSelo : t.intervalosDisponiveis_selosGarantia.text;
                                        var NumeroSeloInicial = t.numeroSeloInicial != undefined ? t.numeroSeloInicial : t.Nr_Selo_inicial_selosGarantia;
                                        var NumeroSeloFinal = t.numeroSeloFinal != undefined ? t.numeroSeloFinal : t.Nr_Selo_final_selosGarantia ;
                                        var Quantidade_selosGarantia = t.quantidadeSelos != undefined ? parseInt(t.quantidadeSelos) : parseFloat(t.Quantidade_selosGarantia)
                                        var SelosSeguranca = t.selosSegurancaSelagemSelosGarantia == undefined ? t.SelosSeguranca : t.selosSegurancaSelagemSelosGarantia;
                                        var Etiquetas_selagem_selosGarantia = t.etiquetasSegurancaSelosGarantia == undefined ? t.Etiquetas_selagem_selosGarantia : t.etiquetasSegurancaSelosGarantia;
                                        var Sinetes_selosGarantia = t.sinetesSelosGarantia != undefined ? t.sinetesSelosGarantia : t.Sinetes_selosGarantia;
                                        var idAutoDetalhe = t.IDAutoDetalhe != undefined ? parseInt(t.IDAutoDetalhe) : parseInt(t.IDAutoDetalhe)
                                        var selosSegSelosGarant = []
                                        var EtiquetasSegSelosGarant = []
                                       
                                        Etiquetas_selagem_selosGarantia.map((Etiquetas_selagem_selosGarantia) => (
                                            EtiquetasSegSelosGarant.push(Etiquetas_selagem_selosGarantia.idEtiqueta != undefined ? Etiquetas_selagem_selosGarantia.idEtiqueta : Etiquetas_selagem_selosGarantia)
                                        ));
                                        SelosSeguranca.map((SelosSeguranca) => (
                                            selosSegSelosGarant.push(SelosSeguranca.idSelo != undefined ? SelosSeguranca.idSelo : SelosSeguranca)
                                        ));
                                        AutoGridSelosGarantia.push({
                                            "idTipoSelo" : idTipoSelo,
                                            "SerieSelo" : SerieSelo, 
                                            "IDRegistoSelo": IDRegistoSelo,
                                            "IntervaloSelo" : IntervaloSelo,
                                            "NumeroSeloInicial": NumeroSeloInicial,
                                            "NumeroSeloFinal": NumeroSeloFinal, 
                                            "QuantidadeSelos": Quantidade_selosGarantia,
                                            "SelosSegurancaSelagemSelosGarantia": selosSegSelosGarant, 
                                            "EtiquetasSegurancaSelosGarantia": EtiquetasSegSelosGarant,
                                            "SinetesSelosGarantia": Sinetes_selosGarantia,  
                                            "idAutoDetalhe": idAutoDetalhe  
                                        })
                                    })} 
                                    if(x.rotulos != undefined){x.rotulos.map ((m) => {
                                        var tipo_rotulos = m.tipoRotulo != undefined ? m.tipoRotulo : m.tipo_rotulos.text;
                                        var numeroRegisto_rotulos = m.numeroRegisto != undefined ? parseInt(m.numeroRegisto)  : parseInt(m.Registo_rotulos.text)
                                        var correlativa_rotulos = m.correlativa != undefined ? m.correlativa : m.Correlativa_rotulos.text;
                                        var Descricao_rotulos =  m.descricaoRotulo != undefined ? m.descricaoRotulo : m.Descricao_rotulos;
                                        var QuantidadeRotulo = m.quantidadeRotulo != undefined ? parseInt(m.quantidadeRotulo)  : parseInt(m.Quantidade_rotulos)
                                        var SelosSegurancas_rotulos = m.selosSegurancaSelagemRotulos == undefined ? m.SelosSegurancas_rotulos : m.selosSegurancaSelagemRotulos;
                                        var Etiquetas_selagem_rotulos = m.etiquetasSegurancaRotulos == undefined ? m.Etiquetas_selagem_rotulos : m.etiquetasSegurancaRotulos;
                                        var Sinetes_rotulos = m.sinetesRotulos != undefined ? m.sinetesRotulos : m.Sinetes_rotulos;
                                        var idAutoDetalhe = m.IDAutoDetalhe != undefined ? parseInt(m.IDAutoDetalhe)  : parseInt(m.IDAutoDetalhe)
                                        var idRotulo = m.idRotulo != undefined ? parseInt(m.idRotulo)  : parseInt(m.Registo_rotulos.value)
                                        var selosSegRotulos = []
                                        var EtiquetasRotulos= []
                                       
                                        Etiquetas_selagem_rotulos.map((Etiquetas_selagem_rotulos) => (
                                            EtiquetasRotulos.push(Etiquetas_selagem_rotulos.idEtiqueta != undefined ?Etiquetas_selagem_rotulos.idEtiqueta : Etiquetas_selagem_rotulos)
                                        ));
                                        SelosSegurancas_rotulos.map((SelosSegurancas_rotulos) => (
                                            selosSegRotulos.push(SelosSegurancas_rotulos.idSelo != undefined ?SelosSegurancas_rotulos.idSelo : SelosSegurancas_rotulos)
                                        ));
                                        AutoGridRotulos.push({
                                            "TipoRotulo" : tipo_rotulos,
                                            "numeroRegisto" : numeroRegisto_rotulos, 
                                            "correlativa": correlativa_rotulos,
                                            "idRotulo": idRotulo,
                                            "DescricaoRotulo" : Descricao_rotulos,
                                            "QuantidadeRotulo": QuantidadeRotulo,
                                            "SelosSegurancaSelagemRotulos": selosSegRotulos,
                                            "EtiquetasSegurancaRotulos": EtiquetasRotulos,
                                            "SinetesRotulos": Sinetes_rotulos, 
                                            "idAutoDetalhe": idAutoDetalhe
                                        })
                                    })}  
                                });
            
                                var data = {
                                    idAuto : DesselagemQuery == "true" ? "0" : idAuto ,
                                    isConcluir: isConcluir,
                                    idTipoAuto: idTipoAuto,
                                    idInstalacaoVinica: idInstalacaoVinica,
                                    idMotivo: idMotivo,
                                    observacao: observacao,
                                    representante: representante,
                                    representanteEmail: representanteEmail,
                                    depositario: depositario,
                                    assinado: assinado,
                                    fiscais:  fiscais.length == 0 ? FiscaisChosen : fiscais,
                                    autoGridGranel : AutoGridGranel,
                                    autoGridEngarrafado : AutoGridEngarrafado,
                                    autoGridViatura : AutoGridViatura,
                                    autoGridSelosGarantia : AutoGridSelosGarantia,
                                    autoGridRotulos : AutoGridRotulos,
                                    idFiscalPrincipal: idFiscalPrincipal,
                                    edocklink : edocklink ,
                                    numeroPedidoAgendamento : numeroPedidoAgendamento,
                                    idEntidadeProprietario: idEntidadeProprietario,
                                    AutoAssinaturas: AutoAssinaturas,
                                    LoggedUser: window.localStorage.getItem('username'),
                                    
                                    SelagemGranel: SelagemGranel,
                                    SelagemEngarrafado: SelagemEngarrafado,
                                    SelagemViatura: SelagemViatura,
                                    SelagemSelosGarantia: SelagemSelosGarantia,
                                    SelagemRotulos: SelagemRotulos,
                                    
                                   // RepEntidadeDepositario: RepEntidadeDepositario,
                                    EntregaEmMao: EntregaEmMao,
                                    DespejoImediato: DespejoImediato,
                                    Recurso: Recurso,
                                    DespejoControlado: DespejoControlado,
            
                                    idAutoOrigem: idAutoOrigemDesselagem,
                                    dataPedido : DataEmissao,
                                    dataPedidoAE : DataRequisitante,
                                    idEntidade : idEntidadeProprietario,
                                };
                                let res = await services.apiCall.requestApi(
                                    "/Fiscalizacao/SubmeterAuto",
                                    data,
                                    "post"
                                );
                                if (res) {
                                    if(concluido == true){
                                        Swal.fire({
                                            title: 'Deseja emitir receita?',
                                            showDenyButton: true,
                                            showCancelButton: false,
                                            confirmButtonText: 'Sim',
                                            denyButtonText: 'Não',
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                this.redirectScreen2();
                                            } else if (result.isDenied) {
                                                this.redirectScreen();
                                            }
                                        })
                                    }else{
                                        this.redirectScreen();
                                    } 
                                }
                            } else{
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Validar selos de segurança',
                                    text: 'Não pode selecionar o mesmo selo de segurança em vasilhas diferentes',
                                })
                            }
                        }else{
                            Swal.fire({
                                icon: 'error',
                                title: 'Validar etiquetas de segurança',
                                text: 'Não pode selecionar a mesma etiqueta de segurança em vasilhas diferentes',
                            })
                        }
                        
                    }else{
                        Swal.fire({
                            icon: 'error',
                            title: 'Preencher dados na grid',
                            text: 'Preencha os campos em falta e volte a Submeter',
                        }) 
                    }
                    
                    //Vistoria Inicio
                }else if ($("#tipo_auto :selected").val() == "22"){
                    var NomeAEInsc =  $("#NomeDesignacaoAE").val()
                    var NIFAEInsc = $("#NIFAE").val()
                    var NomeAEDet =  $("#NomeDesignacaoAEI").val()
                    var NIFAEDet = $("#NIFAEI").val()
                    var RepresentanteAEDet =  $("#Representante").val()
                    var CargoAEDet = $("#Cargo").val()
                    var IdentificacaoAEDet =  $("#IdentAE :selected").val()
                    var NumIdentificacaoAEDet = $("#NrIdentificacao").val()
                    var DesignacaoInstalacao =  $("#DesignacaoVist").val()
                    var CodPostalInstalacao = String($("#CodPostalVist1").val()) +"-"+ String($("#CodPostalVist2").val())
                    var MoradaInstalacao =  $("#MoradaVist").val()
                    var ProprietarioInstalacao = $("#ProprietarioVist").val()
                    var NIFProprietarioInstalacao =  $("#NifVist").val()
                    var DistritoInstalacao = $("#Distrito :selected").val()
                    var ConcelhoInstalacao =  $("#Concelho :selected").val()
                    var FreguesiaInstalacao = $("#Freguesia :selected").val()
                    var TipoInstalacaoVinificacao =  $('#Vinificacao').is(":checked")
                    var TipoInstalacaoArmazenamento =  $('#Armazenamento').is(":checked")
                    var TipoInstalacaoProdutoAcabado =  $('#ArmProdAcabado').is(":checked")
                    var EngarrafamentoLinhaPropria =  $('#LinhaPropria').is(":checked")
                    var EngarrafamentoLinhaMovel =  $('#LinhaMovel').is(":checked")
                    var EngarrafamentoPrestacaoServicos =  $('#PrestacaoServicos').is(":checked")
                    var CoordenadasInstalacao =  String($('#ProprietarioCoordenadas1').val()) +"°"+ String($('#ProprietarioCoordenadas2').val()) +"'"+ String($('#ProprietarioCoordenadas3').val()) +"''"+ String($('#latNorteSul :selected').val()) +":"+ String($('#ProprietarioCoordenadas4').val()) +"°"+ String($('#ProprietarioCoordenadas5').val()) +"'"+ String($('#ProprietarioCoordenadas6').val()) +"''"+ String($('#longEsteOeste :selected').val())
                    var ReqPlantas =  $('#PlantasInstalacoesSim').is(":checked") == true ? true : $('#PlantasInstalacoesNao').is(":checked") == true ? false : null
                    var ReqDocComprovativo =  $('#PossuiComprovativoLicenciamentoSim').is(":checked") == true ? true: $('#PossuiComprovativoLicenciamentoNao').is(":checked") == true ? false : null
                    var ReqPlantaVerificacao =  $('#ElementosPlantaInstalacoesCorrespondenteVerificadaSim').is(":checked") == true ? true: $('#ElementosPlantaInstalacoesCorrespondenteVerificadaNao').is(":checked") == true ? false : null
                    var ReqRecipientesOrdem =  $('#RecipientesIndicacaoNOrdemSim').is(":checked") == true ? true: $('#RecipientesIndicacaoNOrdemNao').is(":checked") == true ? false : null
                    var ReqRecipientesCapacidade =  $('#RecipientesIndicacaoCapacidadeSim').is(":checked") == true ? true: $('#RecipientesIndicacaoCapacidadeNao').is(":checked") == true ? false : null
                    var ReqRecipientesNatureza =  $('#RecipientesIndicacaoNaturezaSim').is(":checked") == true ? true: $('#RecipientesIndicacaoNaturezaNao').is(":checked") == true ? false : null
                    var ReqRecipientesNivel =  $('#RecipientesIndicacaoNivelControloQuantidadeSim').is(":checked") == true ? true: $('#RecipientesIndicacaoNivelControloQuantidadeNao').is(":checked") == true ? false : null
                    var ReqMaterialInerte =  $('#MaterialContactoInerteSim').is(":checked") == true ? true: $('#MaterialContactoInerteNao').is(":checked") == true ? false : null
                    var ReqCondicoesSeguranca =  $('#InstalacoesBoasCondicoesSim').is(":checked") == true ? true: $('#InstalacoesBoasCondicoesNao').is(":checked") == true ? false : null
                    var ReqIluminacao =  $('#IluminacaoAdequadaProtecaoVidrosSim').is(":checked") == true ? true: $('#IluminacaoAdequadaProtecaoVidrosNao').is(":checked") == true ? false : null
                    var ReqAgua =  $('#AguaAdequadaConsumoHumanoSim').is(":checked") == true ? true: $('#AguaAdequadaConsumoHumanoNao').is(":checked") == true ? false : null
                    var ReqProdutosLimpeza =  $('#ProdutosLimpezaLocaisPropriosSim').is(":checked") == true ? true: $('#ProdutosLimpezaLocaisPropriosNao').is(":checked") == true ? false : null
                    var ReqProdutosEnologicos =  $('#ProdutosEnologicosLocaisPropriosSim').is(":checked") == true ? true: $('#ProdutosEnologicosLocaisPropriosNao').is(":checked") == true ? false : null
                    var ReqRecipientesSolidos =  $('#RecipientesColocacaoResiduosFechadosIdentificadosSim').is(":checked") == true ? true: $('#RecipientesColocacaoResiduosFechadosIdentificadosNao').is(":checked") == true ? false : null
                    var ReqProcessoProdutivo =  $('#ProcessoRastreabilidadeIndicaçãoNLoteSim').is(":checked") == true ? true: $('#ProcessoRastreabilidadeIndicaçãoNLoteNao').is(":checked") == true ? false : null
                    var ReqMeiosExtincao =  $('#MeiosExtincaoIncendiosSim').is(":checked") == true ? true: $('#MeiosExtincaoIncendiosNao').is(":checked") == true ? false : null
                    var ReqPrimeirosSocorros =  $('#MeiosPrimeirosSocorrosSim').is(":checked") == true ? true: $('#MeiosPrimeirosSocorrosNao').is(":checked") == true ? false : null
                    var ReqETAR =  $('#ETARFuncionamentoSim').is(":checked") == true ? true: $('#ETARFuncionamentoNao').is(":checked") == true ? false : null
                    
                    var AreaCoberta = parseFloat($("#AreaCobertaVistoria").val())
                    var ResponsavelTecnico = $("#ApoioTecnicoVistoria").val()
                    var FullTime =  $('#FullTime').is(":checked")
                    var ParecerPositivo =  $('#ParecerCheckSim').is(":checked")
                    var ParecerNegativo =  $('#ParecerCheckNao').is(":checked")
                    var ParecerPositivoCondicionado =  $('#ParecerCheckNA').is(":checked")
                    var ParecerNaoConformidades = $(".Obrs_fisc_parecer").val()
                    var ParecerMelhoriaAte = null;
                    if(ParecerPositivoCondicionado == true){
                        ParecerMelhoriaAte = $("#melhoriaAte").val() == 'dia/mês/ano' ? null : $("#melhoriaAte").val()
                    }else{
                        ParecerMelhoriaAte = null
                    }
                    

                    var data = {
                        idAuto : idAuto ,
                        isConcluir: isConcluir,
                        idTipoAuto: idTipoAuto,
                        idInstalacaoVinica: idInstalacaoVinica,
                        idMotivo: idMotivo,
                        observacao: observacao,
                        representante: representante,
                        representanteEmail: representanteEmail,
                        depositario: depositario,
                        assinado: assinado,
                        fiscais:  fiscais,
                        idFiscalPrincipal: idFiscalPrincipal,
                        edocklink : edocklink ,
                        numeroPedidoAgendamento : numeroPedidoAgendamento,
                        idEntidadeProprietario: idEntidadeProprietario,
                        AutoAssinaturas: AutoAssinaturas,
                        LoggedUser: window.localStorage.getItem('username'),
                        dataPedido : DataEmissao,
                        dataPedidoAE : DataRequisitante,

                        NomeAEInsc: NomeAEInsc,
                        NIFAEInsc: NIFAEInsc,
                        NomeAEDet: NomeAEDet,
                        NIFAEDet : NIFAEDet,
                        RepresentanteAEDet: RepresentanteAEDet,
                        CargoAEDet: CargoAEDet,
                        IdentificacaoAEDet : IdentificacaoAEDet,
                        NumIdentificacaoAEDet : NumIdentificacaoAEDet,
                        DesignacaoInstalacao : DesignacaoInstalacao,
                        CodPostalInstalacao : CodPostalInstalacao,
                        MoradaInstalacao : MoradaInstalacao,
                        ProprietarioInstalacao : ProprietarioInstalacao,
                        NIFProprietarioInstalacao : NIFProprietarioInstalacao,
                        DistritoInstalacao : DistritoInstalacao,
                        ConcelhoInstalacao : ConcelhoInstalacao,
                        FreguesiaInstalacao : FreguesiaInstalacao,
                        TipoInstalacaoVinificacao : TipoInstalacaoVinificacao,
                        TipoInstalacaoArmazenamento : TipoInstalacaoArmazenamento,
                        TipoInstalacaoProdutoAcabado : TipoInstalacaoProdutoAcabado,
                        EngarrafamentoLinhaPropria : EngarrafamentoLinhaPropria,
                        EngarrafamentoPrestacaoServicos : EngarrafamentoPrestacaoServicos,
                        EngarrafamentoLinhaMovel : EngarrafamentoLinhaMovel,
                        CoordenadasInstalacao : CoordenadasInstalacao,
                        ReqPlantas : ReqPlantas,
                        ReqDocComprovativo: ReqDocComprovativo,
                        ReqPlantaVerificacao : ReqPlantaVerificacao,
                        ReqRecipientesOrdem :ReqRecipientesOrdem,
                        ReqRecipientesCapacidade : ReqRecipientesCapacidade,
                        ReqRecipientesNivel : ReqRecipientesNivel,
                        ReqRecipientesNatureza: ReqRecipientesNatureza,
                        ReqMaterialInerte : ReqMaterialInerte,
                        ReqCondicoesSeguranca: ReqCondicoesSeguranca,
                        ReqIluminacao: ReqIluminacao,
                        ReqAgua : ReqAgua,
                        ReqProdutosLimpeza : ReqProdutosLimpeza,
                        ReqProdutosEnologicos : ReqProdutosEnologicos,
                        ReqRecipientesSolidos : ReqRecipientesSolidos,
                        ReqProcessoProdutivo : ReqProcessoProdutivo,
                        ReqMeiosExtincao : ReqMeiosExtincao,
                        ReqPrimeirosSocorros : ReqPrimeirosSocorros,
                        ReqETAR : ReqETAR,
                        AreaCoberta : AreaCoberta,
                        ResponsavelTecnico : ResponsavelTecnico,
                        FullTime : FullTime,
                        ParecerPositivo : ParecerPositivo,
                        ParecerNegativo : ParecerNegativo,
                        ParecerPositivoCondicionado : ParecerPositivoCondicionado,
                        ParecerNaoConformidades : ParecerNaoConformidades,
                        ParecerMelhoriaAte : ParecerMelhoriaAte,
                        idEntidade : idEntidadeProprietario,
                    };
                    let res = await services.apiCall.requestApi(
                        "/Fiscalizacao/SubmeterAuto",
                        data,
                        "post"
                    );
                    
                        if (res) {
                            if(concluido == true){
                                Swal.fire({
                                    title: 'Deseja emitir receita?',
                                    showDenyButton: true,
                                    showCancelButton: false,
                                    confirmButtonText: 'Sim',
                                    denyButtonText: 'Não',
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        this.redirectScreen2();
                                    } else if (result.isDenied) {
                                        this.redirectScreen();
                                    }
                                })
                            }else{
                                this.redirectScreen();
                            } 
                            const datemelh = new Date(Date(ParecerMelhoriaAte))
                            const yearmelh = datemelh.getFullYear();
                            const monthmelh = datemelh.getMonth() + 1;
                            const daymelh = datemelh.getDate();
                            const withSlashesmelh = [daymelh, monthmelh, yearmelh].join('/');
                            $('#melhoriaAte').val(withSlashesmelh)
                        }
                     
                }else{
                    Swal.fire({
                        icon: 'error',
                        title: 'Preencher campos em falta',
                        text: 'Preencha os campos em falta e volte a Submeter',
                    })
                }
            // if(validacaoGrid == true){
            //     console.log(data) 
            //      let res = await services.apiCall.requestApi(
            //         "/Fiscalizacao/SubmeterAuto",
            //         data,
            //         "post"
            //     );
            //     if (res) {
            //         this.redirectScreen();
            //     }
            // }else{ 
            //     Swal.fire({
            //     icon: 'error',
            //     title: 'É obrigatório preencher a grid',
            // })}

            // let res = await services.apiCall.requestApi(
            //     "/Fiscalizacao/SubmeterAuto",
            //     data,
            //     "post"
            // );
            // if (res) {
            //     this.redirectScreen();
            // }
        }

        }catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Erro na submissão',
                text: `Ocorreu um erro ao enviar os dados: ${error.message}`
            });
            console.error("Erro na submissão:", error);
        }
    };

    ActionPerform = () => { };

    columnlist = Object.keys(columnKeyMap).map(function (key) {
        return { field: columnKeyMap[key], columnMenuType: "checkbox" };
    });

    createTabel = (module, data) => {
        console.log("800 in the data ", data);
        console.log("800 in the column list", this.columnlist);

        const columnList = Object.keys(columnKeyMap).map((key) => ({
            field: columnKeyMap[key],
            columnMenuType: "checkbox",
        }))

        if (module === "registo") {
            let telkikTable = (
                <TlkTable
                    notGroup={true}
                    noDownloadButton={true}
                    pageable={false}
                    date={new Date()}
                    notAction={true}
                    forRutoloDetail={true}
                    viewFor={"rotulos"}
                    noFilterShow={true}
                    modulename={"rotulos"}
                    deleteFunc={(id) => this.handleDelete(id)}
                    list={data}
                    columnlist={columnList}
                    ActionPerform={(action, id) =>
                        this.ActionPerform(action, id)
                    }
                />
            );

            this.setState({ telkikTable });
        }
    };

    isRemarkSet = () => {
        this.setState({
            isRemarkSet: true,
        });
    };

    
    handleCloseAssinaturaManuscritoAgente = (e) => { 
       this.setState({openItem : false}) 
       
    } 

    setProgressAgente = (e) =>{
      
        if(this.state.AgenteOutro == true){
            var imageSignature = "<div class='boxAssinaturas'><img src=" + e + " class='imageSignature'/></div>"
            var splitChange = IdButtonClicked.split("AssinaturaButtonTeste")[1]
            $("#Assinatura"+splitChange+"").html(imageSignature)
        } else if(this.state.Represent == true){
            var imageSignatureRepresentante = "<div class='boxAssinaturas'><img src=" + e + " class='imageSignature represAssinatura'/></div>"
            $(".AssinaturaDivRepresentante").html(imageSignatureRepresentante)
        }else if(this.state.FiscalPrincipal == true){
            var imageSignatureFiscPrinc = "<div class='boxAssinaturas'><img src=" + e + " class='imageSignature FiscPrincAssinatura'/></div>"
            $(".AssinaturaDivFiscPrincipal").html(imageSignatureFiscPrinc)
        }else if(this.state.Agente == true){
            var imageSignature = "<div class='boxAssinaturas'><img src=" + e + " class='imageSignature'/></div>"
            $("#Assinatura0").html(imageSignature)
        }  
    }
    
    getBoxesInputs = (e) =>{

        var parsed = queryString.parse(window.location.search);

        var estadoQuery = parsed.codEstado

        if(estadoQuery == null || estadoQuery != '3'){

            inputbutton += 1
            //var btn = $(".AssinaturaTeste")[0]
            var AssinaturaInput = "<div class='Boxselect' style='position: relative'><input placeholder='Nome' type='text' class='NomeEntidadeAssinatura haveValue blockSpecialChar'></input><div id='container'><button style='right: -15px' class='add-plus cursor-pointer ant-tooltip-open assinaturaButton represButton AssinaturaButtonTeste' id='AssinaturaButtonTeste"+ inputbutton +"'><i class='fas fa-file-signature'></i></button></div></div>"
            var IndentificacaoEntidadeDiv = "<div class='input-box active-grey drop-down-box Boxnome'><select class='custome-drop-down IdentificacaoEntidadeAssinatura haveValueSelect' name='IdentificacaoEntidadeAssinatura' ><option value='0'  selected disabled>Selecione a Identificação ...</option><option value='Agente Fiscal do IVDP'>Agente Fiscal do IVDP</option><option value='Transportador/Entidade/Fiel Depositário'>Transportador/Entidade/Fiel Depositário</option></select></div>"
            var assinaturas = "<div class='BoxAssinatura' id='Assinatura"+inputbutton+"'></div>"
            $(".NomeEntidadeDiv").append(AssinaturaInput)
            $(".IndentificacaoEntidadeDiv").append(IndentificacaoEntidadeDiv)
            $(".AssinaturaDiv").append(assinaturas)
            thisAssinatura = this
            
            $(".AssinaturaButtonTeste").off("click").on("click" , function(e){
                IdButtonClicked = e.currentTarget.id
                thisAssinatura.toggleComponent()
            })
        }
        //$('<button onClick='+ {this.toggleComponent} +' className="add-plus cursor-pointer ant-tooltip-open assinaturaButton represButton"><i class="fas fa-file-signature"></i></button>').appendTo('#container');
    }
    
    static toggleComponent2 = () => {
        thisStateData.toggleComponent()
    }
    DeleteBox = (e) =>{

        var parsed = queryString.parse(window.location.search);

        var estadoQuery = parsed.codEstado

        if(estadoQuery == null || estadoQuery != '3'){

            for (let index = 0; index < $(".haveValue").length; index++) {
                var BoxValid = $(".haveValue")[0]
                var BoxValidSelect = $(".haveValueSelect :selected")[0];
                $(".Boxnome")[0].remove();
                $(".Boxselect")[0].remove();
                $(".BoxAssinatura")[0].remove();
            }
            //     if($(BoxValid).val() == "0" || $(BoxValidSelect).val() == "0"){
                    
            // }
        }
    }
    // MakeOnlyText = event => {
    //     const result = event.target.value.replace(/[^a-z]/gi, '');
    
    //     setMessage(result);
    //   };
    componentDidMount() {
        
        
        $(window).scrollTop(0);
        //this.getTituloList();
        let parsed = queryString.parse(window.location.search);
        console.log("parsed in mount", parsed);
        console.log("PROPS: ", this.props);
        this.setState(
            {
                parsed,
                readOnly: parsed.evaluator ? false : true,
                estado: parsed.estado,
            },

            () => {
                if (parsed.idPedidoTransferencia) {
                    this.getEvaluationData(parsed.idPedidoTransferencia);
                }
            }
        );
        

        (async () => {    
            let res = await services.apiCall.requestApi("/allservice/TipoVasilha/GetAll",combolistrequest,"post")
            console.log("Tipores",res)
            this.setState({tipoOptionList:res})

            var strHTML = "<option value='0' selected>Selecione...</option>";
            const data = {}
            const TipoAuto = await services.apiCall.requestApi(
                "/Fiscalizacao/GetTiposAuto",
                data,
                "get"
            );

            for (let index = 0; index < TipoAuto.length; index++) {
                var idTipoAuto = TipoAuto[index].idTipoAuto;
                var descricao = TipoAuto[index].descricao;
            if(idTipoAuto == 15){
                strHTML = strHTML + "<option value='" + idTipoAuto + "' disabled>" + descricao + "</option>";
            }else{
                strHTML = strHTML + "<option value='" + idTipoAuto + "'>" + descricao + "</option>";
            }
                
            }
        

        $("#tipo_auto").html(strHTML);   
            ///// FISCAIS///
            const dataFisc = {}
            var FiscaisArray = []
            const Fiscais = await services.apiCall.requestApi(
               "/Fiscalizacao/GetFiscais",
               dataFisc,
               "get"
            );
            //console.log("Auto e TypeAuto", Family)
            //console.log("FISCAISSSSSSSSSSSSSSSSSSSSSSSSSSSSS" , Fiscais )
            for (let index = 0; index < Fiscais.length; index++) {
              var id = Fiscais[index].id;
              var displayName = Fiscais[index].displayName;
              FiscaisArray.push(<span value={id} key={id} >{displayName}</span>)
            }
            this.setState ({availableOptions : FiscaisArray})
           
            // aqui
            // var strHTML = "<option value='0' selected>Selecione...</option>";
            const dataEntidade = {"filter" : $('#react-select-4-placeholder').val()}
            const EntidadeFiscalizacao = await services.apiCall.requestApi(
               "/Entidades/ViewEntidadesFiscalizacao",
               dataEntidade,
               "get"
            ); 
            EntidadeFiscalizacao.map((entidade) => (
                optionsEntidade.push({value: entidade.codEntidade, label: entidade.nome})
            ));
            this.handleInputChangeEntidade();
            $("#ent_prop_exist_auto").html(strHTML);
            var a = 123;
            $(".ant-select-selection-search-input")[0].placeholder =""
                    ///// DETALHES ////
            // const queryParams = queryString.parse(this.props.location.search)
            // const token = +queryParams1.idAuto

            // const dataToken = {"idAuto": token}
            // const Detalhes1 = await services.apiCall.requestApi(
            //         "/Fiscalizacao/GetAutoOrigens",
            //         dataToken,
            //         "get"
            // );
            // console.log("Detalhe11111111111111", Detalhes1)
                
            // var idAuto = Detalhes1.idAuto;
                
            // $(".autoOrigem :selected").val(idAuto)
            // $(".autoOrigem :selected").text(idAuto)

                  
            const queryParams = queryString.parse(this.props.location.search)
            const token = queryParams.idAuto
            const estado = queryParams.codEstado
            console.log(token ,"QUERY")
                if(this.props.location.search != ""){

                    const dataToken = {"idAuto": token}
                    const Detalhes = await services.apiCall.requestApi(
                        "/Fiscalizacao/GetAutoDetalhe",
                        dataToken,
                        "get"
                    );
                    console.log("DetalhesssssssssssssssMarco", Detalhes)
                    FiscalizacaoClassCreateGrid.componentDidMount(Detalhes)
                    var numeroAuto = Detalhes.numeroAuto;
                    var idTipoAutoDet = Detalhes.idTipoAuto;
                    var idInstalacaoVinica = Detalhes.idInstalacaoVinica;
                    var idMotivo = Detalhes.idMotivo;
                    var distrito = Detalhes.distrito;
                    var concelho = Detalhes.concelho;
                    var freguesia = Detalhes.freguesia;
                    var observacao = Detalhes.observacao;
                    var idEntidade = Detalhes.idEntidade;
                    var representante = Detalhes.representante;
                    var representanteEmail = Detalhes.representanteEmail;
                    var depositario = Detalhes.depositario;
                    var entidade = Detalhes.entidade;
                    var edocklink = Detalhes.edocklink;
                    var numeroPedidoAgendamento = Detalhes.numeroPedidoAgendamento;
                    var fiscalPrincipal = Detalhes.fiscalPrincipal;
                    var IDfiscalPrincipal = Detalhes.idFiscalPrincipal;
                    var autoAssinaturas = Detalhes.autoAssinaturas;
                    var certificadoProcedencia = Detalhes.certificadoProcedencia;
                    var proveniencia = Detalhes.proveniencia;
                    var destinatario = Detalhes.destinatario;
                    var transportador = Detalhes.transportador;
                    var matricula = Detalhes.matricula;
                    var numeroContentores = Detalhes.numeroContentores;
                    var volume = Detalhes.volume;
                    var documentoTransporte = Detalhes.documentoTransporte;
                    var origemDevolucao =  Detalhes.origemDevolucao;
                    var rotulosEmConformidade = Detalhes.rotulosEmConformidade;
                    var dataInicioDespejo = Detalhes.dataInicioDespejo;
                    var dataFimDespejo = Detalhes.dataFimDespejo; 
                    var despejoEntidade = Detalhes.despejoEntidade; 
                    var descricaoAutoBranco = Detalhes.descricaoAutoBranco
                    var selagemGranel = Detalhes.selagemGranel
                    var selagemEngarrafado = Detalhes.selagemEngarrafado
                    var selagemViatura = Detalhes.selagemViatura
                    var selagemSelosGarantia = Detalhes.selagemSelosGarantia
                    var selagemRotulos = Detalhes.selagemRotulos
                    var tituloAutoBranco = Detalhes.tituloAutoBranco
                    var idFatura = Detalhes.idFatura 
                    idAutoOrigemDesselagem = Detalhes.idAutoOrigem
                    if(idFatura != null && idFatura !=""){
                        $("#EmitirReceitaButton").css("display" , "none")
                    }
                    var DataEmissao = Detalhes.dataPedido
                    var DataRequisitante = Detalhes.dataPedidoAE
                    $("#deadlineclender").val(DataEmissao)
                    $("#dataPedido").val(DataRequisitante)

                    this.searchEntidade(entidade);
                    this.handleChangeEntidade(idEntidade)

                    this.setState({defaultValuefiscais : Detalhes.fiscais});

                    if(DesselagemQuery == "true"){
                        $("#tipo_auto option[value='" + 15 + "']").attr("selected","selected");
                    }else{
                        $("#tipo_auto option[value='" + idTipoAutoDet + "']").attr("selected","selected");
                    }

                    if($("#tipo_auto :selected").val() != "15"){
                        var dataFiscais = this.state.availableOptions;

                        DualListSelectorNotSelected = dataFiscais;
                        FiscaisChosen = Detalhes.fiscais
                        $.map( Detalhes.fiscais, function( val, i ) {
    
                            if(dataFiscais.find(c=> c.key == val) != null){
    
                                DualListSelectorSelected.push(dataFiscais.find(c=> c.key == val))
                            
                                DualListSelectorNotSelected = DualListSelectorNotSelected.filter(c=> c.key != val);
                                
                            }
    
                        });
                        // document.getElementById('deadlineclender').valueAsDate = new Date();
                        
                            this.setState({chosenOptions : DualListSelectorSelected});
                        
                        
                        this.setState({availableOptions : DualListSelectorNotSelected});
                        chosenFiscais = DualListSelectorSelected;
                        
                        
                        
                    }
                    
                    this.setState({defaultValueEntidade : idEntidade});

                    
                    // const data = {}
                    // const TipoAuto = await services.apiCall.requestApi(
                    //     "/Fiscalizacao/GetTiposAuto",
                    //     data,
                    //     "get"
                    // );
                    // for (let index = 0; index < TipoAuto.length; index++) {
                    //     var idTipoAuto = TipoAuto[index].idTipoAuto;
                    //     var descricao = TipoAuto[index].descricao;
                    //     strHTML = strHTML + "<option value='" + idTipoAuto + "'>" + descricao + "</option>";
                    // }
                    //$("#tipo_auto").html(strHTML);
                    
                    

                    var strHTML = "<option value='0' selected>Selecione...</option>";
                    const dataInstalacaoVinica = {"CodEntidade" : idEntidade}
                    const InstalacaoVinica = await services.apiCall.requestApi(
                    "/InstalacaoVinica/ViewInstalacoesVinicasEntidade",
                    dataInstalacaoVinica,
                    "get"
                    );

                    InstalacaoVinica.map((InstalacaoVinica) => (
                        strHTML = strHTML + "<option value='" + InstalacaoVinica.idInstalacaoVinica + "!" + InstalacaoVinica.codEntidade +  "'>" + InstalacaoVinica.instalacaoVinica + "</option>"
                    ));
                  
                    
                    
                    if(numeroAuto == 9 ){

                    }else{
                       
                        this.createGrid()
                        this.setState({data: Detalhes.autoGrid}) 
                        this.setState({Detalhes : Detalhes.autoGrid}) 
                    }
                    
                    
                   
                    $("#OrigemDevolucao").val(origemDevolucao)
                    $("#OrigemDevolucao").text(origemDevolucao)
                    $(".k-textbox-container").removeClass("k-state-empty")
                    if(rotulosEmConformidade != undefined){
                        if(rotulosEmConformidade == true){
                            $('#id-label-verified-accordance').prop('checked', true);
                        }else{
                            $('#id-label-verified-not-accordance').prop('checked', true);
                        }
                    }
                    if(despejoEntidade != undefined){
                        if(despejoEntidade == true){
                            $('#id-label-verified-solicited').prop('checked', true);
                        }
                    }
                    
                   
                var indexassinatura = 0;
                if(autoAssinaturas != undefined && $("#tipo_auto :selected").val() != "15"){
                    for (let k = 0; k < autoAssinaturas.length; k++) {
                        var nome = autoAssinaturas[k].nome;
                        var imagem = autoAssinaturas[k].imagem;
                        var identificacao = autoAssinaturas[k].identificacao;
                        if(identificacao == "Fiscal Principal"){
                            var imageSignatureFiscP = "<img src='data:image/png;base64," + imagem +"' class='imageSignature FiscPrincAssinatura'/>"
                            $(".AssinaturaDivFiscPrincipal").append(imageSignatureFiscP)
                        }else if(identificacao == "Representante da Entidade"){
                            var imageSignatureRepres = "<img src='data:image/png;base64," + imagem +"' class='imageSignature represAssinatura'/>"
                            $(".AssinaturaDivRepresentante").append(imageSignatureRepres)
                        }else if(autoAssinaturas.length == 3){
                            $("#IdentificacaoEntidadeAssinatura"+[indexassinatura]+" option[value='" + identificacao + "']").attr("selected","selected");
                            $(".NomeEntidadeAssinatura").val(nome)
                            var imageSignature = "<div class='boxAssinaturas'><img src='data:image/png;base64," + imagem +"' class='imageSignature'/></div>"
                            $(".AssinaturaDiv").append(imageSignature)
                            
                        }else if(autoAssinaturas.length > 3){
                            if(indexassinatura == 0){
                                $("#IdentificacaoEntidadeAssinatura"+[indexassinatura]+" option[value='" + identificacao + "']").attr("selected","selected");
                                $(".NomeEntidadeAssinatura").val(nome)
                                var imageSignature = "<div class='boxAssinaturas'><img src='data:image/png;base64," + imagem +"' class='imageSignature'/></div>"
                                $(".AssinaturaDiv").append('<div id="Assinatura'+indexAssinatura+'">' + imageSignature + '</div>')
                             
                                indexassinatura += 1
                            }else{

                                var imageSignature2 = "<div class='boxAssinaturas'><img src='data:image/png;base64," + imagem +"' class='imageSignature'/></div>"
                                var AssinaturaInput = "<div style='position: relative'><input type='text' placeholder='Nome' class='NomeEntidadeAssinatura' value='"+ nome +"' ></input><div id='container'><button style='right: -15px' class='add-plus cursor-pointer ant-tooltip-open assinaturaButton represButton AssinaturaButtonTeste'><i class='fas fa-file-signature'></i></button></div></div>"
                                var IndentificacaoEntidadeDiv = "<div class='input-box active-grey drop-down-box'><select class='custome-drop-down IdentificacaoEntidadeAssinatura' id='IdentificacaoEntidadeAssinatura" + [k] +"' name='IdentificacaoEntidadeAssinatura' ><option value='0'  selected disabled>Selecione a Identificação ...</option><option value='Representante da Entidade'>Representante da Entidade</option><option value='Agente Fiscal do IVDP'>Agente Fiscal do IVDP</option><option value='Transportador/Entidade/Fiel Depositário'>Transportador/Entidade/Fiel Depositário</option></select></div>"
                                $(".NomeEntidadeDiv").append(AssinaturaInput)
                                $(".AssinaturaDiv").append('<div id="Assinatura'+indexAssinatura+'">' + imageSignature2 + '</div>')
                                $(".IndentificacaoEntidadeDiv").append(IndentificacaoEntidadeDiv)
                                $("#IdentificacaoEntidadeAssinatura"+[indexassinatura]+" option[value='" + identificacao + "']").attr("selected","selected"); 
                                indexassinatura += 1
                            }
                        } 
                    }
                }
               
                this.getMotivos(idMotivo);
                
                this.componentDidUpdate(Detalhes)
                DetalhesGuardados = Detalhes
                   
                    $(".Edocklink_det_auto").val(edocklink)
                    $(".Edocklink_det_auto").text(edocklink)  
                    $(".k-textbox-container").removeClass("k-state-empty")
                    $(".Nr_Pedido_Agendamento_det_auto").val(numeroPedidoAgendamento)
                    $(".Nr_Pedido_Agendamento_det_auto").text(numeroPedidoAgendamento) 
                    $(".k-textbox-container").removeClass("k-state-empty") 
                    if($("#tipo_auto :selected").val() != "15"){
                        $(".Fisc_Princ_fisc").val(fiscalPrincipal)
                        $(".Fisc_Princ_fisc").text(IDfiscalPrincipal)  
                    }
                   
                    $(".k-textbox-container").removeClass("k-state-empty")
                    $("#distrito_det_auto").val(distrito)
                    $("#distrito_det_auto").text(distrito)
                    $("#concelho_det_auto").val(concelho)
                    $("#concelho_det_auto").text(concelho)
                    $("#freguesia_det_auto").val(freguesia)
                    $("#freguesia_det_auto").text(freguesia)
                    $(".Obrs_fisc").val(observacao)
                    $(".Obrs_fisc").text(observacao)  
                    if($("#tipo_auto :selected").val() != "15"){
                        $(".repres_fisc").val(representante)
                        $(".repres_fisc").text(representante)
                        $(".k-textbox-container").removeClass("k-state-empty")
                        $(".email-repr_fisc").val(representanteEmail)
                        $(".email-repr_fisc").text(representanteEmail)
                        $(".k-textbox-container").removeClass("k-state-empty")
                        $(".Dep_fisc").val(depositario)
                        $(".Dep_fisc").text(depositario)
                    }
                    
                    $(".certificado_procedencia").val(certificadoProcedencia)
                    $(".certificado_procedencia").text(certificadoProcedencia)
                    $(".Proveniencia").val(proveniencia)
                    $(".Proveniencia").text(proveniencia)
                    $(".Destinatario").val(destinatario)
                    $(".Destinatario").text(destinatario)
                    $(".Transportador").val(transportador)
                    $(".Transportador").text(transportador)
                    $(".Matrícula").val(matricula)
                    $(".Matrícula").text(matricula)
                    $(".NContentores").val(numeroContentores)
                    $(".NContentores").text(numeroContentores)
                    $(".VolumeL").val(volume)
                    $(".VolumeL").text(volume)
                    $(".DocTransporte").val(documentoTransporte)
                    $(".DocTransporte").text(documentoTransporte)
                    // $(".autoOrigem :selected").val(idAuto)
                    // $(".autoOrigem :selected").text(idAuto)
                    $("#instal_vinica_auto option[value='" + idInstalacaoVinica+ "!" + idEntidade + "']").attr("selected","selected"); 
                    this.handleChangeVinicaAuto()
                    $("#Motivo_fisc option[value='" + idMotivo + "']").attr("selected","selected");
                    $('.botaoAdicionarNovoEnable').removeClass('disabled')
                    if(selagemGranel == true){
                        $("#inlineCheckbox1").prop( "checked", true )
                        $("#inlineCheckbox2").attr( "disabled", true )
                        $("#inlineCheckbox3").attr( "disabled", true )
                        $("#inlineCheckbox4").attr( "disabled", true )
                        $("#inlineCheckbox5").attr( "disabled", true )

                    }
                    if(selagemEngarrafado == true){
                        $("#inlineCheckbox2").prop( "checked", true )
                        $("#inlineCheckbox1").attr( "disabled", true )
                        $("#inlineCheckbox3").attr( "disabled", true )
                        $("#inlineCheckbox4").attr( "disabled", true )
                        $("#inlineCheckbox5").attr( "disabled", true )
                    }
                    if(selagemViatura == true){
                        $("#inlineCheckbox3").prop( "checked", true )
                        $("#inlineCheckbox1").attr( "disabled", true )
                        $("#inlineCheckbox2").attr( "disabled", true )
                        $("#inlineCheckbox4").attr( "disabled", true )
                        $("#inlineCheckbox5").attr( "disabled", true )
                    }
                    if(selagemSelosGarantia == true){
                        $("#inlineCheckbox4").prop( "checked", true )
                        $("#inlineCheckbox7").prop( "checked", true )
                        $("#inlineCheckbox1").attr( "disabled", true )
                        $("#inlineCheckbox2").attr( "disabled", true )
                        $("#inlineCheckbox3").attr( "disabled", true )
                        $("#inlineCheckbox5").attr( "disabled", true )
                    }
                    if(selagemRotulos == true){
                        $("#inlineCheckbox5").prop( "checked", true ) 
                        $("#inlineCheckbox6").prop( "checked", true )
                        $("#inlineCheckbox1").attr( "disabled", true )
                        $("#inlineCheckbox2").attr( "disabled", true )
                        $("#inlineCheckbox3").attr( "disabled", true )
                        $("#inlineCheckbox4").attr( "disabled", true )
                    }
                    $("#auto_de").val(tituloAutoBranco)
                    $("#auto_de").text(tituloAutoBranco)

                    $('#id-div-whiteAuto-textarea').val(descricaoAutoBranco);
                    $('#id-div-whiteAuto-textarea').text(descricaoAutoBranco);

                    $("#nrSequecial").text(numeroAuto)
                    $("#nrSequecial").val(numeroAuto)
                    FiscalizacaoClassCreateGrid.handleChangeAuto17Desc()

                   
                        var NomeAEInsc =  Detalhes.nomeAEInsc;
                        var NIFAEInsc =  Detalhes.nifaeInsc;
                        var NomeAEDet =  Detalhes.nomeAEDet;
                        var NIFAEDet =  Detalhes.nifaeDet;
                        var RepresentanteAEDet =  Detalhes.representanteAEDet;
                        var CargoAEDet =  Detalhes.cargoAEDet;
                        var IdentificacaoAEDet =  Detalhes.identificacaoAEDet;
                        var NumIdentificacaoAEDet =  Detalhes.numIdentificacaoAEDet;
                        var DesignacaoInstalacao =  Detalhes.designacaoInstalacao;
                        var CodPostalInstalacao =  Detalhes.codPostalInstalacao;
                        var MoradaInstalacao =  Detalhes.moradaInstalacao;
                        var ProprietarioInstalacao =  Detalhes.proprietarioInstalacao;
                        var NIFProprietarioInstalacao =  Detalhes.nifProprietarioInstalacao;
                        var DistritoInstalacao =  Detalhes.distritoInstalacao;
                        var ConcelhoInstalacao =  Detalhes.concelhoInstalacao;
                        var FreguesiaInstalacao =  Detalhes.freguesiaInstalacao;
                        var TipoInstalacaoVinificacao =  Detalhes.tipoInstalacaoVinificacao;
                        var TipoInstalacaoArmazenamento =  Detalhes.tipoInstalacaoArmazenamento;
                        var TipoInstalacaoProdutoAcabado =  Detalhes.tipoInstalacaoProdutoAcabado;
                        var EngarrafamentoLinhaPropria =  Detalhes.engarrafamentoLinhaPropria;
                        var EngarrafamentoPrestacaoServicos =  Detalhes.engarrafamentoPrestacaoServicos;
                        var EngarrafamentoLinhaMovel =  Detalhes.engarrafamentoLinhaMovel;
                        var ReqPlantas =  Detalhes.reqPlantas;
                        var ReqDocComprovativo =  Detalhes.reqDocComprovativo;
                        var ReqPlantaVerificacao =  Detalhes.reqPlantaVerificacao;
                        var ReqRecipientesOrdem =  Detalhes.reqRecipientesOrdem;
                        var ReqRecipientesCapacidade =  Detalhes.reqRecipientesCapacidade;
                        var ReqRecipientesNivel =  Detalhes.reqRecipientesNivel;
                        var ReqRecipientesNatureza =  Detalhes.reqRecipientesNatureza;
                        var ReqMaterialInerte =  Detalhes.reqMaterialInerte;
                        var ReqCondicoesSeguranca =  Detalhes.reqCondicoesSeguranca;
                        var ReqIluminacao =  Detalhes.reqIluminacao;
                        var ReqAgua =  Detalhes.reqAgua;
                        var ReqProdutosLimpeza =  Detalhes.reqProdutosLimpeza;
                        var ReqProdutosEnologicos =  Detalhes.reqProdutosEnologicos;
                        var ReqRecipientesSolidos =  Detalhes.reqRecipientesSolidos;
                        var ReqProcessoProdutivo =  Detalhes.reqProcessoProdutivo;
                        var ReqPrimeirosSocorros =  Detalhes.reqPrimeirosSocorros;
                        var ReqETAR =  Detalhes.reqETAR;
                        var AreaCoberta =  Detalhes.areaCoberta;
                        var ResponsavelTecnico =  Detalhes.responsavelTecnico;
                        var FullTime =  Detalhes.fullTime;
                        var ParecerPositivo =  Detalhes.parecerPositivo;
                        var ParecerNegativo =  Detalhes.parecerNegativo;
                        var ParecerPositivoCondicionado =  Detalhes.parecerPositivoCondicionado;
                        var ParecerNaoConformidades =  Detalhes.parecerNaoConformidades;
                        var ParecerMelhoriaAte =  Detalhes.parecerMelhoriaAte;
                        var ReqMeiosExtincao = Detalhes.reqMeiosExtincao;
                        var coordenadasInstalacao = Detalhes.coordenadasInstalacao;
                        const datemelh = new Date(ParecerMelhoriaAte)
                        const yearmelh = datemelh.getFullYear();
                        const monthmelh = datemelh.getMonth() + 1;
                        const daymelh = datemelh.getDate();
                        const withSlashesmelh = [daymelh, monthmelh, yearmelh].join('/');
                        $("#NomeDesignacaoAE").val(NomeAEInsc)
                        $("#NIFAE").val(NIFAEInsc)
                        $("#NomeDesignacaoAEI").val(NomeAEDet)
                        $("#NIFAEI").val(NIFAEDet)
                        $("#Representante").val(RepresentanteAEDet)
                        $("#Cargo").val(CargoAEDet)
                        $("#NomeDesignacaoAE").text(NomeAEInsc)
                        $("#NIFAE").text(NIFAEInsc)
                        $("#NomeDesignacaoAEI").text(NomeAEDet)
                        $("#NIFAEI").text(NIFAEDet)
                        $("#Representante").text(RepresentanteAEDet)
                        $("#Cargo").text(CargoAEDet)
                        $("#IdentAE option[value='" + IdentificacaoAEDet + "']").attr("selected","selected");
                        $("#NrIdentificacao").val(NumIdentificacaoAEDet)
                        $("#DesignacaoVist").val(DesignacaoInstalacao)
                        $("#CodPostalVist1").val(CodPostalInstalacao.slice(0,4))
                        $("#CodPostalVist2").val(CodPostalInstalacao.slice(5,8))
                        
                        $("#MoradaVist").val(MoradaInstalacao)
                        $("#ProprietarioVist").val(ProprietarioInstalacao)
                        $("#NifVist").val(NIFProprietarioInstalacao)

                        $("#NrIdentificacao").text(NumIdentificacaoAEDet)
                        $("#DesignacaoVist").text(DesignacaoInstalacao)
                        $("#CodPostalVist1").text()
                        $("#CodPostalVist2").text()
                        $("#MoradaVist").text(MoradaInstalacao)
                        $("#ProprietarioVist").text(ProprietarioInstalacao)
                        $("#NifVist").text(NIFProprietarioInstalacao)
                        if (TipoInstalacaoVinificacao === true) {$("#Vinificacao").prop( "checked", true )}
                        if(TipoInstalacaoArmazenamento === true){$("#Armazenamento").prop( "checked", true )} 
                        if(TipoInstalacaoProdutoAcabado === true){$("#ArmProdAcabado").prop( "checked", true )} 
                        if(EngarrafamentoLinhaPropria === true){$("#LinhaPropria").prop( "checked", true )}
                        if(EngarrafamentoLinhaMovel === true){$("#LinhaMovel").prop( "checked", true )}
                        if(EngarrafamentoPrestacaoServicos === true){$("#PrestacaoServicos").prop( "checked", true )}
                        //// ver coordenadas
                       
                        //var CoordenadasInstalacao =  String($('#ProprietarioCoordenadas1').val()) + String($('#ProprietarioCoordenadas2').val()) + String($('#ProprietarioCoordenadas3').val()) + String($('#latNorteSul :selected').val()) + String($('#ProprietarioCoordenadas4').val()) + String($('#ProprietarioCoordenadas5').val()) + String($('#ProprietarioCoordenadas6').val()) + String($('#longEsteOeste :selected').val())
                        if(ReqPlantas === true){$("#PlantasInstalacoesSim").prop("checked", true)}else if(ReqPlantas === false){$("#PlantasInstalacoesNao").prop("checked", true)}else{$("#PlantasInstalacoesNA").prop("checked", true)}
                        if(ReqDocComprovativo === true){$("#PossuiComprovativoLicenciamentoSim").prop("checked", true)}else if(ReqDocComprovativo === false){$("#PossuiComprovativoLicenciamentoNao").prop("checked", true)}else{$("#PossuiComprovativoLicenciamentoNA").prop("checked", true)}
                        if(ReqPlantaVerificacao === true){$("#ElementosPlantaInstalacoesCorrespondenteVerificadaSim").prop("checked", true)}else if(ReqPlantaVerificacao === false){$("#ElementosPlantaInstalacoesCorrespondenteVerificadaNao").prop("checked", true)}else{$("#ElementosPlantaInstalacoesCorrespondenteVerificadaNA").prop("checked", true)}
                        if(ReqRecipientesOrdem === true){$("#RecipientesIndicacaoNOrdemSim").prop("checked", true)}else if(ReqRecipientesOrdem === false){$("#RecipientesIndicacaoNOrdemNao").prop("checked", true)}else{$("#RecipientesIndicacaoNOrdemNA").prop("checked", true)}
                        if(ReqRecipientesCapacidade === true){$("#RecipientesIndicacaoCapacidadeSim").prop("checked", true)}else if(ReqRecipientesCapacidade === false){$("#RecipientesIndicacaoCapacidadeNao").prop("checked", true)}else{$("#RecipientesIndicacaoCapacidadeNA").prop("checked", true)}
                        if(ReqRecipientesNatureza === true){$("#RecipientesIndicacaoNaturezaSim").prop("checked", true)}else if(ReqRecipientesNatureza === false){$("#RecipientesIndicacaoNaturezaNao").prop("checked", true)}else{$("#RecipientesIndicacaoNaturezaNA").prop("checked", true)}
                        if(ReqRecipientesNivel === true){$("#RecipientesIndicacaoNivelControloQuantidadeSim").prop("checked", true)}else if(ReqRecipientesNivel === false){$("#RecipientesIndicacaoNivelControloQuantidadeNao").prop("checked", true)}else{$("#RecipientesIndicacaoNivelControloQuantidadeNA").prop("checked", true)}
                        if(ReqMaterialInerte === true){$("#MaterialContactoInerteSim").prop("checked", true)}else if(ReqMaterialInerte === false){$("#MaterialContactoInerteNao").prop("checked", true)}else{$("#MaterialContactoInerteNA").prop("checked", true)}
                        if(ReqCondicoesSeguranca === true){$("#InstalacoesBoasCondicoesSim").prop("checked", true)}else if(ReqCondicoesSeguranca === false){$("#InstalacoesBoasCondicoesNao").prop("checked", true)}else{$("#InstalacoesBoasCondicoesNA").prop("checked", true)}
                        if(ReqIluminacao === true){$("#IluminacaoAdequadaProtecaoVidrosSim").prop("checked", true)}else if(ReqIluminacao === false){$("#IluminacaoAdequadaProtecaoVidrosNao").prop("checked", true)}else{$("#IluminacaoAdequadaProtecaoVidrosNA").prop("checked", true)}
                        if(ReqAgua === true){$("#AguaAdequadaConsumoHumanoSim").prop("checked", true)}else if(ReqAgua === false){$("#AguaAdequadaConsumoHumanoNao").prop("checked", true)}else{$("#AguaAdequadaConsumoHumanoNA").prop("checked", true)}
                        if(ReqProdutosLimpeza === true){$("#ProdutosLimpezaLocaisPropriosSim").prop("checked", true)}else if(ReqProdutosLimpeza === false){$("#ProdutosLimpezaLocaisPropriosNao").prop("checked", true)}else{$("#ProdutosLimpezaLocaisPropriosNA").prop("checked", true)}
                        if(ReqProdutosEnologicos === true){$("#ProdutosEnologicosLocaisPropriosSim").prop("checked", true)}else if(ReqProdutosEnologicos === false){$("#ProdutosEnologicosLocaisPropriosNao").prop("checked", true)}else{$("#ProdutosEnologicosLocaisPropriosNA").prop("checked", true)}
                        if(ReqRecipientesSolidos === true){$("#RecipientesColocacaoResiduosFechadosIdentificadosSim").prop("checked", true)}else if(ReqRecipientesSolidos === false){$("#RecipientesColocacaoResiduosFechadosIdentificadosNao").prop("checked", true)}else{$("#RecipientesColocacaoResiduosFechadosIdentificadosNA").prop("checked", true)}
                        if(ReqProcessoProdutivo === true){$("#ProcessoRastreabilidadeIndicaçãoNLoteSim").prop("checked", true)}else if(ReqProcessoProdutivo === false){$("#ProcessoRastreabilidadeIndicaçãoNLoteNao").prop("checked", true)}else{$("#ProcessoRastreabilidadeIndicaçãoNLoteNA").prop("checked", true)}
                        if(ReqMeiosExtincao === true){$("#MeiosExtincaoIncendiosSim").prop("checked", true)}else if(ReqMeiosExtincao === false){$("#MeiosExtincaoIncendiosNao").prop("checked", true)}else{$("#MeiosExtincaoIncendiosNA").prop("checked", true)}
                        if(ReqPrimeirosSocorros === true){$("#MeiosPrimeirosSocorrosSim").prop("checked", true)}else if(ReqPrimeirosSocorros === false){$("#MeiosPrimeirosSocorrosNao").prop("checked", true)}else{$("#MeiosPrimeirosSocorrosNA").prop("checked", true)}
                        if(ReqETAR === true){$("#ETARFuncionamentoSim").prop("checked", true)}else if(ReqETAR === false){$("#ETARFuncionamentoNao").prop("checked", true)}else{$("#ETARFuncionamentoNA").prop("checked", true)}
                        
                        $("#AreaCobertaVistoria").val(AreaCoberta)
                        $("#ApoioTecnicoVistoria").val(ResponsavelTecnico)
                        $("#AreaCobertaVistoria").text(AreaCoberta)
                        $("#ApoioTecnicoVistoria").text(ResponsavelTecnico)
                        if(FullTime === true) {$("#FullTime").prop( "checked", true )}
                        if(ParecerPositivo === true ){$("#ParecerCheckSim").prop( "checked", true )} 
                        if(ParecerNegativo === true){ $("#ParecerCheckNao").prop( "checked", true )}
                        if(ParecerPositivoCondicionado === true){ $("#ParecerCheckNA").prop( "checked", true )}
                        
                        $(".Obrs_fisc_parecer").val(ParecerNaoConformidades)
                        
                        $(".Obrs_fisc_parecer").text(ParecerNaoConformidades)
                       
                        $(".k-textbox-container").removeClass("k-state-empty")

                        if ($("#tipo_auto :selected").val() == "22"){
                            var Splitval = coordenadasInstalacao.split("°")
                            var Splitval1 = coordenadasInstalacao.split("°")[1].split("'")
                            var Splitval2 = coordenadasInstalacao.split("'")[1].split("''")
                            var Splitval3 = coordenadasInstalacao.split("''")[1].split(":")
                            var Splitval4 = coordenadasInstalacao.split(":")[1].split("°")
                            var Splitval5 = coordenadasInstalacao.split("°")[2].split("'")
                            var Splitval6 = coordenadasInstalacao.split("'")
                            var Splitval7 = coordenadasInstalacao.split("''")[2].split(" ")

                            $("#ProprietarioCoordenadas1").val(Splitval[0])
                            $("#ProprietarioCoordenadas1").text(Splitval[0])
                            $("#ProprietarioCoordenadas2").val(Splitval1[0])
                            $("#ProprietarioCoordenadas2").text(Splitval1[0])
                            $("#ProprietarioCoordenadas3").val(Splitval2[0])
                            $("#ProprietarioCoordenadas3").text(Splitval2[0])
                            $("#latNorteSul option[value='" + Splitval3[0] + "']").attr("selected","selected");
                            $("#ProprietarioCoordenadas4").val(Splitval4[0])
                            $("#ProprietarioCoordenadas4").text(Splitval4[0])
                            $("#ProprietarioCoordenadas5").val(Splitval5[0])
                            $("#ProprietarioCoordenadas5").text(Splitval5[0])
                            $("#ProprietarioCoordenadas6").val(Splitval6[4])
                            $("#ProprietarioCoordenadas6").text(Splitval6[4])
                            $("#longEsteOeste option[value='" + Splitval7[0] + "']").attr("selected","selected");

                            $("#Distrito option[value='" + DistritoInstalacao + "']").attr("selected","selected");
                            $("#Concelho option[value='" + ConcelhoInstalacao + "']").attr("selected","selected");
                            $("#Freguesia option[value='" + FreguesiaInstalacao + "']").attr("selected","selected");
                        }
                        

                        if(estado == "2" && DesselagemQuery != "true"){
                            
                            $("#id-DropDownAutoOrigem").attr("disabled" , true)
                            $(".Edocklink_det_auto").attr("disabled" , true)
                            $(".Nr_Pedido_Agendamento_det_auto").attr("disabled" , true)
                            $(".Fisc_Princ_fisc").attr("disabled" , true)
                            $("#instal_vinica_auto").attr("disabled" , true)
                            $("#distrito_det_auto").attr("disabled" , true)
                            $("#distrito_det_auto").attr("disabled" , true)
                            $("#concelho_det_auto").attr("disabled" , true)
                            $("#freguesia_det_auto").attr("disabled" , true)
                            $(".Obrs_fisc").attr("disabled" , true)
                            $(".repres_fisc").attr("disabled" , true)
                            $(".email-repr_fisc").attr("disabled" , true)
                            $(".Dep_fisc").attr("disabled" , true)
                            $(".certificado_procedencia").attr("disabled" , true)
                            $(".Proveniencia").attr("disabled" , true)
                            $(".Destinatario").attr("disabled" , true)
                            $(".Transportador").attr("disabled" , true)
                            $(".Matrícula").attr("disabled" , true)
                            $(".NContentores").attr("disabled" , true)
                            $(".VolumeL").attr("disabled" , true)
                            $(".DocTransporte").attr("disabled" , true)
                            $("#tipo_auto").attr("disabled" , true)
                            $("#Motivo_fisc").attr("disabled" , true)
                            $(".pf-m-plain").css("display" , "none")
                            $(".ant-select-selector").attr("disabled" , true)
                            $(".ant-select-selection-search").attr("disabled" , true)
                            $(".ant-select-selection-search-input").attr("disabled" , true)
                            $(".ant-select-selection-item").attr("disabled" , true)
                            $(".container").attr("disabled" , true)
                            $(".ant-select-show-search").attr("disabled" , true)
                            $(".botaoAdicionarNovoEnable").css("display" , "none")
                            $("#inlineCheckbox1").attr("disabled" , true)
                            $("#inlineCheckbox2").attr("disabled" , true)
                            $("#inlineCheckbox3").attr("disabled" , true)
                            $("#inlineCheckbox4").attr("disabled" , true)
                            $("#inlineCheckbox5").attr("disabled" , true)
                            $("#id-div-whiteAuto-textarea").attr("disabled" , true)
                            $("#auto_de").attr("disabled" , true)
                            $(".OrigemDevolucao").attr("disabled" , true)
                            $(".custom-control-input").attr("disabled" , true)
                            $(".IdentificacaoEntidadeAssinatura").attr("disabled" , true)
                            $("#Distrito").attr("disabled" , true)
                            $("#Concelho").attr("disabled" , true)
                            $("#Freguesia").attr("disabled" , true)
                            $(".Obrs_fisc_parecer").attr("disabled" , true)
                            $(".melhoriaAte").attr("disabled" , true)
                            $("#id-label-verified-accordance").attr("disabled" , true)
                            $("#id-label-verified-not-accordance").attr("disabled" , true)
                            
                            for (let index = 0; index < $(".IdentificacaoEntidadeAssinatura").length; index++) {
                                var ident = $("#IdentificacaoEntidadeAssinatura" + [index] + "");
                                $(ident).attr("disabled" , true)
                                $(".NomeEntidadeAssinatura").attr("disabled" , true)
                                $(".AssinaturaTeste").css("display" , "none")
                                $(".represButton").css("display" , "none")
                               // $(".btn-sm").css("display" , "none")
                                $(".k-input").attr("disabled" , true)
                            }
                            
                        }
                        if(estado == "2"  && DesselagemQuery == "true" ){
                            $(".botaoAdicionarNovoEnable").css("display", "none")
                            $("#nrSequecial").val("")
                        }
            }

         })();

        $(".blockSpecialChar").on('keyup', function(e) {
            if(/^[a-zA-Z0-9- ]*$/.test(e.originalEvent.key) == false){
                $($(this)[0]).val(this.value.slice(0,-1))
            }else{
                console.log('entrou!! sem caracteres especiais!!!')
            }
        });

        $(".blockSpecialCharEmail").on('keyup', function(e) {
            if(/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(this.value) == false){
                $(this).addClass('focusInputCharEmail');
            }else{
                $(this).removeClass('focusInputCharEmail');
            }
        });
       
            
        
        
    }
    
     /*Para obter detalhes de uma única entidade usando api */

    /////// preenche a drop do tipo de auto ////
    getTipoAuto() {

        (async () => {
           

        })();
    }

    /////// preenche a drop dos motivos ////
    getMotivos(e) {

        (async () => {

            var strHTML = "<option value='0' selected>Selecione...</option>";
            if($("#tipo_auto :selected").val() != "" && $("#tipo_auto :selected").val() != "0"){
                var selecionado = parseInt($("#tipo_auto :selected").val())
                const dataMotivo = {IDTipoAuto: selecionado}
                const Motivo = await services.apiCall.requestApi(
                "/Fiscalizacao/GetMotivos",
                dataMotivo,
                "get"
                );

                var strHTML = "<option value='0' selected>Selecione...</option>";
                for (let index = 0; index < Motivo.length; index++) {
                var idMotivo = Motivo[index].idMotivo;
                var descricao = Motivo[index].descricao;
                strHTML = strHTML + "<option value='" + idMotivo + "'>" + descricao + "</option>";
                }
            }

            $("#Motivo_fisc").html(strHTML)
            if(this.props.location.search != ""){
                $("#Motivo_fisc option[value='" + e + "']").attr("selected","selected");
            }
        })();
    }

    // getFamilia = async () => {
    //     let certProcIVDest = [];
    //     const queryParam = queryString.parse(this.props.location.search);

    //     (async () => {
    //       ;(async () => {
    //         // const filters = {
    //         //   codEntidade: +queryParam.entityId,

    //         // };
    //         console.log("querycenas" , this)
    //         certProcIVDest = await services.apiCall.requestApi("/Fiscalizacao/GetFamiliasAuto", 'get');
    //         console.log("Familia....... " , certProcIVDest)
    //         this.setState({ certProcIVDest })
    //       })()
    //     })()
    // };
    /////// end preenche a drop das familias ////

     componentDidUpdate() { 
        
        // const date4 = new Date()
        // const year4 = date4.getFullYear();
        // const month4 = date4.getMonth() + 1;
        // const day4 = date4.getDate();
        // const withSlashes4 = [day4, month4, year4].join('/');
        // $('.deadlineclender input').val(withSlashes4) 
       
        
        if(DetalhesGuardados != undefined){
            const queryParams = queryString.parse(this.props.location.search)
            const token = +queryParams.idAuto
            const estado = +queryParams.codEstado
            if(DetalhesGuardados.parecerMelhoriaAte != ""){
                const datemelh = new Date(Date(DetalhesGuardados.parecerMelhoriaAte))
                const yearmelh = datemelh.getFullYear();
                const monthmelh = datemelh.getMonth() + 1;
                const daymelh = datemelh.getDate();
                const withSlashesmelh = [daymelh, monthmelh, yearmelh].join('/');
                
                $('#melhoriaAte').val(withSlashesmelh)
                // $('#melhoriaAte input').text(withSlashesmelh)
            }
            if(estado == "2"){
                $(".deadlineclender").attr("disabled" , true)
            }
            if(DetalhesGuardados.dataPedido != ""){
                const date3 = new Date(DetalhesGuardados.dataPedido)
                const year3 = date3.getFullYear();
                const month3 = date3.getMonth() + 1;
                const day3 = date3.getDate();
                const withSlashes3 = [day3, month3, year3].join('/');
                $('#deadlineclender').val(withSlashes3) 
            }
            if(DetalhesGuardados.dataPedidoAE != ""){
                const date4 = new Date(DetalhesGuardados.dataPedidoAE)
                const year4 = date4.getFullYear();
                const month4 = date4.getMonth() + 1;
                const day4 = date4.getDate();
                const withSlashes4 = [day4, month4, year4].join('/');
                $('#dataPedido').val(withSlashes4) 
            }
            
           
           if(DetalhesGuardados.dataInicioDespejo != ""){
            const date = new Date(DetalhesGuardados.dataInicioDespejo)
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const day = date.getDate();
            const withSlashes = [day, month, year].join('/');
            $('.DataInicioDespejo input').val(withSlashes) 
           }
        if(DetalhesGuardados.dataFimDespejo != ""){
            const date2 = new Date(DetalhesGuardados.dataFimDespejo)
            const year2 = date2.getFullYear();
            const month2 = date2.getMonth() + 1;
            const day2 = date2.getDate();
            const withSlashes2 = [day2, month2, year2].join('/');
            $('.DataFimDespejo input').val(withSlashes2) 
        }

            if( DetalhesGuardados.distritoInstalacao != "" && DetalhesGuardados.distritoInstalacao != undefined){
                var DistritoInstalacao =  DetalhesGuardados.distritoInstalacao;
                var ConcelhoInstalacao =  DetalhesGuardados.concelhoInstalacao;
                var FreguesiaInstalacao =  DetalhesGuardados.freguesiaInstalacao;
                $("#Distrito option[value='" + DistritoInstalacao + "']").attr("selected","selected");
              (async () => {
                let busentconcelho = await services.apiCall.requestApi(
                    "/busentconcelho/getbyid/" + ConcelhoInstalacao,
                    {},
                    "post"
                );
                var strHTML = "<option value='0' selected>Selecione...</option>";
                for (let index = 0; index < busentconcelho.length; index++) {
                var codcon = busentconcelho[index].codcon;
                var descricao = busentconcelho[index].descon;
                strHTML = strHTML + "<option value='" + codcon + "'>" + descricao + "</option>";
                }
                    $("#Concelho").html(strHTML)
                    $("#Concelho option[value='" + ConcelhoInstalacao + "']").attr("selected","selected");
                let reqData = {
                    districtId: parseInt(DistritoInstalacao),
                    countryId: parseInt(ConcelhoInstalacao),
                };
                let BusEntFregusia = await services.apiCall.requestApi(
                    "/BusEntFreguesia/GetByID",
                    reqData,
                    "post"
                );    
                var strHTML2 = "<option value='0' selected>Selecione...</option>";
                for (let index = 0; index < BusEntFregusia.length; index++) {
                var codfrg = BusEntFregusia[index].codfrg;
                var desfrg = BusEntFregusia[index].desfrg;
                strHTML2 = strHTML2 + "<option value='" + codfrg + "'>" + desfrg + "</option>";
                }
                $("#Freguesia").html(strHTML2)
                $("#Freguesia option[value='" + FreguesiaInstalacao + "']").attr("selected","selected");
              })()
            }
        }
        
    }

    getEvaluationData = async (id) => {

        let dataRegisto = {
            idPedidoTransferencia: id,
        };
        let resRegisto = await services.apiCall.requestApi(
            "/Rotulos/ViewRotulosTransferenciasDetalhe",
            dataRegisto,
            "get"
        );
        let parsed = queryString.parse(window.location.search);
        var estadoQuery = parsed.estado
        console.log("response data registo", resRegisto);

        let arrayTeste = [];
        arrayTeste.push(resRegisto);
        var obs = resRegisto.observacoes;
            this.setState(
                {
                    registoData: arrayTeste,
                    Estado: estadoQuery,
                    Observacoes: obs
                },
                () => {
                    this.getTableDate(
                        "Processamento",
                        this.state.registoData
                    );
                    this.createTable(
                        "Processamento",
                        this.state.registoData
                    );
                }
            );
    };

    getTableDate = (type, data) => {
        console.log("data 123: ", data)
        if (type === "Processamento") {
            Object.keys(columnKeyMap).map((key) => {
                console.log(key,"key")
                console.log(columnKeyMap[key],"key2")
                 data.map((el) => {
                     console.log(el)
                    if (key === "numeroPedido") {
                        el[columnKeyMap[key]] = el.numeroPedido;
                    }
                    else if (key === "numeroRegistoOrigem") {
                        el[columnKeyMap[key]] = el.numeroRegistoOrigem;
                    }
                    else if (key === "numeroRegistoDestino") {
                        el[columnKeyMap[key]] = el.numeroRegistoDestino;
                    }
                    else if (key === "correlativas") {
                        el[columnKeyMap[key]] = el.correlativas;
                    }
                });
            });
        }
    };

    formatTableData = (data) => {
        console.log("formatTableData: ", data)
        return data.map((_row, index) => {
            Object.keys(_row).map(function (key) {
                if (key === "indiceCalorico") {
                    Object.keys(_row[key]).map((_k) => {
                        _row[Lang.langCheck.langRequest(_k)] = _row[key][_k];
                    });
                } else {
                    _row[Lang.langCheck.langRequest(key)] = _row[key];
                }
            });
        });
    };

    createTable = async (type, data) => {
        const columnlist = Object.keys(columnKeyMap).map(function (key) {
            return { field: columnKeyMap[key], columnMenuType: "checkbox" };
        });

        console.log("columnlist", columnlist);
        console.log("data", data);


        let telkikTable = (
            <TlkTable
                notGroup={true}
                noDownloadButton={true}
                pageable={false}
                date={new Date()}
                notAction={true}
                viewFor="marcas"
                forRutoloDetail={true}
                noFilterShow={true}
                modulename="marcas"
                deleteFunc={(id) => this.handleDelete(id)}
                list={data}
                columnlist={columnlist}
                ActionPerform={(action, id) =>
                    this.ActionPerform(action, id)
                }
            />
        );

        this.setState({ telkikTable });
    }

    returntoFirst = async (obs) => {
        let data = {
            VoltarDoSegundo: true,
            Nprocesso: +this.state.parsed.id,
            Ultimaobservacao: obs,
            NumeroAvaliacao: 2,
            processmentos: {
                Pmentos: [],
            },
        };

        let res = await services.apiCall.requestApi(
            "/SIVDP/evelution_approvel_next_lavel",
            data,
            "post"
        );
        if (res) {
            $("#popup-return").trigger("click");
            let paramoption = {
                name: "1ª avaliação",
                url: "/fiscalizacao",
                tableName: "RotulosOneAvalicao",
            };
            this.props.history.push({
                pathname: "/fiscalizacao",
                state: { paramoption: paramoption },
            });
        }
    };

    handleLibertar = async () => {
        let res = await services.apiCall.requestApi(
            "/SIVDP/libertar",
            { id: +this.state.parsed.id },
            "post"
        );

        if (res) {
            let paramoption = {
                name: "Pendentes",
                url: "/fiscalizacao",
                tableName: "RotulosPendentes",
            };
            this.props.history.push({
                pathname: "/fiscalizacao",
                state: { paramoption: paramoption },
            });
        }
    };

    handleChange = (e, type) => {
        console.log("eleeee", e.target.value);
        let sendData = { ...this.state.sendData };
        if (type === "processoLabel") {
            sendData["processo"] = { ...sendData.processo };
            sendData["processo"][e.target.name] = e.target.checked;
        } else {
            // sendData['processomento'] = {...sendData.processomento}
            sendData[e.target.name] =
                type === "date"
                    ? services.Converter.dateConvert(e.target.value, dateFormat)
                    : e.target.value;
        }

        this.setState({ sendData });
    };

    handleInputChangeEntidade = (e) => {
        
        thisFiscalizacaohandle = this.handleChange;

        $('#id-select-Entidade [data-value]').on('keyup',function(e){
            
            optionsEntidade = [];

            (async () => {   

                // {thisSetStateData({ selectEntidade: undefined })}

                const dataEntidade = {"Nome" : $(this).attr('data-value')}
                const EntidadeFiscalizacao = await services.apiCall.requestApi(
                    "/Entidades/ViewEntidadesFiscalizacao",
                    dataEntidade,
                    "get"
                ); 
                
                if(EntidadeFiscalizacao != null){

                    EntidadeFiscalizacao.map((entidade) => (
                        optionsEntidade.push({value: entidade.codEntidade, label: entidade.nome})
                    ));
                    
                }
                
                {thisFiscalizacaohandle(e)}
                
            })(); 
            
        });

    };

    deselectSelect = (e) => {
        thisSetStateData({ selectEntidade: e.value })
    };

    createGrid = () => {
        if($("#tipo_auto :selected").val() != "6" && $("#tipo_auto :selected").val() != "15"){
            $(".DepositarioField").css("display" , "none")
        }else{
            $(".DepositarioField").css("display" , "block")
        }
        this.getMotivos();
        FiscalizacaoClassCreateGrid.changeColumnsGrid($("#tipo_auto :selected").val());
        var valGetTipoAuto = $("#tipo_auto :selected").val()
        $('#instal_vinica_auto option:selected').prop("selected", false);
        this.setState({ valGetTipoAuto })
        
    }

    handleMotivoChange = (e) => {
        var motivoAuto = e.target.value;
        this.setState({
            motivoAuto
        });

        if((motivoAuto == '36' || motivoAuto == '35' || motivoAuto == '49') && $("#tipo_auto :selected").val() == '6'){
            
            (async () => { 
                var strHTML = "<option value='0' selected>Selecione...</option>";
                const data = {"idEntidade" : parseInt($("#instal_vinica_auto :selected").val().split("!")[1]) , "idMotivo" : parseInt($("#Motivo_fisc :selected").val())}
                const NumerosRequisicao = await services.apiCall.requestApi(
                "/Fiscalizacao/GetNumerosRequisicao",
                data,
                "get"
                );
    
                if(NumerosRequisicao != null && NumerosRequisicao.length>0){
                    NumerosRequisicao.map((NumerosRequisicao) => (
                        strHTML = strHTML + "<option value='" + NumerosRequisicao.idRequisicaoServicos +  "'>" + NumerosRequisicao.numeroRequisicao + "</option>"
                    ));
                }

                $("#NrRequisicao").html(strHTML);
            })();
        }
    }


    handleChangeVinicaAuto = (e) => {
        console.log("ENTROU NA INSTALAÇÃO VINICA")
        if($('#instal_vinica_auto').val() != '0' && $('#instal_vinica_auto').val() != ''){

            DropDownCellTipoVasilha.getAllData();
            
            SelectVinicaAutoActive = true;
            if($("#tipo_auto :selected").val() == "22"){
                var idinstalacao = parseInt($("#instal_vinica_auto :selected").val().split("!")[0])
                this.handleCheckCodIVV();
                (async () => {
                    const dataAtividades = {}
                    const GetAllAtividades = await services.apiCall.requestApi(
                        "InstalacaoVinica/GetAtividades",
                        dataAtividades,
                        "get"
                    );
                    const IVAtividade = {}
                    const GetAtividades = await services.apiCall.requestApi(
                        '/InstalacaoVinica/GetIVA/'+idinstalacao+'',
                        IVAtividade,
                        "get"
                    )
    
                    var atividadesFiltradas = GetAllAtividades.filter(atividade => GetAtividades.includes(atividade.idAtividade));
                    const descricoes = atividadesFiltradas.map(atividade => atividade.descricaoAtividade).join('; ');
                    $("#AtividadesVist").val(descricoes.replaceAll(" " , ""));

                })();
                
            }
            
        }else{

            SelectVinicaAutoActive = false;

        }

        if(SelectVinicaAutoActive && SelectEntidadeActive){
            $('.botaoAdicionarNovoEnable').removeClass('disabled');
        }else{
            $('.botaoAdicionarNovoEnable').addClass('disabled');
        }

        (async () => {          
            var idInstVinica = parseInt($("#instal_vinica_auto :selected").val().split("!")[0])
            const data = {"idInstalacaoVinica" : idInstVinica}
            const Dicofre = await services.apiCall.requestApi(
               "/Fiscalizacao/GetInstalacaoVinicaDICOFRE",
               data,
               "get"
            );
            console.log("ENTROU NA INSTALAÇÃO VINICA" ,idInstVinica , Dicofre)
            if(Dicofre != null){
                var distrito = Dicofre.distrito;
                var concelho = Dicofre.concelho;
                var freguesia = Dicofre.freguesia;
  
              $(".distrito_det_auto").val(distrito)
              $(".concelho_det_auto").val(concelho)
              $(".freguesia_det_auto").val(freguesia)
  
              $(".distrito_det_auto").text(distrito)
              $(".concelho_det_auto").text(concelho)
              $(".freguesia_det_auto").text(freguesia)
            }
           

        })();

    };    

    handleCheckCodIVV= e => {
          (async () => {
            const data = {idInstalacaoVinica : parseInt($('#instal_vinica_auto :selected').val().split("!")[0])}
            const InstalacaoVinicaDetails = await services.apiCall.requestApi(
              "/InstalacaoVinica/GetInstalacaoByIdInstalacao",
                data,
                "get"
            );
            
              if(InstalacaoVinicaDetails){
                $("#DesignacaoVist").val(InstalacaoVinicaDetails.instalacaoVinica);
                $("#CodPostalVist1").val(InstalacaoVinicaDetails.codigoPostal.substr(0, 4));
                var cod2 = InstalacaoVinicaDetails.codigoPostal.substr(4).replace(" ", "");
                $("#CodPostalVist2").val(cod2);
                $("#MoradaVist").val(InstalacaoVinicaDetails.morada);
                $("#ProprietarioVist").val(InstalacaoVinicaDetails.nomeEntidade);
                var coddis = InstalacaoVinicaDetails.dicofre.substr(0,2);
                if(InstalacaoVinicaDetails.dicofre.substr(0,2) < 10){
                  coddis = InstalacaoVinicaDetails.dicofre.substr(0,2).replace("0", "");
                }
                var codcon = InstalacaoVinicaDetails.dicofre.substr(2,2);
                if(InstalacaoVinicaDetails.dicofre.substr(2,2) <  10){
                  codcon = InstalacaoVinicaDetails.dicofre.substr(2,2).replace("0", "");
                }
                var codfrg = InstalacaoVinicaDetails.dicofre.substr(4,4);
                if(InstalacaoVinicaDetails.dicofre.substr(4,4) < 10){
                  codfrg = InstalacaoVinicaDetails.dicofre.substr(4,4).replace("0", "");
                }
                this.setState({
                  coddis, 
                  codcon,
                  codfrg
              })
               
                $("#Distrito option[value='" + coddis + "']").attr("selected", "selected");
                $("#Distrito").trigger('click');
                $("#Concelho option[value='" + codcon + "']").attr("selected", "selected");
                $("#Concelho").trigger('click');
                $("#Freguesia option[value='" + codfrg + "']").attr("selected", "selected");
                $("#NifVist").val(InstalacaoVinicaDetails.nif)
              }
            
          })()
      }

    handleChangeEntidade = (e) => {

        SelectCellEtiquetas.changeValueFromSelect(e)
        SelectCellSelos.changeValueFromSelect(e)
        //SelectCellSelosGarantia.changeValueFromSelect(e)
        SelectCellEtiquetasSelagem.changeValueFromSelect(e)
        SelectCellSelosSelagem.changeValueFromSelect(e)
        EntidadeArray = e;

        localStorage.EntidadeSelected = e;
        
        // changeValueSelect(e);
        if(e){
            SelectEntidadeActive = true;
        }else{
            SelectEntidadeActive = false;
        }
        

        if(SelectVinicaAutoActive && SelectEntidadeActive){
            $('.botaoAdicionarNovoEnable').removeClass('disabled');
        }else{
            $('.botaoAdicionarNovoEnable').addClass('disabled');
        }

        InstalacoesVinicasEntidade = e;

        (async () => { 

            var strHTML = "<option value='0' selected>Selecione...</option>";
            const dataInstalacaoVinica = {"CodEntidade" : InstalacoesVinicasEntidade}
            const InstalacaoVinica = await services.apiCall.requestApi(
            "/InstalacaoVinica/ViewInstalacoesVinicasEntidade",
            dataInstalacaoVinica,
            "get"
            );

            if(InstalacaoVinica != null && InstalacaoVinica.length>0){
                InstalacaoVinica.map((InstalacaoVinica) => (
                    strHTML = strHTML + "<option value='" + InstalacaoVinica.idInstalacaoVinica + "!" + InstalacaoVinica.codEntidade +  "'>" + InstalacaoVinica.instalacaoVinica + "</option>"
                ));
            }

            $("#instal_vinica_auto").html(strHTML);

            var data = {"CodEntidade" : InstalacoesVinicasEntidade}
            var emailEnt = await services.apiCall.requestApi(
            "/Entidades/ViewEntidades",
            data,
            "get"
            );
            if(InstalacaoVinica != null && InstalacaoVinica.length>0){
                emailEnt.map((entidadeEmail) => (
                    entidadeEmail.contactos.map((contact) =>(
                        console.log(contact , contact.codSetor ),
                        contact.codSetor == 0 ? $("#email-inst").val(contact.email) : ""
                    ))
                ));
            }
        })();

        
    }

    handleChangeFilter = (e) => {

        // $('#FiltrosFiscalizacao [name]').on('change', function(){

        //     FiscalizacaoGrid.ClassGrid.removeAllRows();

        //     FiscalizacaoGrid2.ClassGrid2.removeAllRows();

        //     console.log('Change - Filter - ' + this.id);

        // })
        $('#tipo_auto').on('change', function(){

            FiscalizacaoGrid.ClassGrid.removeAllRows();

            FiscalizacaoGrid2.ClassGrid2.removeAllRows();

            console.log('Change - Filter - ' + this.id);

        })
        $('#EntidadeDrop').on('change', function(){

            FiscalizacaoGrid.ClassGrid.removeAllRows();

            FiscalizacaoGrid2.ClassGrid2.removeAllRows();

            console.log('Change - Filter - ' + this.id);

        })
        $('#instal_vinica_auto').on('change', function(){

            FiscalizacaoGrid.ClassGrid.removeAllRows();

            FiscalizacaoGrid2.ClassGrid2.removeAllRows();

            console.log('Change - Filter - ' + this.id);

        })

    }

    searchEntidade = (e) => {
        console.log("hey");
        console.log(e);
        let entidades = []
        const queryParams = queryString.parse(this.props.location.search)
        const token = +queryParams.idAuto

        
        
        if (e == ""){
          return;
        }
    
        const filters = {"Nome" : e , "NIF" : e};
        
        (async () => {
            if(this.props.location.search != ""){
                const filtersPreenchido = {"Nome" : e };
                    entidades = await services.apiCall.requestApi(
                        "/Entidades/ViewEntidadesFiscalizacao",
                        filtersPreenchido,
                        "get"
                    );
            }
            var Validanumero = /^\d+$/.test(e)
            if(Validanumero == false){
                const filters = {
                    "Nome" : e 
                };
                entidades = await services.apiCall.requestApi(
                    "/Entidades/ViewEntidadesFiscalizacao",
                    filters,
                    "get"
                );
            }else{
                const filters = {
                    "NIF" : e,
                };
                entidades = await services.apiCall.requestApi(
                    "/Entidades/ViewEntidadesFiscalizacao",
                    filters,
                    "get"
                );
            }
            
    
            this.setState({ entidades })
         
            if(this.props.location.search != ""){
                const dataToken = {"idAuto": token}
                const Detalhes1 = await services.apiCall.requestApi(
                    "/Fiscalizacao/GetAutoOrigens",
                    dataToken,
                    "get"
                );
                console.log("Detalhe11111111111111", Detalhes1)
                
                var idAuto = Detalhes1.idAuto;
                
                $(".autoOrigem :selected").val(idAuto)
                $(".autoOrigem :selected").text(idAuto)
            }

        })()
    }

    static getDaraGridMethod  = (data) => {
        dadosDaGrid = data
    }

    static openModalSelosGarantia = (field) => {

        otherThis.setState({
          detailPopUp : null
        })
    
        let detailPopUp = (
          <SelosGarantia date={new Date()}/>
        )
    
        otherThis.setState({
            detailPopUp
        })
    
        SelosGarantia.getEntrouPelaGrid(field);
    
    }

    static openInserirvasilha = () => {

        otherThis.setState({
            detailPopUp : null
        })

        let detailPopUp = (
            <Inserirvasilha 
                date={new Date()}
                //VasilhaData={(data)=>this.VasilhaData(data)} 
                IDInstalacaoVinica={($("#instal_vinica_auto :selected").val().split("!")[0])}
                tipoOptionList = {otherThis.state.tipoOptionList}
                DadosVasilha = {dadosDaGrid}
            />
        )
        
        otherThis.setState({
            detailPopUp
        })
       
        Inserirvasilha.getEntrouPelaGrid(dadosDaGrid)
    
    }
    
    // VasilhaData=(data)=>{
    //     this.setState({
    //         VasilhaData: data,
    //     },()=> this.props.getVasilhaData(data))
    // }
    decodeHtml = (html) => {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    };

    render() {
        // console.log("data",this.state.sendData, this.state.resData)
        
        console.log("submetidopor:");
        console.log(this.state);

        thisStateData = this.state;
        thisSetStateData = this.setState;
        var leftNavFields;
        otherThis = this
        $("#tipo_auto").val() == "22" ? leftNavFields = {...InputFieldsAllParecer } : leftNavFields = {...InputFieldsAll }
        
        let parsed = queryString.parse(window.location.search);
        let estadoQuery = parsed.estado;
        let processmentoLabel = this.state.resData.processmentos || {};
        let processoLabel = (this.state.resData && this.state.resData.processo) || {};
        console.log(processoLabel);

        this.handleChangeFilter()

        return (
            <div className="dashboard">
                {estadoQuery != null ?(
                    <>
                    <FormnavBar
                        showReturnButton={
                            this.state.resData.evaluationStatus !== "under_review1"
                        }
                        pendingCases={
                            this.state.resData.evaluationStatus ===
                            "review2_pending" ||
                            this.state.resData.evaluationStatus ===
                            "under_review2" ||
                            this.state.resData.evaluationStatus === "under_review1"
                        }

                        handleLibertar={() => this.handleLibertar()}
                        handleSave={() => this.handleSave()}
                        to={"/" + (this.state.parsed.from || "rotuloss")}
                        handleSubmit={(data, url) => this.handleSubmit(false)}
                        handleConcluir={(data, url) => this.handleConcluir()}
                        returntoFirst={(data) => this.returntoFirst(data)}
                        estado={this.state.resData.estado}
                        numeroAvaliacao={this.state.resData.numeroAvaliacao}
                        parsed={this.state.parsed}
                        type="parcelas"
                        headName="Gestão de Autos"
                        evaluator={
                            this.state.resData.evaluationStatus ===
                            "review2_pending" ||
                            this.state.resData.evaluationStatus ===
                            "under_review2" ||
                            this.state.resData.evaluationStatus === "under_review1"
                        }
                    />
                    </>
                ):(
                    <>
                    <FormnavBar
                        showReturnButton={
                            this.state.resData.evaluationStatus !== "under_review1"
                        }
                        pendingCases={
                            this.state.resData.evaluationStatus ===
                            "review2_pending" ||
                            this.state.resData.evaluationStatus ===
                            "under_review2" ||
                            this.state.resData.evaluationStatus === "under_review1"
                        }

                        handleLibertar={() => this.handleLibertar()}
                        handleSave={() => this.handleSave()}
                        to={"/" + (this.state.parsed.from || "fiscalizacao")}
                        handleSubmit={(data, url) => this.handleSubmit(false)}
                        handleConcluir={(data, url) => this.handleConcluir()}
                        returntoFirst={(data) => this.returntoFirst(data)}
                        estado={this.state.resData.estado}
                        numeroAvaliacao={this.state.resData.numeroAvaliacao}
                        parsed={this.state.parsed}
                        type="parcelas"
                        headName="Gestão de Autos"
                        evaluator={
                            this.state.resData.evaluationStatus ===
                            "review2_pending" ||
                            this.state.resData.evaluationStatus ===
                            "under_review2" ||
                            this.state.resData.evaluationStatus === "under_review1"
                        }
                    />
                    </>
                )}

                <div className="full-container edit-ward">
                    <FormleftNev
                        InputFieldsAll={leftNavFields}
                        navFor="Fiscalizacao"

                    />
              
                    <div className="right-section right-section-processo">
                    {this.state.parsed ? (
                            <div className="row justify-content-start mb-4">
                                <div className="col-lg-2 col-md-2 col-sm-12 pl-1">
                                    <div className="input-box active-grey" style={{paddingLeft:"8px" , paddingRight: "8px"}}>
                                        <label style={{ marginBottom : "0"}}>Nr Auto</label>
                                        <input className="input-1 NrAuto_det_auto" name="NrAuto_det_auto" id="nrSequecial" disabled></input>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-12 pl-1">
                                    <div className="input-box active-grey" style={{paddingLeft:"8px" , paddingRight: "8px"}}>
                                            <label style={{ marginBottom : "0"}}>Gestão Documental</label>
                                            <input className="input-1 Edocklink_det_auto" name="Edocklink_det_auto" id="Edocklink_det_auto"></input>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-12 pl-1">
                                    <div className="input-box active-grey" style={{paddingLeft:"8px" , paddingRight: "8px"}}>
                                        <label style={{ marginBottom : "0"}}>Nº Pedido Agendamento</label>
                                        <input className="input-1 Nr_Pedido_Agendamento_det_auto" name="Nr_Pedido_Agendamento_det_auto" id="Nr_Pedido_Agendamento_det_auto"></input>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-12 pl-1" style={{marginTop:"20px" }}>
                                    <span className="deadlineclenderlable EmissaoReceita">Data de Emissão</span>
                                        <div className="input-box active-grey">
                                            <DatePicker
                                                className="form-control deadlineclender input-1"
                                                size="middle"
                                                placeholder="Data"
                                                label="Data"
                                                name="deadlineclender"
                                                id="deadlineclender"
                                                defaultValue={new Date()}
                                            />   
                                        </div>    
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-12 pl-1 pr-0" style={{marginTop:"20px" }}>
                                    <span className="deadlineclenderlable EmissaoReceita">Data de pedido AE/Requisitante</span>
                                        <div className="input-box active-grey">
                                            <DatePicker
                                                className="form-control deadlineclender input-1"
                                                size="middle"
                                                placeholder="Data"
                                                label="Data de pedido AE/Requisitante "
                                                name="dataPedido"
                                                id="dataPedido"
                                                defaultValue={new Date()}
                                            />   
                                        </div>    
                                </div>
                            </div>
                            ) : (
                                <>

                                </>
                            )}
                        <div className="row top-serch">
                            {this.state.parsed ? (
                                <div
                                    className="bg-white middle p20"
                                    id="FiltrosFiscalizacao"
                                >
                                    <div className="head position-relative mb-4">
                                        <h2>
                                            {Lang.langCheck.langRequest(
                                                "Filtros"
                                            )}
                                        </h2>
                                    </div>
                                        <p className="font-14"></p>

                                        <div className="row">
                                            <div className="col-lg-6 col-md-6 col-sm-12">
                                                <div className="input-box active-grey drop-down-box">
                                                    <label className="input-label" style={{top: "-11px"}}>Tipo de Auto</label>
                                                    <select className="custome-drop-down" name="tipo_auto" id="tipo_auto" onChange={this.createGrid} >
                                                        <option value="">Selecione...</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-12">
                                                <div className="input-box active-grey drop-down-box" >
                                                    <label className="input-label" style={{top: "-11px"}}>Entidade Proprietário Existência</label> 

                                                    <div className="App container" style={{padding:"0px"}}>
                                                        {console.log("ValueEntidaeValueEntidade: " + this.state.defaultValueEntidade)}
                                                        {/* aqui */}
                                                        <Select
                                                            showSearch
                                                            onSearch={(e) => this.searchEntidade(e)}
                                                            optionFilterProp="children"
                                                            placeholder="Selecione a entidade"
                                                            className="mov-Ent-Select DropEntidade"
                                                            defaultValue={this.state.defaultValueEntidade}
                                                            value={this.state.defaultValueEntidade}
                                                            onChange={(e) => this.handleChangeEntidade(e)}
                                                            id="EntidadeDrop"
                                                            style={{ width: "100%"}}>
                                                        
                                                            <Option disabled >Selecione a entidade destino</Option>
                                                            {(this.state.entidades && !!this.state.entidades.length) && this.state.entidades.map((item, index) => (
                                                               <Option key={index} value={item.codEntidade}>{this.decodeHtml(item.nome) + " - " + item.nif}</Option>
                                                            ))}
                                                        </Select>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-12">
                                                <div className="input-box active-grey drop-down-box" style={{marginTop: "12px"}}>
                                                    <label className="input-label" style={{top: "-11px"}}>Instalação Vinica</label>
                                                    <select className="custome-drop-down" name="instal_vinica_auto" id="instal_vinica_auto" onChange={this.handleChangeVinicaAuto} >
                                                        <option value="">Selecione...</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-12">
                                                <div className="input-box active-grey drop-down-box" style={{marginTop: "12px"}}>
                                                    <label className="input-label" style={{top: "-11px", zIndex:"0"}}>Motivo</label>
                                                    <select className="custome-drop-down" name="Motivo_fisc" id="Motivo_fisc" onChange={this.handleMotivoChange}>
                                                        <option value="">Selecione...</option>
                                                    </select>
                                                </div>
                                            </div>
                                            {/* <div className="col-md-6">
                                                <div className="input-box active-grey drop-down-box" style={{marginTop: "12px"}}>
                                                    <label className="input-label" style={{top: "-11px", zIndex:"0"}}>Motivo</label>
                                                    <select className="custome-drop-down" name="autoOrigem" id="autoOrigem">
                                                        <option value="">Selecione...</option>
                                                    </select>
                                                </div>
                                            </div> */}
                                            <div className="col-lg-6 col-md-6 col-sm-12 d-none">
                                                <div className="input-box active-grey drop-down-box" style={{marginTop: "12px"}}>
                                                    <label className="input-label" style={{top: "-11px"}}>Instalação Vinica</label>
                                                    <select className="custome-drop-down" name="instal_vinica2_auto" >
                                                        <option value="">Selecione...</option>
                                                    </select>
                                                </div>
                                            </div>
                                            {/* <div className="col-md-12">
                                                <button className="buttonFiltrosFisc">Aplicar</button>
                                            </div> */}
                                        </div>
                                </div>
                            ) : (
                                <>

                                </>
                            )}
                            {this.state.estado === "Sob Análise" ? (
                                ""
                            ) : (
                                <div
                                    className="bg-white middle p20 position-relative"
                                    id="DetAuto"
                                >
                                    <div className="head position-relative mb-4">
                                        <h2>
                                            {Lang.langCheck.langRequest(
                                                "Detalhes do Auto"
                                            )}
                                        </h2>
                                    </div>
                                    <div className="row mt-2">
                                        {/* <div className="col-2" style={{marginTop: "20px"}}>
                                            <span className="deadlineclenderlable FiscalizacaoData">Ano</span>
                                                <div className="input-box active-grey">
                                                <DatePicker
                                                className="form-control deadlineclender input-1"
                                                size="middle"
                                                placeholder="Ano"
                                                label="Ano"
                                                name="ano_det_auto"

                                                format={"yyyy"}

                                            />

                                            </div>
                                        </div>
                                        <div className="col-2">
                                            <div className="input-box active-grey">
                                                <Input
                                                    style={{ width: "100%" , marginBottom: "5px"}}
                                                    className="input-1"
                                                    name="nAuto_det_auto"
                                                    label="Nº Auto"
                                                    //onChange={(e) => this.handleChange(e, 'parcel')}
                                                />
                                            </div>
                                        </div> */}
                                        
                                        <div className="col-lg-4 col-md-4 col-sm-12">
                                            <div className="input-box active-grey">
                                                <label style={{ marginBottom : "0"}}>Distrito</label>
                                                <input className="input-1 distrito_det_auto" name="distrito_det_auto" id="distrito_det_auto" disabled></input>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-sm-12">
                                            <div className="input-box active-grey">
                                                <label style={{ marginBottom : "0"}}>Concelho</label>
                                                <input className="input-1 concelho_det_auto" name="concelho_det_auto" id="concelho_det_auto" disabled></input>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-sm-12">
                                        <div className="input-box active-grey">
                                                <label style={{ marginBottom : "0"}}>Freguesia</label>
                                                <input className="input-1 freguesia_det_auto" name="freguesia_det_auto" id="freguesia_det_auto" disabled></input>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            )}
                            {this.state.estado === "Sob Análise" ? (
                                ""
                            ) : (
                                <div
                                    className="bg-white middle p20 position-relative"
                                    id="DadosFiscalizacao"
                                >
                                    

                                    <FiscalizacaoClassCreateGrid
                                        date={new Date()}
                                        parsed={this.state.parsed}
                                        changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
                                        linkData={this.state.linkData}
                                        trans_methods={this.state.trans_methods}
                                    /> 
                                               
                                    {/* {columnsGrid = [
                                        <Column field="Tipo_Vasilha" title="Tipo Vasilha" cell={DropDownCellTipoVasilha}/>,
                                        <Column field="N_Vasilha" title="Nº Vasilha" cell={DropDownCellNVasilha}/>,
                                        <Column field="Reg_Depos" title="Reg.Depos." editor="boolean"/>,
                                        <Column field="Tipo_med" title="Tipo med." cell={FiscalizacaoGrid.DropDownCellFiscalizacao}/>,
                                        <Column field="Capacidade_comunicada" title="Capacidade comunicada(L)" cell={NumericCell}/>,
                                        <Column field="Quantidade_aferida" title="Quantidade Aferida (L)" cell={NumericCell}/>,
                                        <Column field="Falta" title="Falta (L)" cell={NumericCell}/>,
                                        <Column field="Produto_NC_GA_IG" title="Produto (NC; GA;IG)" cell={DropDownCellProduto}/>,
                                        <Column field="Registo" title="Registo"/>,
                                        <Column field="N_Garrafas_IVDP" title="Nº Garrafas" cell={NumericCell}/>,
                                        <Column field="Capacidade_IVDP" title="Capacidade" cell={DropDownCellCapacidades}/>,
                                        <Column field="Etiquetas_segurança_IDVP" title="Etiquetas de segurança" cell={SelectCellEtiquetas}/>,
                                        <Column field="Nº Garrafas_AE" title="Nº Garrafas" cell={NumericCell}/>,
                                        <Column field="Capacidade_AE" title="Capacidade" cell={DropDownCellCapacidades}/>,
                                        <Column field="Etiquetas_segurança_AE" title="Etiquetas de segurança" cell={SelectCellEtiquetas}/>,
                                        <Column cell={FiscalizacaoGrid.FiscalizacaoCreateGrid.CommandCell} width="90px" />
                                    ]}

                                    <div className="row">
                                        <div className="col-12" id="id-div-fiscalizacao-grid">
                                            <FiscalizacaoGrid.FiscalizacaoCreateGrid
                                                date={new Date()}
                                                parsed={this.state.parsed}
                                                changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
                                                linkData={this.state.linkData}
                                                trans_methods={this.state.trans_methods}
                                                columnList={columnsGrid}
                                            />
                                        </div>
                                    </div> */}

                                </div>
                            )}
                            {this.state.parsed ? (
                                
                                <div className="bg-white middle p20 d-none" id="ParecerFiscalizacao">

                                    <div className="head position-relative">
                                        <h2>
                                            {Lang.langCheck.langRequest(
                                                "Parecer"
                                            )}
                                        </h2>
                                    </div>
                                    <div className="head position-relative mb-4">
                                        <div className="input-box active-grey" style={{marginTop: "20px"}}>
                                            
                                            <label class="input-label">Não Conformidades</label>
                                            <textarea name="Obrs_fisc_parecer" className="form-control heigh-auto mt-2 Obrs_fisc_parecer" rows="3"></textarea>
                                        </div>
                                    </div>
                                    
                                    <div className="head position-relative mb-4">
                                        <div className="input-box active-grey" style={{marginTop: "20px"}}>
                                            
                                        <label class="input-label">Parecer</label> 
                                    <div className="row mt-1  bg-white ml-0 p20 align-items-center">
                                    
                                        <div className="mb-0 col-lg-2 col-md-2 col-sm-12 switchFiscais">

                                            <div class="custom-switch">
                                                <input type="radio" class="custom-control-input" name="ParecerCheck" id="ParecerCheckSim" value="optionParecerCheckSim" onChange={this.handleMelhoria} disabled/>
                                                <label class="custom-control-label" for="ParecerCheckSim">Positivo</label>
                                            </div>
                                        
                                        </div>
                                                                                                
                                        <div className="mb-0 col-lg-2 col-md-2 col-sm-12 switchFiscais">

                                            <div class="custom-switch">
                                                <input type="radio" class="custom-control-input" name="ParecerCheck" id="ParecerCheckNao" value="optionParecerCheckNao" onChange={this.handleMelhoria} disabled/>
                                                <label class="custom-control-label" for="ParecerCheckNao">Negativo</label>
                                            </div>                                       
                                      
                                    </div>

                                        <div className="mb-0 col-lg-3 col-md-3 col-sm-12 switchFiscais">

                                            <div class="custom-switch">
                                                <input type="radio" class="custom-control-input" name="ParecerCheck" id="ParecerCheckNA" value="optionParecerCheckNA"  onChange={this.handleMelhoria} disabled/>
                                                <label class="custom-control-label" for="ParecerCheckNA">Positivo Condicionado</label>
                                  </div>

                                  </div>

                                  <div className="mb-0 col-lg-4 col-md-4 col-sm-12 switchFiscais d-none" id="MelhoriaReceita">
                                  <span className="deadlineclenderlable EmissaoReceita">Melhoria até:</span>
                                        <div className="input-box active-grey">
                                            <DatePicker
                                                className="form-control deadlineclender input-1"
                                                label="Melhoria até:"
                                                name="melhoriaAte"
                                                id="melhoriaAte"
                                                  
                                            /> 
                                        </div>    
                                  </div>
                            </div>
                                        </div>
                          </div>
                                </div> 
                                   
                                
                            ) : (
                                <>

                                </>
                            )}

                             {this.state.estado === "Sob Análise" ? (
                                ""
                            ) : (
                                <div
                                    className="bg-white middle p20 position-relative"
                                    id="FiscaisAuto"
                                >
                                    <div className="head position-relative mb-4">
                                        <h2>
                                            {Lang.langCheck.langRequest(
                                                "Fiscais"
                                            )}
                                        </h2>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-12">
                                        <DualListSelector
                                            isSearchable
                                            availableOptions={this.state.availableOptions}
                                            chosenOptions={this.state.chosenOptions}
                                            onListChange={this.onListChange}
                                            id="dual-list-selector-basic-search"
                                            filterOption={this.filterOption}
                                            isDisabled ={parsed.codEstado === "3" ? true : false}
                                        />

                                        </div>
                                    </div>
                                </div>
                            )}
                            {this.state.estado === "Sob Análise" ? (
                                ""
                            
                            ) : (
                                <div
                                    className="bg-white middle p20 position-relative"
                                    id="ReconhecimentoFiscalizacao"
                                >
                                    <div className="head position-relative mb-4">
                                        <h2>
                                            {Lang.langCheck.langRequest(
                                                "Reconhecimento"
                                            )}
                                        </h2>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-lg-7 col-md-7 col-sm-12">
                                            <div className="input-box active-grey" style={{marginTop: "20px"}}>
                                                <label className="input-label">Observações</label>
                                                <textarea name="Obrs_fisc" className="form-control heigh-auto mt-2 Obrs_fisc" rows="5"></textarea>
                                            </div>
                                        </div>
                                        <div className="col-lg-5 col-md-5 col-sm-12" >
                                            <div className="input-box active-grey DepositarioField">
                                                <label style={{ marginBottom : "0"}}>Depositário autorizado</label>
                                                <input className="input-1 Dep_fisc blockSpecialChar" name="Dep_fisc" id="Dep_fisc"></input>
                                            
                                            </div>
                                            <div className="input-box active-grey">
                                                <label style={{ marginBottom : "0"}}>E-mail institucional </label>
                                                <input className="input-1 email-inst" name="email-inst" id="email-inst" disabled></input>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="row getSigAgentes" id="getSignature">
                                        <div class="col-lg-3 col-md-3 col-sm-12" style={{paddingTop: "14px"}}>
                                            <p id="TituloAssinatura">Assinaturas Agentes</p>
                                            <button onClick={this.getBoxesInputs}className="add-plus cursor-pointer ant-tooltip-open assinaturaButton represButton AssinaturaTeste">  
                                                    <i className="fas fa-plus" aria-hidden="true"></i>
                                            </button> 
                                            <button onClick={this.DeleteBox} style={{right: "52px"}}className="add-plus cursor-pointer ant-tooltip-open assinaturaButton represButton AssinaturaTeste">  
                                                    <i className="fas fa-minus" aria-hidden="true"></i>
                                            </button> 
                                        </div>
                                        <div  class="col-lg-3 col-md-3 col-sm-12 IndentificacaoEntidadeDiv" >
                                            <div class='input-box active-grey drop-down-box'>
                                                <select class='custome-drop-down IdentificacaoEntidadeAssinatura' name='IdentificacaoEntidadeAssinatura' id="IdentificacaoEntidadeAssinatura0" >
                                                    <option value='0'  selected disabled>Selecione a Identificação ...</option>
                                                    <option value='Agente Fiscal do IVDP'>Agente Fiscal do IVDP</option>
                                                    <option value='Transportador/Entidade/Fiel Depositário'>Transportador/Entidade/Fiel Depositário</option></select>
                                            </div>
                                        </div>
                                        <div  class="col-lg-3 col-md-3 col-sm-12 NomeEntidadeDiv pl-3" >
                                            <input placeholder='Nome' className='NomeEntidadeAssinatura blockSpecialChar' type="text"></input>
                                             <button onClick={this.toggleComponentAgente} className="add-plus cursor-pointer ant-tooltip-open assinaturaButton represButton AssinaturaTeste">  
                                             <i class="fas fa-file-signature"></i>
                                            </button> 
                                        </div>
                                        <div  class="col-lg-3 col-md-3 col-sm-12 AssinaturaDiv" >
                                            <div id="Assinatura0"></div>
                                            
                                        </div>
                                    </div>
                                    {/* <!---- representante ---> */}
                                    <div className="row" id="getSignature">
                                        <div class="col-lg-3 col-md-3 col-sm-12" style={{paddingTop: "14px"}}>
                                            <p id="TituloAssinatura">Assinatura Representante</p>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-12">
                                            <div className="input-box active-grey">
                                                <input  type="text" className="input-1 repres_fisc blockSpecialChar" name="repres_fisc" style={{backgroundColor: "white"}} id="repres_fisc" placeholder="Representante" pattern="[A-Za-z]"></input>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-12 pl-3" >
                                            <div className="input-box active-grey">
                                                <input type="text" className="input-1 email-repr_fisc blockSpecialCharEmail" name="email-repr_fisc" id="email-repr_fisc" style={{backgroundColor: "white"}} placeholder="E-mail Representante"></input>
                                            </div>
                                            <button onClick={this.toggleComponentRepres} className="add-plus cursor-pointer ant-tooltip-open assinaturaButton represButton">  
                                            <i class="fas fa-file-signature"></i>
                                            </button> 
                                        </div>
                                        <div  class="col-lg-3 col-md-3 col-sm-12 AssinaturaDivRepresentante" ></div>
                                    </div>
                                     {/* <!---- Fiscal Principal ---> */}
                                     <div className="row" id="getSignature">
                                        <div class="col-lg-3 col-md-3 col-sm-12" style={{paddingTop: "14px"}}>
                                            <p id="TituloAssinatura">Assinatura Fiscal Principal</p>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <div className="input-box active-grey">
                                                <input className="input-1 Fisc_Princ_fisc" name="Fisc_Princ_fisc" id="Fisc_Princ_fisc" placeholder="Fiscal Principal" disabled style={{backgroundColor: "white"}}></input>
                                            </div>
                                            <button onClick={this.toggleComponentFisc} className="add-plus cursor-pointer ant-tooltip-open assinaturaButton represButton">  
                                            <i class="fas fa-file-signature"></i>
                                            </button> 
                                        </div>
                                        <div  class="col-lg-3 col-md-3 col-sm-12 AssinaturaDivFiscPrincipal" ></div>
                                    </div>
                                    {this.state.openItem ? <AssinaturaManuscritoDialog  open={this.state.openItem}  onClose={this.handleCloseAssinaturaManuscritoAgente} handleProgress={this.setProgressAgente}  /> : null}
                                </div>
                             )}

                        </div>
                    </div>
                    
                </div>
                <div className="modal left-popup" id="left-popup-center">
                    <div className="modal-dialog modal-lg">
                        {this.state.detailPopUp}
                    </div>
                </div>
            </div>
            
        );
    }
}

export default InserirFiscalizacao;
